import { flattenObject } from 'utils/utils';

const messages = {
  CNM_CONNECTION_EXCEPTION: 'No ha sido posible conectar con CNM',
  DEVICE_NOT_FOUND: 'Dispositivo no encontrado',
  GENERAL: {
    SWW: 'Hubo un problema',
    ACTIONS: 'Acciones',
    ACTION: 'Acción',
    ACTIVATE: 'Activar',
    ADD_MULTI_INPUT: 'Añade una entrada',
    ADD: 'Añadir',
    ALL: 'Todo',
    ANY: 'Todos',
    APPEND: 'AGREGAR',
    APPLICATIONS: 'Aplicaciones',
    APPLY: 'Filtrar',
    BACK: 'Atrás',
    BOTH: 'Ambos',
    BROWSE: 'Seleccionar',
    CANCEL: 'Cancelar',
    CASB_RULES: 'Reglas CASB',
    CLEAR_FILTERS: 'Limpiar Filtros',
    CLOSE: 'Cerrar',
    CONFIGURATION: 'Configuración',
    CONFIRM_CONTINUE: '¿Está seguro de que quiere continuar?',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esto?',
    CONFIRM_ERROR: 'La confirmación es incorrecta',
    COPY: 'COPIAR',
    CREATED: 'Creado',
    CTRL_CLICK: 'Ctrl + click para seleccionar múltiples',
    CUSTOM: 'Personalizado',
    DEFAULT: 'Por defecto',
    DELETE_COMPLETELY: 'Eliminar completamente',
    DELETE_SMALL: 'Eliminar',
    DELETE_SUCCESS: 'Eliminado correctamente',
    DELETE: 'ELIMINAR',
    DESCRIPTION_PLACEHOLDER: 'Descripción...',
    DESCRIPTION: 'Descripción',
    DETAILS: 'Detalles',
    DISCARD: 'Descartar',
    DISCARD_SESSION:
      '¿Está seguro? Esto descartará los cambios de otros usuarios',
    DOWNLOAD: 'Descargar',
    DUPLICATED_NAME: 'Nombre ya usado',
    INVALID_NAME: 'El formato del nombre no es válido',
    ERROR_NAME_LENGTH: 'La longitud del nombre no es válida',
    ERROR_NAME_LENGTH_CUSTOM:
      'La longitud del nombre debe ser entre {min_length} y {max_length}',
    DYNAMIC_IP: 'IP dinámica',
    EDIT_OBJECT: 'Editar objeto',
    EDIT_SMALL: 'Editar',
    EDIT: 'EDITAR',
    EMAIL: 'Email',
    ENTER_ADD: 'Añade un uuid y presiona enter para añadir',
    ERROR: 'Error',
    EXPORT: 'Exportar',
    GENERAL: 'General',
    GENERATE: 'Generar',
    GLOBAL_SETTINGS: 'Configuración global',
    HOSTNAME: 'Nombre de host',
    IP: 'Ip',
    ID: 'ID',
    DOMAIN_NAME: 'Nombre de dominio',
    DOMAIN_NAME_PLACEHOLDER: 'video.google.com',
    SEARCH_ENGINE: 'Motor de búsqueda',
    SEARCH_ENGINE_PLACEHOLDER: 'google',
    INFORMATION: 'Información',
    INSTALLING:
      'Instalando configuración en {installation_tasks} dispositivo(s). Compruebe el estado en la lista de dispositivos.',
    INSTANCE: 'Instancia',
    INTERNAL_ERROR: 'Error interno',
    INVALID: 'Inválido',
    INVALID_CONFIRM_PASSWORD: 'La contraseña no coincide',
    INVALID_DNS: 'El DNS no es válido',
    MISSING_DNS: 'Añade un DNS válido',
    INVALID_API_KEY: 'Formato de API Key no válido',
    INVALID_EMAIL: 'Email inválido',
    INVALID_FORMAT_EMAIL: 'Formato de Email no válido',
    INVALID_FIELD: 'Campo inválido',
    INVALID_IP: 'La IP no es válida',
    INVALID_DOMAIN_NAME: 'El nombre de dominio no es válido',
    INVALID_OBJECT_NAME: 'Nombre de objeto inválido',
    INVALID_PASSWORD:
      'La contraseña debe contener al menos una mayuscula y un numero',
    INVALID_PORT: 'El puerto no es válido',
    INVALID_URL: 'Formato de URL no válido',
    LOAD_FILE: 'Cargar archivo',
    LOADING_MORE: 'Cargando...',
    LOADING: 'Cargando',
    LOCKED: 'Bloqueado',
    MAX_NAME_SIZE: 'El nombre debe tener un máximo de 64 caracteres',
    MIN_LENGTH: 'La longitud mínima debería ser {length}',
    NAME_PLACEHOLDER: 'Nombre...',
    NAME: 'Nombre',
    NEXT: 'Siguiente',
    NO_DATA: 'No hay información para mostrar',
    NO_FILE: 'Ningún archivo seleccionado',
    NO: 'No',
    NONE: 'Ninguno/a',
    NOT_IN_USE: 'No usado',
    NOW: 'Ahora',
    OK: 'Ok',
    OPTIONS: 'Opciones',
    OTHERS: 'Otros',
    PENDING: 'Pendiente',
    PLACEHOLDER_SEARCH: 'Buscar...',
    PLACEHOLDER_URL: 'https://www.exaple.com',
    PREVIOUS: 'Anterior',
    PROPERTY: 'Propiedad',
    REFRESH: 'Actualizar',
    REQUIRED_FIELD: 'Campo requerido',
    ONE_REQUIRED_FIELD: 'Uno de estos campos es requerido',
    MAX_ELEMENTS_REACHED:
      'Se ha alcanzado el número máximo de elementos. Contacte con Teldat para más información',
    RESET: 'REINICIAR',
    RESTORING:
      'Restaurando la última configuración en {installation_tasks} dispositivo(s). Compruebe el estado en la lista de dispositivos.',
    RETURN: 'Volver',
    SAVE_SMALL: 'Guardar',
    SAVE_SUCCESS: 'Guardado correctamente',
    PARTIAL_SAVE_FAILURE: '{failed} de {total} operaciones fallaron — revisa los cambios e intenta Guardar de nuevo',
    SAVE: 'GUARDAR',
    SEARCH: 'Buscar',
    SELECT_FILE: 'Seleccionar archivo',
    SELECT_ALL: 'Seleccionar todo',
    SELECT: '-- Seleccione una opción --',
    SHOW_MORE: '+{count} más',
    SHOW_LESS: 'Ver menos',
    SPECIFY: 'Específico',
    STATIC_IP: 'IP estática',
    STATUS: 'Estado',
    SUCCESS: 'Correcto',
    SUPPORT: 'Contacta soporte',
    TENANTS: 'Clientes',
    TIME: 'Tiempo',
    TOTAL: 'TOTAL',
    TOTAL_SELECTED: 'Total seleccionados',
    UNKNOWN: 'Desconocido',
    UPDATE_SUCCESS: 'Actualizado correctamente',
    UPDATE: 'ACTUALIZAR',
    UPLOAD: 'Cargar',
    UPDATED: 'ACTUALIZADO',
    WARNING: 'Advertencia',
    WHERE_USED: 'Donde se usa',
    WRONG_FILE_FORMAT: 'El formato del archivo es incorrecto',
    YES: 'Sí',
    DATA: 'Dato',
    INVALID_UUID: 'UUID inválido',
    DUPLICATED_UUID: 'UUID duplicado',
    COMMENTS: 'Comentarios',
    DUPLICATED_INTERFACE_NAME: 'Nombre de interfaz ya usado',
    FOUND_ERRORS: 'Errores encontrados',
    NEXT_ERROR: 'Siguiente error',
    PREVIOUS_ERROR: 'Error anterior',
    USERNAME: 'Nombre de usuario',
    PASSWORD: 'Contraseña',
    PASSWORD_CONFIRMATION: 'Repite la contraseña',
    MINUTES: 'Minutos',
    HOURS: 'Horas',
  },
  GRAPH: {
    INVALID_FIELD: 'Campo de gráfico no válido',
  },
  SIDEBAR: {
    HOME: 'Inicio',
    ANALYTIC: 'Analítica',
    DASHBOARD: 'Dashboard',
    ADMINISTRATION: 'Administración',
    DEVICES: 'Dispositivos',
    DEVICE: 'Dispositivo',
    INSTANCE_CONFIGURATION: 'Instance Configuration',
    CONFIGURATION: 'Configuración',
    REPORTS: 'Informes',
    LOGS: 'Logs de seguridad',
    REPORT_TEMPLATES: 'Plantillas de informes',
    LOGS_REPORTS: 'Log & Informes',
    SCHEDULE: 'Programación',
    XDR: 'XDR',
    NO_TITLE: 'Sin título',
    USER_LOGINS: 'Logins de usuario',
    SESSION_LOGS: 'Logs de tráfico',
    AGENTLESS: 'ZTNA Agentless',
  },
  AGENTLESS: {
    USER: 'Usuario',
    LOGIN_TIME: 'Inicio de sesión',
    LOGOUT_TIME: 'Cierre de sesión',
    APP: 'Aplicación(es)',
    PROTOCOL: 'Protocolo',
    DURATION: 'Duración',
    RECORDING: 'Grabación',
    ACTIVE: 'Activa',
    PLAYER_TITLE: 'Reproducción de sesión',
    PLAYER_ERROR: 'No se pudo cargar la grabación desde el gateway.',
    FEATURE_DISABLED: 'ZTNA Agentless no está disponible para esta cuenta',
    GATEWAY_NOT_CONFIGURED:
      'El portal que grabó esta sesión no está configurado para servir grabaciones',
    NO_RECORDING: 'Esta sesión de aplicación no tiene grabación',
    FETCH_ERROR: 'No se pudieron cargar las sesiones agentless',
    RECORDING_URL_ERROR: 'No se pudo abrir la grabación',
    RECORDING_EXPIRED: 'Esta grabación supera el periodo de retención y se ha eliminado',
  },
  NAVBAR: {
    LOGOUT: 'Cerrar sesión',
    CHANGES: 'Cambios',
    VIEW_CHANGES: 'Ver cambios',
    OBJECT_EXPLORER: 'Explorador de objetos',
    INSTALL_CONFIGURATION: 'Instalar configuración',
    INSTALLING: 'Instalando...',
    SUCCESS_INSTALL_CONFIGURATION: 'Configuración instalada correctamente',
    ERROR_INSTALL_CONFIGURATION: 'Error al instalar la configuración',
    WAIT_INSTALL_CONFIGURATION:
      'Espera hasta que termine la instalación en curso',
    DISCARD_CHANGES: 'Descartar los cambios',
    SUCCESS_DISCARD_CHANGES: 'Cambios descartados correctamente',
    CONFIRM_DISCARD_CHANGES:
      '¿Está seguro que desea descartar los cambios pendientes?',
    PROFILE: 'Perfil',
    API_KEY: 'API KEY',
    NOTIFICATIONS: 'Notificaciones',
    VIEW_NOTIFICATIONS: 'Ver notificaciones',
    MANUAL: 'Manual',
    API_DOCS: 'API Docs',
  },
  ADMIN_USERS: {
    ACTIONS: 'Acciones',
    ADD_TENANT: 'Añadir cliente',
    ADD_USER_ERROR: 'Error al crear usuario',
    ADD_USER_SUCCESS: 'Usuario añadido correctamente',
    ADD_USER: 'Añadir administrador',
    ADMINISTRATORS: 'Administradores',
    AZURE: 'Azure AD',
    AZURE_AD_SUCCESS_CREDENTIALS: 'Configuración correcta',
    AZURE_AD_SYNC_USER_GROUPS: 'Sincronizar grupos de usuarios de Azure AD',
    AZURE_AD_SUCCESS_SYNC: 'Sincronización correcta',
    AZURE_AD_SYNC_ERROR: 'Error al sincronizar Azure AD',
    AZURE_AD_INVALID_CREDENTIALS:
      'Credenciales no válidas. Revise sus datos de conexión',
    BE_ACTIVE: 'Be Active',
    BE_ACTIVE_ALIAS: 'Alias',
    BE_ACTIVE_CONFIGS: 'Configuraciones Be Active',
    BE_ACTIVE_CONFIG_SAVE_SUCCESS: 'Configuración Be Active guardada con éxito',
    BE_ACTIVE_CONFIG_ERROR: 'Error al guardar la configuración Be Active',
    BE_ACTIVE_CONFIG_EDIT_SUCCESS:
      'Configuración Be Active actualizada con éxito',
    BE_ACTIVE_DELETE_CONFIG_SUCCESS:
      'Configuración Be Active eliminada con éxito',
    BE_ACTIVE_DUPLICATE_URL_USER: 'Usuario ya existe con esa URL',
    BE_ACTIVE_EDIT: 'Editar configuración Be Active',
    BE_ACTIVE_INVALID_CREDENTIALS:
      'Credenciales no válidas. Revise sus datos de conexión',
    BE_ACTIVE_NEW: 'Nueva configuración Be Active',
    BE_ACTIVE_PASSWORD: 'Contraseña',
    BE_ACTIVE_SECRET_KEY: 'Clave Secreta',
    BE_ACTIVE_SUCCESS_CREDENTIALS: 'Credenciales válidas',
    BE_ACTIVE_SUCCESS_SYNC: 'Sincronización correcta',
    BE_ACTIVE_SYNC_ERROR: 'Error al sincronizar',
    BE_ACTIVE_TEST_CONNECTION: 'Probar conexión',
    BE_ACTIVE_TIME_SYNC_INFO_INVALID:
      'El tiempo de sincronización no es válido',
    BE_ACTIVE_TIME_SYNC_INFO: 'Rango de 1 a 180 minutos',
    BE_ACTIVE_TIME_SYNC: 'Tiempo de sincronización',
    TIME_SYNC_INFO: 'Intervalo de sincronización: 1-60 minutos o 1-3 horas',
    TIME_SYNC_MINUTES_ERROR: 'Los minutos deben estar entre 1 y 60',
    TIME_SYNC_HOURS_ERROR: 'Las horas deben estar entre 1 y 3',
    BE_ACTIVE_URL_ERROR: 'URL no válida',
    BE_ACTIVE_URL_PLACEHOLDER: 'https://beactive.com',
    BE_ACTIVE_URL_REQUIRED: 'URL requerida',
    BE_ACTIVE_URL: 'URL',
    BE_ACTIVE_USER: 'Usuario',
    BE_ACTIVE_SYNC_USERS: 'Sincronizar usuarios',
    CONFIRM_DELETE_TENANT: '¿Está seguro de que quiere eliminar el cliente?',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar el usuario?',
    CONFIRM_ERROR: 'La confirmación es incorrecta',
    CONNECTION_SETTINGS: 'Ajustes de conexión',
    DELETE_SUCCESS: 'Usuario eliminado correctamente',
    DESCRIPTION: 'Usuarios',
    EDIT_TENANT: 'Editar cliente',
    EMAIL_PLACEHOLDER: 'nombre@empresa.com',
    EMAIL: 'Email',
    FIRST_NAME: 'Nombre',
    INACTIVE_TIME: 'Tiempo máximo inactivo (entre 2 y 60 minutos)',
    LAST_NAME_PLACEHOLDER: 'Moreno Martín',
    LAST_NAME: 'Apellido',
    LOAD_ERROR: 'Error al cargar Usuarios',
    LOG_AS_OWN_RESELLER: 'No puedes suplantar a administradores de tu propio reseller',
    NAME_PLACEHOLDER: 'Antonio',
    NEW_USER: 'Añadir usuarios',
    PASSWORD_PLACEHOLDER: 'Welcome123$',
    PASSWORD: 'Contraseña',
    PROTECTED: 'Protegido',
    RECEIVE_MAILS: 'Recibir mails',
    REPEAT_PASSWORD: 'Repetir Contraseña',
    SERVER_CONNECTIONS: 'Conexiones de servidor',
    TENANT_ID: 'ID del cliente',
    TENANT_NAME: 'Nombre del cliente',
    TENANT_TYPE: 'Tipo del cliente',
    TYPE: 'Rol',
    USER: 'Usuario',
    WRONG_INACTIVE_TIME:
      'El máximo tiempo inactivo debe estar entre {min} y {max} minutos',
    AZURE_AD_CONFIG: 'Configuración Azure AD',
    AD_TENANT_NAME: 'Nombre del Tenant AD',
    AD_TENANT_ID: 'ID del Tenant AD',
    AD_CLIENT_ID: 'ID del Cliente AD',
    AD_CLIENT_SECRET: 'Código secreto del Client AD',
    ENTRA_APP_REGISTRATION: 'Registro de aplicación de Entra',
    ENTRA_APP_REGISTRATION_HELP: 'Un registro de aplicación sirve para importar usuarios y grupos y para el inicio de sesión del portal ZTNA. En el centro de administración de Microsoft Entra:',
    ENTRA_CHECK_APP_PERMISSIONS: 'Permisos de API: permisos de aplicación de Microsoft Graph User.Read.All y GroupMember.Read.All',
    ENTRA_CHECK_ADMIN_CONSENT: 'Conceda el consentimiento de administrador para esos permisos',
    ENTRA_CHECK_DELEGATED: 'Para el inicio de sesión del portal: permisos delegados de Microsoft Graph openid, profile y email',
    ENTRA_CHECK_REDIRECT_URI: 'Para el inicio de sesión del portal: Autenticación > Agregar una plataforma > Web, con el URI de redirección de abajo',
    ENTRA_CHECK_SECRET: 'Certificados y secretos: un secreto de cliente, introducido arriba (Valor, no ID del secreto)',
    ENTRA_CHECK_GROUP: 'Solo se importan miembros de un grupo de Entra: ponga a los usuarios del portal en un grupo',
    AD_KEEP_STORED_VALUE: 'Déjelo en blanco para mantener el valor guardado',
    ADD_AZURE_AD_CONFIG: 'Añadir Configuración Azure AD',
    EDIT_AZURE_AD_CONFIG: 'Editar Configuración Azure AD',
    AD_CONFIG_SAVE_SUCCESS: 'Configuración Azure AD guardada con éxito',
    AD_CONFIG_EDIT_SUCCESS:
      'Configuración Azure AD Configuration actualizada con éxito',
    DELETE_AD_CONFIG: '¿Está seguro de que quiere eliminar esta configuración?',
    DELETE_AD_CONFIG_SUCCESS: 'Configuración Azure AD eliminada con éxito',
    AGENT_CONFIG_PULL_INTERVAL:
      'Configuración intervalo Pull del Cliente VPN (minutos)',
    WRONG_MIN_CONFIG_INTERVAL:
      'El intervalo del Agente debe ser mayor o igual que 1',
    WRONG_MAX_CONFIG_INTERVAL:
      'El intervalo del Agente debe ser menor o igual que 99',
    WINDOWS_BUILD_CONFIRM:
      '¿Está seguro de que quiere construir el ejecutable de Windows?',
    WINDOWS_EXE_EMAIL_SUCCESS: 'Email enviado con éxito',
    WINDOWS_EXE_DOWNLOAD_SUCCESS: 'Ejecutable de Windows descargado con éxito',
    SUCCESS_BUILD:
      'Build iniciado satisfactoriamente. El ejecutable estará disponible en unos minutos. Por favor, espera a que el proceso se complete.',
    BUILD_STATUS:
      'Un build está actualmente en progreso. Por favor, intenta la creación en masa después de 5 minutos.',
    PAGE_RELOAD:
      'Por favor, recarga o refresca la alerta para aplicar los cambios',
    CONFIRM_LOG_AS_USER:
      '¿Está seguro de que quiere iniciar sesión como este usuario?',
    ERROR_LOG_AS_USER: 'Error al iniciar sesión como usuario',
    ERROR_NO_USER: 'No se encontró el usuario',
    ERROR_NOT_ALLOWED:
      'Este usuario no tiene permisos para iniciar sesión con otro usuario',
    ERROR_SAME_USER: 'No puedes iniciar sesión como el mismo usuario',
    ERROR_NOT_IMPERSONATING: 'No estás suplantando a ningún usuario',
    IMPERSONATION_BANNER: 'Suplantando a {user}',
    EXIT_IMPERSONATION: 'Salir',
    RESELLER_TENANT_SELECT: 'Seleccionar cliente',
    RESELLER_TENANT_IN_USE:
      'Al menos uno de los clientes ya se encuentra en uso',
    TENANT_HAS_RESELLER: 'tiene integrador',
    SYNC_USERS_CONFIRM_TITLE: 'Sincronizar usuarios',
    SYNC_GROUPS_TITLE: 'Seleccionar grupos de Azure',
    SYNC_GROUPS_DESCRIPTION:
      '¿Deseas sincronizar los usuarios de {count} grupo(s) seleccionado(s)?',
    SYNC_GROUPS_NO_SELECTION: 'Debes seleccionar al menos un grupo',
    SYNC_GROUPS_LOADING: 'Cargando grupos...',
    SYNC_GROUPS_SUCCESS: 'Usuarios sincronizados correctamente',
    SYNC_GROUPS_ERROR: 'Error al sincronizar usuarios',
    SYNC_GROUPS_FETCH_ERROR: 'Error al cargar los grupos de Azure',
    SYNC_USERS: 'Sincronizar',
    CANCEL: 'Cancelar',
  },
  ADMIN_IP_WHITELISTS: {
    IP_WHITELISTS: 'Lista blanca IPs',
    NAME: 'Nombre',
    ROLE: 'Rol',
    ORIGIN: 'Origen',
    ERROR_FETCH: 'Error obteniendo lista blanca',
    SUCCESS_DELETE: 'Registro eliminado con éxito',
    ERROR_DELETE: 'Error al eliminar registro',
    SUCCESS_CREATE: 'Registro creado con éxito',
    ERROR_CREATE: 'Error al crear registro',
    SUCCESS_UPDATE: 'Registro actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar registro',
    EDIT_IP_WHITELIST: 'Editar lista blanca',
    ADD_IP_WHITELIST: 'Crear lista blanca',
    INVALID_WHITELIST: 'Datos de lista blanca inválidos',
    ERROR_INDEX: 'Error al obtener datos',
    ACCOUNT: 'Tenant',
    ORIGIN_HELP: '* para cualquiera o lista de IPv4s separadas por ;',
  },
  RESELLER_ACCOUNT: {
    DETELE_DEVICES_ERROR:
      'No se pueden eliminar distribuidores con dispositivos Cloud',
  },
  ADMINISTRATION: {
    PERFORMANCE_MODE: 'Modo rendimiento',
    PERFORMANCE_MODE_HINT:
      'El modo rendimiento instala un pack específico de reglas de Suricata. Actívalo o desactívalo en la página de configuración del cliente.',
    TUNNEL_SETTINGS: 'CONFIGURACIÓN DE TÚNEL',
    TUNNEL_INTERFACE_MODE: 'Modo interfaz de túnel',
    SASE_SETTINGS: 'CONFIGURACIÓN SASE',
    PERFORMANCE_SETTINGS: 'CONFIGURACIÓN RENDIMIENTO',
    PERFORMANCE_WARNING: 'Está por cambiar el modo de rendimiento',
    AUDIT: 'Auditoría',
    AUDIT_LOG_AS: '{impersonator} como {user}',
    TITLE: 'Prevención de amenazas',
    PROFILE_PROTECTION: 'Perfil de protección',
    TECHNOLOGIES: 'Tecnologías',
    SECURITY_PROTECTION:
      'Seguridad optimizada para los usuarios. Evita los ciberataques. Incluye protección para usuarios que navegan por la web, trabajan con aplicaciones de escritorio, acceden a aplicaciones corporativas, comparten archivos a través de FTP o usan otros protocolos de red. Este es el perfil recomendado para múltiples protecciones en el tráfico entre usuarios y aplicaciones.',
    PROTECTION: 'protección',
    DESCRIPTION: 'Descripción',
    DETAILS: 'Detalles',
    'WEB-FILTER': 'Filtro Web',
    'WEB-FILTER_DESCRIPTION':
      'Proteja su negocio con un filtro web y anti-malware. Puede bloquear el acceso a webs por categorías, paises e incluso bloquear dominios concreto.',
    ANTIVIRUS: 'Antivirus y Anti C&C',
    SSL: 'Inspección SSL',
    'SSL-VPN': 'Vpn SSL',
    'IPSEC-VPN': 'Vpn IPSEC',
    IPS_GROUP: 'Protección IPS',
    IPS: 'Protección IT',
    OT: 'Protección OT',
    DLP: 'DLP',
    APPLICATIONS: 'Control de aplicaciones',
    CONFIGURATION: 'Configuración',
    ACTIVATE_PROTECTION: 'Activar protección',
    ZTNA: 'ZTNA',
    ZTNA_DESCRIPTION: 'Conectar con otros ordenadores',
    'REMOTE-ACCESS': 'Acceso Remoto',
    'REMOTE-ACCESS_DESCRIPTION': 'Conectar con otros ordenadores',
    ANTIVIRUS_DESCRIPTION:
      'Previene, detecta y responde a todas las amenazas que puedan afectar a cualquiera de los activos de su organización.',
    SSL_DESCRIPTION:
      'Descifra el tráfico SSL para evitar amenazas encriptadas entrante a las aplicaciones o saliente de los usuarios a internet.',
    IPS_DESCRIPTION:
      'Sistema de detección y prevención de intrusiones. Monitorización del tráfico en tiempo real.',
    DLP_DESCRIPTION:
      'Aplique reglas para evitar que salga de su organización información sensible a internet.',
    APPLICATIONS_DESCRIPTION:
      'Restringa el acceso a aplicaciones específicas en su organización.',
    ADVANCED_CONFIGURATION: 'Abrir configuración avanzada',
    FIREWALL_DESCRIPTION: 'Protección Firewall',
    ANTISPAM_DESCRIPTION: 'Descripción Antispam',
    TYPE: 'Tipo',
    ACTION: 'Acción',
    DATE: 'Fecha',
    LICENSES: 'Licencias',
    LICENSE: 'Licencia',
    LICENSE_GENERATOR: 'Generador de licencias',
    VALID_LICENSE: 'Licencia Válida',
    INVALID_LICENSE: 'Licencia Inválida',
    TIME_EXPIRED: 'Fecha expirada',
    REMAINING_DAYS: 'Días restantes',
    VERSIONS: 'Control versiones',
    FIREWALL: 'Firewall',
    SETTINGS: 'Ajustes',
    NETWORK: 'Network',
    THREAT_PREVENTION: 'Prevención de amenazas',
    ANTISPAM: 'Antispam',
    CONTENT_CONTROL: 'Control de contenido',
    CASB: 'CASB',
    CASB_DESCRIPTION: 'Configuración para CASB',
    'USER-IDENTIFICATION': 'Identificación de usuarios',
    'USER-IDENTIFICATION_DESCRIPTION':
      'Configuración para identificar a los usuarios',
    'VPN-TUNNEL': 'Túnel VPN IPsec',
    'VPN-TUNNEL_DESCRIPTION': 'Configuración para Túnel VPN',
    'DNS-FILTER': 'Filtro DNS',
    'DNS-FILTER_DESCRIPTION': 'Descripción DNS filter',
    GLOBAL_SETTINGS: 'Ajustes Globales',
    IP_WHITELISTS: 'Lista blanca IPs',
    CNM_SETTINGS: 'Ajustes de CNM',
    CNM_CONNECTION: 'Conexión CNM',
    API_KEY: 'Clave API',
    ENDPOINT: 'Endpoint',
    CNM_CA_BUNDLE: 'CA de dispositivos (PEM)',
    CNM_CA_BUNDLE_WARNING:
      'Este tenant ya tiene dispositivos enrolados. Cambiar la CA afecta cómo se validan sus certificados al descargar reglas — una CA inválida o incompleta puede dejar a los dispositivos sin reglas. Para renovar la CA, pega la CA vieja y la nueva juntas durante la transición y quita la vieja cuando todos los dispositivos se hayan reemitido.',
    EMAIL_SETTINGS: 'Ajustes de Email',
    INACTIVITY_SETTINGS: 'Ajustes de Inactividad',
    NAT: 'NAT',
    LOOK_AND_FEEL: 'Look and feel',
    COLOR: 'Color',
    LOGO: 'Logo',
    REPORT_SETTINGS: 'Ajustes de Informe',
    AUDIT_SETTINGS: 'Ajustes de Auditoría',
    ADD_USER_LOGS_AUDIT: 'Añadir logs de usuario a la Auditoría',
    SYSLOG_SETTINGS: 'Ajustes de Syslog',
    UPLOAD_CERTIFICATE: 'Subir certificado',
    VPN_USERS: 'Usuarios',
    SERVER_ADDRESS: 'Dirección del servidor',
    PORT: 'Puerto',
    DOMAIN: 'Dominio',
    AUTHENTICATION: 'Autentificación',
    USERNAME: 'Nombre de usuario',
    PASSWORD: 'Contraseña',
    NONE: 'Ninguno/a',
    PLAIN: 'PLAIN',
    LOGIN: 'Inicio de sesión',
    CRAM_MD5: 'CRAM MD5',
    PEER: 'Peer',
    OPENSSL: 'Modo verificación OpenSSL',
    STARTTLS: 'Habilitar y usar STARTTLS',
    SMTP: 'Habilitar SMTP sobre TLS',
    SDWAN: 'Integración con SD-WAN',
    CERTIFICATES: {
      TITLE: 'Certificados',
      INFO: 'El fichero cifrado debe contener el certificado y la clave privada',
      PASSWORD_INFO: 'Parámetro opcional',
      ADD: 'Añadir certificado',
      EDIT: 'Editar certificado',
      SUBJECT: 'Sujeto',
      ISSUER: 'Emisor',
      CERTIFICATE_TYPE: 'Tipo de certificado',
      CIPHERED: 'Cifrado',
      UNCIPHERED: 'Sin cifrar',
      PASSWORD: 'Contraseña',
      EXPIRATION_DATE: 'Fecha de expiración',
      VALIDITY: 'Validez en años',
      VALIDITY_WRONG:
        'La validez del certificado debe estar entre {min_year} y {max_year} años',
      SOURCE: 'Origen',
      LOCAL: 'Local',
      CUSTOM: 'Personalizado',
      UPLOAD_CIPHERED_CERTIFICATE: 'Subir un certificado PKCS#12',
      UPLOAD_CERTIFICATE: 'Subir un certificado X-509',
      UPLOAD_KEY: 'Subir la clave privada del certificado',
      ADD_ERROR: 'Error al crear el certificado',
      ADD_SUCCESS: 'Certificado creado con éxito',
      EDIT_ERROR: 'Error al actualizar el certificado',
      EDIT_SUCCESS: 'Certificado actualizado con éxito',
      DELETE_ERROR: 'Error al eliminar el certificado',
      DELETE_SUCCESS: 'Certificado eliminado con éxito',
      NAME_ERROR: 'El nombre no es válido',
      SOURCE_ERROR: 'El origen no es válido',
      VALIDITY_ERROR: 'La validez del certificado no es válida',
      CERT_X509_ERROR: 'El certificado no es válido',
      KEY_RSA_ERROR: 'La clave no es válida',
      VERIFY_ERROR: 'El certificado no puede ser verificado',
      FILE_ERROR: 'Los ficheros de certificado y clave no pueden estar vacíos',
      PKCS12_INVALID_PASSWORD: 'La clave del fichero no es correcta',
      CONFIRM_DELETE: '¿Está seguro de que quiere eliminar este certificado?',
      IN_USE: 'El certificado no se puede eliminar porque está siendo usando',
      NO_CA_ERROR: 'El certificado no es una Autoridad Certificadora (CA)',
      ERROR_CLIENT: 'Error al generar los certificados del cliente',
      ERROR_SERVER: 'Error al generar los certificados del servidor',
      ERROR_DH: 'Error al generar los parámetros DH',
    },
    VPN_SETTINGS: 'Ajustes VPN',
    AD_SETTINGS: 'Ajustes AD',
    AD_SYNC_INTERVAL: 'Syncronizar usuarios de AD (horas)',
    WRONG_MIN_CONFIG:
      'El intervalo de syncronización AD debe ser mayor o igual que 1',
    WRONG_MAX_CONFIG:
      'El intervalo de syncronización AD debe ser menor o igual que 24',
    LOGIN_SETTINGS: 'Inicio de sesión',
    ENABLE_2FA:
      'Activar Doble Factor de Autenticación con una OTP App como Google Authenticator',
    CONFIRM_ENABLE_2FA:
      'Esta acción puede tardar varios minutos. ¿Desea continuar?',
    THREAT_INTEL: 'Teldat Threat Labs',
    SASE_SETTINGS: 'Ajustes de SASE',
    BAN_TIMEOUT: 'Tiempo de bloqueo (minutos)',
    ENABLE_DEVICE_BAN:
      'Habilitar bloqueo de dispositivo al finalizar el tiempo',
    BAN_TIMEOUT_ERROR: 'El tiempo de bloqueo debe estar entre 15 y 600 minutos',
  },
  APPLICATIONS: {
    ALL_CATEGORIES: 'Todas las categorías',
    TABLE: {
      NAME: 'Nombre',
      DESCRIPTION: 'Descripción',
      ACTIONS: 'Acciones',
      FAMILY: 'Categoría',
    },
    UNRANKED: 'No clasificado',
    TITLE: 'Applications',
    REDIRECT_TO_APPLICATION: 'Go to Applications',
    UPDATE_SUCCESS: 'Control de aplicaciones actualizado correctamente',
    UPDATE_ERROR: 'Error al actualizar el control de aplicaciones',
  },
  AZURE_AD: {
    FAILED_CONNECTION: 'Error de conexión a Azure AD',
    REQUEST_TIMEOUT: 'La petición ha tardado demasiado tiempo',
    SYNC_IN_PROGRESS: 'Ya hay una sincronización en curso',
    SYNC_ENQUEUED: 'Ya hay una sincronización en curso; tu petición será atendida por ella',
  },
  CNM_CONNECTION: {
    INFO: 'Solo se puede cambiar si no tiene dispositivos registrados',
    TEST_CONNECTION: 'Probar conexión',
    SUCCESS: 'Conexión con éxito',
    AUTHENTICATION_ERROR: 'Error de autenticación',
    CONNECTION_ERROR: 'Error de conexión',
    READ_TIMEOUT: 'Tiempo de lectura de respuesta agotado',
    OPEN_TIMEOUT: 'Tiempo de apertura de conexión agotado',
    BAD_REQUEST: 'Petición incorrecta',
    UNKNOWN_HOST: 'Host desconocido',
    EMPTY_VALUES: 'Campos vacíos',
  },
  SSL_INSPECTION: {
    DOWNLOAD_CERTIFICATE_ERROR: 'Error al descargar el certificado',
    MODE_BASIC: 'Básico',
    MODE_FULL: 'Completo',
    MODE: 'Tipo de inspección SSL',
    SEARCH: 'Buscar',
    SELECT_YOUR_SSL: 'SELECCIONA EL TIPO DE INSPECCIÓN SSL',
    ERROR_FETCH: 'Error al cargar las opciones de la inspección SSL',
    SSL_EXCEPTION_ADD_ERROR: 'Error al crear excepción SSL',
    SSL_EXCEPTION_ADD_SUCCESS: 'Excepción SSL creada con éxito',
    SSL_EXCEPTION_ADD: 'Añadir nueva excepción SSL',
    SSL_EXCEPTION_ANY: 'Todos',
    SSL_EXCEPTION_CONFIRM_DELETE:
      '¿Está seguro de que quiere eliminar esta excepción SSL?',
    SSL_EXCEPTION_DELETE_ERROR: 'Error al eliminar excepción SSL',
    SSL_EXCEPTION_DELETE_SUCCESS: 'Excepción SSL eliminada con éxito',
    SSL_EXCEPTION_EDIT_ERROR: 'Error al actualizar excepción SSL',
    SSL_EXCEPTION_EDIT_SUCCESS: 'Excepción SSL actualizada con éxito',
    SSL_EXCEPTION_EDIT: 'Editar Excepción SSL',
    SSL_EXCEPTION_NAME_PLACEHOLDER: 'Nombre de la excepción SSL...',
    SSL_EXCEPTION: 'Excepciones SSL',
    SSL_MODE_UPDATE_SUCCESS: 'Modo de inspección SSL actualizado con éxito',
    SSL_MODE_UPDATE_ERROR: 'Error al actualizar el modo de inspección SSL',
    CERTIFICATE_UPDATE_SUCCESS: 'Certificado actualizado con éxito',
    CERTIFICATE_UPDATE_ERROR: 'Error al actualizar el certificado',
    CERTIFICATE_ERROR_FETCH: 'Error al cargar las opciones del certificado',
    TITLE: 'Inspección SSL',
    CERTIFICATE: 'Certificado',
    TABLE: {
      ID: 'ID',
      ACTION: 'Acción',
      NAME: 'Nombre',
      SOURCE: 'Origen',
      DESTINATION: 'Destino',
      STATUS: 'Estado',
      ACTIONS: 'Acciones',
    },
  },
  IDENTITY_AWARENESS: {},
  ACCOUNTS: {},
  USERS: {
    ADDITIONAL: 'Información adicional',
    CASB_ID: 'ID de CASB',
    NEW_USER: 'Añadir nuevo usuario',
    NAME: 'Nombre',
    GROUP: 'Grupo',
    EMAIL: 'Email',
    EXTERNAL_IMMUTABLE: 'Este usuario está gestionado por un proveedor de identidad externo y no se puede editar ni eliminar aquí',
    CROSS_TENANT_FORBIDDEN: 'El llamante no está autorizado a aprovisionar usuarios para esta cuenta',
    PROVISIONING_CLAIM_MISSING: 'El token de aprovisionamiento no incluye el claim de rol/proveedor requerido',
  },
  NETWORK_USERS: {
    GENERATE_FILE_PROMPT:
      'Para generar un archivo con los usuarios exportados de tu Directorio Activo, ejecuta el siguiente comando en un terminal Powershell dentro de tu servidor administrador de Directorios Activos',
    DESCRIPTION:
      'Cuando el archivo se cargue, sólo se procesarán las filas válidas.',
  },
  USER_GROUPS: {
    NEW_GROUP: 'Añadir nuevo grupo',
    USERS_LIST: 'Lista de usuarios',
    NAME: 'Nombre',
  },
  LOGS: {
    IPS_MODAL: {
      ACTION: 'Acción',
      ALIAS_NAME: 'Nombre Dispositivo',
      CATEGORY: 'Categoría',
      DATE: 'Fecha',
      DESCRIPTION: 'Descripción',
      DEST_IP: 'IP Destino',
      DEST_PORT: 'Puerto Destino',
      FEATURE: 'Característica',
      FILENAME: 'Nombre del fichero',
      FILE_TYPE: 'Tipo de fichero',
      HOSTNAME: 'Nombre del host',
      MD5_HASH: 'Hash MD5',
      PROTOCOL: 'Protocolo',
      SEVERITY: 'Gravedad',
      SERIAL_NUMBER: 'Serial',
      SOURCE_IP: 'IP Origen',
      SOURCE_PORT: 'Puerto Origen',
      TX_BYTES: 'Bytes Transmitidos',
      TYPE: 'Tipo',
      RULE_ID: 'ID de regla',
      URL: 'URL',
      VIRUS_NAME: 'Nombre del virus',
      WEBFILTER_SUBCATEGORY: 'Subcategoría Filtro Web',
      REPUTATION: 'Reputación',
      POLICY_NAME: 'Nombre de Política',
      VIEW_RELATED_TRAFFIC_LOG: 'Ver Log de Tráfico Relacionado',
      VIEW_RELATED_TRAFFIC: 'Ver Tráfico Relacionado',
      NO_RELATED_TRAFFIC_FOUND: 'No se encontró tráfico relacionado',
      LOADING_RELATED: 'Cargando log relacionado...',
      TAB: {
        FILE_INFORMATION: 'Información del fichero',
        GENERAL: 'General',
      },
    },
    TABLE: {
      DATE: 'Fecha',
      EVENT: 'Evento',
      DESCRIPTION: 'Descripción',
      SERIAL: 'Serial',
      ACTION: 'Acción',
      ALIAS_NAME: 'Nombre Dispositivo',
      ALLOWED: 'PERMITIDO',
      BLOCKED: 'BLOQUEADO',
      DEST_IP: 'IP Destino',
      DEST_MAC: 'MAC Destino',
      DEST_PORT: 'Puerto Destino',
      FEATURE: 'Característica',
      IN_INTERFACE: 'Interfaz de entrada',
      OUT_INTERFACE: 'Interfaz de salida',
      PROTOCOL: 'Protocolo',
      PROTO_FLAG: 'Flag de Protocolo',
      RULE_ID: 'ID de regla',
      RULE_NAME: 'Nombre de regla',
      RECEIVED_BYTES: 'Bytes Recibidos',
      SENT_BYTES: 'Bytes Enviados',
      SERIAL_NUMBER: 'Número de serie',
      SESSION: 'Sesión',
      SOURCE_IP: 'IP Origen',
      SOURCE_MAC: 'MAC Origen',
      SOURCE_PORT: 'Puerto Origen',
      SOURCE_USER: 'Usuario Origen',
      URL: 'URL',
      REPUTATION: 'Reputación',
    },
    SESSION_MODAL: {
      ACTION: 'Acción',
      ALIAS_NAME: 'Nombre Dispositivo',
      ALLOWED: 'PERMITIDO',
      APP_NAME: 'Aplicación',
      BLOCKED: 'BLOQUEADO',
      DATE: 'Fecha',
      DEST_IP: 'IP Destino',
      DEST_MAC: 'MAC Destino',
      DEST_PORT: 'Puerto Destino',
      FEATURE: 'Característica',
      FW_RULE: 'Regla FW',
      FW_RULE_ID: 'ID Regla FW',
      FW_RULE_ORDER: 'Orden Regla FW',
      IN_INTERFACE: 'Interfaz de entrada',
      OUT_INTERFACE: 'Interfaz de salida',
      POLICY_ID: 'ID de firewall',
      POLICY_NAME: 'Perfil FW',
      PROTOCOL: 'Protocolo',
      PROTO_FLAG: 'Flag de Protocolo',
      RULE_ID: 'ID de regla',
      RULE_NAME: 'Nombre de regla',
      SDWAN_APP_ID: 'ID App SDWAN',
      SDWAN_APP_NAME: 'App SDWAN',
      SDWAN_POLICY_ID: 'ID Política SDWAN',
      SDWAN_POLICY_NAME: 'Política SDWAN',
      RECEIVED_BYTES: 'Bytes Recibidos',
      SENT_BYTES: 'Bytes Enviados',
      SERIAL_NUMBER: 'Número de serie',
      SESSION: 'Sesión',
      SOURCE_IP: 'IP Origen',
      SOURCE_MAC: 'MAC Origen',
      SOURCE_PORT: 'Puerto Origen',
      SOURCE_USER: 'Usuario Origen',
      TYPE: 'Tipo',
      VIEW_WEB_FILTER_DETAILS: 'Ver Detalles de Filtro Web',
      HAS_RELATED_SECURITY_LOG:
        'Este log de tráfico tiene un evento de seguridad relacionado',
      LOADING_RELATED: 'Cargando log relacionado...',
    },
    EXPORT: {
      NO_DATE_FILTER:
        'Por favor, seleccione un rango de fechas antes de exportar',
    },
  },
  ADMIN: {},
  SESSIONS: {},
  FIREWALLS: {},
  CLUSTERS: {},
  PROFILE: {
    INVALID_CERTIFICATE: 'El certificado seleccionado no es válido',
    ADD_DEVICE_ERROR: 'Error al asociar dispositivos',
    ADD_DEVICE_SUCCESS: 'Dispositivos asociados con éxito',
    ADD_DEVICES: 'Asociar dispositivos',
    ADD: 'Añadir nuevo perfil',
    API_KEY: 'Api key',
    CLIENT: 'Cliente',
    DEVICES: 'Dispositivos',
    PORTS: 'Puertos de protocolos',
    CONFIRM_DELETE: '¿Desea borrar el perfil?',
    CONFIRM_ERROR: 'Ha ocurrido un error en la confirmación',
    CONFIRM_REFRESH_API_KEY: '¿Está seguro de que desea refrescar la api key?',
    DELETE_SUCCESS: 'Perfil borrado con éxito',
    DEVICES_WITH_FW_PROFILE:
      'Algunos dispositivos tienen instalado un perfil de firewall diferente',
    DEVICES_WITH_PROFILE: 'Hay dispositivos con un perfil asignado',
    DUPLICATE_COPY: 'Copia',
    DUPLICATE_NAME: 'Introducir el nombre del perfil duplicado',
    DUPLICATE: 'Duplicar perfil',
    DUPLICATED_NAME: 'Nombre de perfil ya se encuentra en uso',
    DUPLICATE_NAME_TOO_LONG:
      'El nombre "{name}" supera el máximo de 16 caracteres permitidos',
    IN_USE: 'No es posible eliminar. Perfil en uso',
    INFO_PROFILE: 'Detalles de la cuenta',
    MAXIMUM_ONE_CLOUD: 'Sólo se permite un perfil Cloud',
    MAXIMUM_REACHED: 'Máximo número de perfiles alcanzado',
    MAXIMUM_UTM_REACHED: 'Máximo número de perfiles UTM alcanzado',
    NAME_MAXIMUM_LENGTH:
      'Solo se permiten 16 caracteres para el nombre del perfil',
    NAME_PLACEHOLDER: 'Nombre del perfil',
    NAME: 'Introducir el nuevo nombre del perfil',
    NOT_FOUND: 'Perfil no encontrado',
    REFRESH_API_KEY_SUCCESS: 'La api key fue refrescada correctamente',
    API_KEY_LOADING: 'Cargando clave API…',
    API_KEY_FETCH_ERROR: 'No se pudo cargar la clave API',
    SETTINGS: 'Configuración del perfil',
    MISSING_LICENSES: 'No hay licencias disponibles o han expirado',
    ERROR_FETCH: 'Error al obtener los perfiles',
    INVALID_SECURITY_FEATURES:
      'Poca memoria: La combinación de características de seguridad {features} en el perfil {profile} no son válidas para los modelos RS420 asociados (ej: {device})',
    MISSING_DEVICES: 'No hay dispositivos asociados',
    INVALID_FUNCTIONALITY_FOR_MONITOR: 'Solo los perfiles UTM de IPS e IPS-OT de cuentas UTM pueden ser perfiles monitor',
    MONITOR_IMMUTABLE: 'Un perfil no puede cambiar entre monitor y en línea',
    MONITOR_ALERT_ONLY: 'Los perfiles monitor solo pueden alertar, no bloquear',
    MONITOR_MODE: 'Modo monitor (puerto SPAN)',
    MONITOR_NOT_ALLOWED_INLINE: 'Un perfil monitor no se puede usar en una regla de firewall o ZTNA, ni como perfil en línea de un equipo',
  },
  DEVICES: {
    ACTIONS: 'Acciones',
    ADD_DEVICE_SUCCESS: 'Dispositivo creado con éxito',
    DEVICE_KIND: 'Tipo de dispositivo',
    KIND_STANDALONE: 'Individual',
    KIND_SHARED: 'Compartido',
    NO_SHARED_TENANTS:
      'Todavía no hay clientes SASE compartidos - cree uno en Administración > Clientes',
    ATTACH_NEEDS_GROUP:
      'Todavía no hay dispositivos compartidos existentes a los que asociar',
    SHARED_TENANT_AUTO_ATTACH:
      'El cliente seleccionado se asociará automáticamente como primer cliente de este dispositivo compartido',
    SHARED_DEVICE_MODE: 'Dispositivo compartido',
    SHARED_MODE_CREATE: 'Crear nuevo dispositivo compartido',
    SHARED_MODE_ATTACH: 'Asociar a un dispositivo compartido existente',
    SHARED_TENANTS_BADGE: 'Compartido · {count} clientes',
    SHARED_GROUP_EXPAND: 'Mostrar el grupo de dispositivos compartidos',
    SHARED_GROUP_COLLAPSE: 'Ocultar el grupo de dispositivos compartidos',
    ADD_DEVICE: 'Añadir nuevo dispositivo',
    ADD_SUBNETWORKS: 'Pulsa Tab para añadir sub-redes',
    ADDRESSING_MODE: 'Modo direccionamiento',
    ADVANCED: 'Avanzado',
    ANTI_SPOOFING_HELP:
      'Activar la verificación de la dirección de origen para habilitar la protección contra IP Spoofing',
    ANTI_SPOOFING_INPUT: 'Habilitar:',
    ANTI_SPOOFING: 'Anti Spoofing',
    ANTIVIRUS_PROFILE: 'Perfil Antivirus',
    APPLICATION_PROFILE: 'Perfil Aplicaciones',
    AUTHENTICATION: 'Autenticación',
    AVAILABLE_LICENSES: 'Licencias disponibles',
    BATCH_HELP: 'Carga masiva',
    TUNNEL_HELP: 'Configuración de túnel',
    HELP: 'Ayuda de dispositivos',
    BATCH_LOAD: 'Carga masiva',
    CASB_PROFILE: 'Perfil CASB',
    AUTO_IKE: 'IKE Automático',
    CLI_EXTENSION: 'Extensión de CLI',
    COMPARE_BASE: 'Base',
    COMPARE_BASE_CLI: 'Lineas de Cli Base',
    COMPARE_TO: 'Comparar con',
    COMPARE_TO_CLI: 'Lineas de Cli Comparación',
    COMPARE_OPTION_CANDIDATE: 'Candidata',
    COMPARE_OPTION_CURRENT: 'Actual',
    COMPARE_OPTION_ROLLBACK: 'Última funcional',
    COPY_DIFF: 'Copiar diff',
    COPY_DIFF_TOOLTIP: 'Copiar el diff al portapapeles',
    CONECTION: 'Conexión',
    CONECTION_INFO: 'Información de conexión',
    CONFIGURATION_NOT_SYNCHED: 'Configuración no sincronizada',
    CONFIGURATION_SYNCHED: 'Configuración sincronizada',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar este dispositivo?',
    MESSAGE_DELETE_ZTNA:
      'No se puede eliminar porque se está usando en las siguientes reglas ZTNA: {rulesList}',
    MESSAGE_DELETE_ZTNA_SIMPLE:
      'No se puede eliminar porque se está usando en reglas ZTNA',
    CONFIRM_DISABLE_DNS_FORWARDER:
      'Esta acción puede ocasionar la desactivación del DNS Forwarder. ¿Quieres deshabilitarlo si es posible?',
    CONFIRM_DISABLE_DNS_FORWARDER_ERROR:
      'Error al deshabilitar el DNS Forwarder',
    KEEP_DNS_FORWARDER_ENABLED: 'Mantenerlo habilitado',
    CONNECTION_PROTOCOL: 'Tipo de protocolo',
    CONNECTION: 'Conexión',
    CSV_DVC_EMPTY: 'El campo DVC de la fila {row} está vacío',
    CSV_ERROR_CREATE: 'La creación del dispositivo {name} ha retornado error',
    CSV_IP_DUPLICATED_FILE:
      'El campo IP de la fila {row} ya está siendo usado en el fichero',
    CSV_IP_DUPLICATED: 'El campo IP de la fila {row} ya está en uso',
    CSV_IP_INVALID: 'El campo IP de la fila {row} no es válido',
    CSV_LICENSES_INVALID: 'El campo Licenses de la fila {row} no es válido',
    CSV_MODEL_EMPTY: 'El campo Model de la fila {row} está vacío',
    CSV_MODEL_INVALID: 'El campo Model de la fila {row} no es válido',
    CSV_ZTNA_CONNECTOR_MODEL_INVALID:
      'El campo Model del conector ZTNA de la fila {row} no es válido',
    CSV_NAME_DUPLICATED_FILE:
      'El campo Name de la fila {row} ya está siendo usado en el fichero',
    CSV_NAME_DUPLICATED: 'El campo Name de la fila {row} ya está en uso',
    CSV_NAME_EMPTY: 'El campo Name de la fila {row} está vacío',
    CSV_NOT_ENOUGH_COLUMNS:
      'El número de columnas de la fila {row} es incorrecto',
    CSV_SERIAL_EMPTY: 'El campo Serial Number de la fila {row} está vacío',
    CSV_SERIAL_INVALID: 'El campo Serial Number de la fila {row} no es válido',
    CSV_TYPE_INVALID: 'El campo Type de la fila {row} no es válido',
    CSV_CORE_EMPTY: 'El campo Core Number de la fila {row} está vacío',
    CSV_SHOW_INVALID: 'El campo Show de la fila {row} no es válido',
    CSV_NETWORKS_INVALID:
      'Se debe rellenar el campo Objects o Groups de la fila {row}',
    CSV_PRE_SHARED_KEY_INVALID:
      'El campo Pre Shared Key de la fila {row} no es válido',
    CSV_PRE_SHARED_KEY_REQUIRED_FOR_OTHERS:
      'Pre-Shared Key es obligatorio para dispositivos tipo "Others" en la fila {row}',
    CSV_PEER_ID_INVALID: 'El campo Peer ID de la fila {row} no es válido',
    CSV_NETWORK_ADDRESS_INVALID:
      'Formato de dirección de red inválido en la fila {row}: {address}',
    CSV_NETWORK_NOT_FOUND:
      'Objeto de red "{name}" no encontrado en la fila {row}. En el nuevo formato CSV, proporcione direcciones para crear redes automáticamente.',
    CSV_LICENSE_TYPE_NOT_FOUND:
      'El tipo de licencia "{license_type}" no existe en la fila {row}',
    CSV_LICENSE_NOT_AVAILABLE:
      'No hay licencia disponible para el tipo "{license_type}" en su cuenta en la fila {row}',
    CSV_LICENSE_NO_CAPACITY:
      'La licencia "{license_type}" ha alcanzado su capacidad máxima en la fila {row}',
    CONFIRM_EVENTS: 'Eliminar también los logs asociados a este dispositivo',
    CONFIRM_ERROR: 'Error al borrar el dispositivo',
    CORE_NUMBER: 'Número de núcleos',
    DELETE_SUCCESS: 'Dispositivo borrado con éxito',
    DESCRIPTION_STEP1:
      'Nombre del dispositivo y tipo son campos obligatorios. Los parámetros opcionales pueden ser configurados posteriormente.',
    DESCRIPTION_STEP2:
      'Nombre del dispositivo y tipo son campos obligatorios. Los parámetros opcionales pueden ser configurados posteriormente.',
    DESCRIPTION_STEP4: 'Selecciona una licencia para asignar al dispositivo',
    DESCRIPTION: 'Lista de dispositivos',
    DEVICE_ALREADY_EXISTS: 'Dispositivo ya existe',
    DEVICE_NAME: 'Nombre de dispositivo',
    DEVICES_GROUP: 'Grupo de dispositivos',
    DEVICES: 'Dispositivos',
    DHCP_CONFIG: 'Servidor DHCP',
    DISMISS: 'Ignorar',
    DLP_PROFILE: 'Perfil DLP',
    DUPLICATE_IP: 'IP ya se encuentra registrada',
    DUPLICATE_NAME: 'Nombre ya registrado',
    DUPLICATE_SERIAL_NUMBER: 'Número de serie ya está registrado',
    E_AUTH_TOKEN_ERROR: 'Sin autorización',
    EDIT_DEVICE: 'Editar dispositivo',
    EMPTY_DVC: 'DVC no puede ser vacio',
    EMPTY_UUID: 'UUID no puede ser vacio',
    EMPTY_NAME: 'Nombre no puede ser vacío',
    EMPTY_SERIAL: 'Número de serie no puede ser vacio',
    ERROR_CORE_NUMBER: 'Error al actualizar el número de núcleos',
    ERROR_EMPTY: 'Error: Campo vacío',
    ERROR_FIREWALL_DEPTH:
      'Ha ocurrido un error al actualizar la calidad del motor de firewall',
    ERROR_INSTALLATION: 'Error al instalar configuración',
    ERROR_PROFILE: 'Ha ocurrido un error al actualizar el perfil',
    FEATURE_PROFILES: 'Perfiles de funcionalidades',
    FILTER: 'Dispositivos',
    FIREWALL_CLI_HELP:
      "Este fragmento de código tiene parámetros entre '<' y '>'. Personalícelos antes de pegar la configuración en su router.",
    FIREWALL_CLI: 'Firewall CLI',
    FIREWALL_DEPTH: 'Calidad del motor de firewall de próxima generación',
    FIREWALL_DEPTH_HIGH: 'Mejorado',
    FIREWALL_DEPTH_LOW: 'Por defecto',
    SELECT_FIREWALL_PROFILE: 'Seleccione perfil de firewall',
    GENERAL: 'General',
    GROUP_NAME: 'Nombre del grupo',
    IMPORTED_SUCCESS: 'El fichero ha sido importado con éxito',
    IN_PROCESS: 'Tarea en progreso',
    SCHEDULED: 'Tarea programada',
    INCORRECT_FILE: 'Fichero incorrecto',
    INSTALL: 'Instalar configuración candidata',
    INTERFACES: 'Interfaces',
    INVALID_AVAILABLE_MEMORY:
      'El pack de reglas no puede ser seleccionado, no hay memoria libre suficiente.\nMemoria libre: {available_memory} MB\nMemoria necesaria: {necessary_memory} MB',
    INVALID_CORE_NUMBER:
      'Número de núcleos no válido. Debe ser un número entre 1 y 64',
    INVALID_DVC: 'DVC inválido',
    INVALID_IP: 'Formato de ip, no es valido',
    INVALID_HOSTNAME: 'Formato de hostname no es válido',
    INVALID_NAME: 'El formato del nombre no es válido',
    INVALID_RULE_PACK: 'Pack de reglas no válido',
    INVALID_PRE_SHARED_KEY:
      'El formato de la Pre shared key no es válido. Debe tener un mínimo de 8 de los siguientes carácteres: a-z A-Z 0-9 - + & ! @ # %% ^ * ( ) , . : _',
    NAME_TOO_LONG: 'Longitud de nombre mayor de 63 caracteres',
    NAME_TOO_SHORT: 'Longitud de nombre menor de 2 caracteres',
    INVALID_UUID: 'El formato UUID es inválido',
    INVALID_MEMORY:
      'Los siguientes dispositivos no tienen memoria suficiente para los paquetes seleccionados',
    INVALID_TOTAL_MEMORY:
      'El pack de reglas no puede ser seleccionado, la memoria del equipo no es suficiente.\nMemoria total de {model}: {total_memory} MB\nMemoria necesaria: {necessary_memory} MB',
    IP_ADDRESS: 'Dirección IP',
    IP_DYNAMIC_EXTERNAL: 'Servicio externo IP dinámica',
    IP_DYNAMIC_INTERNAL: 'Servicio Teldat IP dinámica',
    IP_HOSTNAME: 'IP / Hostname',
    IP_STATIC: 'IP Estática',
    IP_TUNNEL: 'Túnel IP',
    IPS_PROFILE: 'Perfil IPS',
    LAST_CONNECTION: 'Última conexión',
    LICENSE: 'Licencia',
    MANUFACTERER: 'Fabricante',
    MISSING_CLOUD_LICENSES_FOR_OTHERS_DEVICE:
      'Faltan licencias cloud para este dispositivo',
    PORTAL_ROLE_RESERVED:
      'El rol portal está reservado para el dispositivo del portal ZTNA que crea beSafe Pro',
    PORTAL_ROLE_IMMUTABLE:
      'Un dispositivo no puede convertirse en o dejar de ser un dispositivo de portal ZTNA',
    PORTAL_DEVICE_FIXED_SHAPE:
      'Un dispositivo de portal ZTNA es siempre un peer SASE no Teldat con peer id',
    MODEL: 'Modelo',
    MODEL_OTHER: 'Otro',
    MODEL_PORTAL: 'Portal',
    MONITOR: 'Monitor',
    NAME: 'Nombre',
    NETWORK: 'Redes',
    NETWORKS: 'Redes',
    NO_LICENSES: 'No hay licencias disponibles',
    NO_STATIC_INTERFACE:
      'En este dispositivo no hay una interfaz estática para el túnel VPN',
    NO_PROFILE: 'Sin perfil de firewall asignado',
    DEVICE_INFO_UNAVAILABLE_TOOLTIP: 'La información del dispositivo no está disponible. Por favor, actualice su aplicación e inténtelo de nuevo.',
    NOT_FOUND: 'Dispositivo no encontrado',
    OT_PROFILE: 'Perfil OT',
    PROFILE: 'Configuración de perfil',
    FIREWALL_PROFILE: {
      TITLE: 'Perfil de firewall',
      CURRENT: 'Perfil actual',
      MODAL_TITLE:
        'Seleccione los disposivitos en los que instalar el perfil de firewall {name}',
    },
    PROFILES: {
      NONE: 'Ninguno',
      MODAL_TITLE:
        'Seleccione los disposivitos en los que instalar el perfil {name}',
    },
    VPN_TUNNEL_PROFILE: 'Perfil de VPN L2L',
    VPN_RA_PROFILE: 'Perfil de VPN Acceso Remoto',
    RECORDS: 'Registros',
    RECORDS_HELP:
      'Aparecerá un listado predeterminado de registros cuando se encuentre asociado un perfil de Filtro Web con Protección de búsquedas activada con el perfil de Firewall del dispositivo',
    REGISTER: 'Añadir dispositivo',
    RESOLVE_HOSTNAME: 'Obtener nombre de host',
    RESOLVED_IP_ADDRESS: 'IP asignada',
    RESTORE_DEVICE_CONFIG: 'Instalar última configuración funcional',
    RESTORE_DEVICE_CONFIG_WARNING:
      'Devolver el dispositivo a su configuración anterior puede causar que las políticas de FW no se apliquen correctamente, dejando el dispositivo fuera de sincronización. Es importante revisar los últimos cambios en las reglas y la funcionalidad, y volver a aplicar para sincronizar el dispositivo.',
    RESTORE_DEVICE_CONFIG_EMPTY:
      'No se ha encontrado configuración previa para instalar',
    ROUTES: 'Enrutamiento',
    RULE_NAME: 'Nombre de regla',
    SERIAL_NUMBER: 'Número de serie',
    SHARED_KEY: 'Clave Compartida',
    SSL_INSPECTION_PROFILE: 'Perfil Inspección SSL',
    STATIC_ROUTES: 'Rutas Estáticas',
    STATUS: 'Estado gestión',
    SUB_NETWORKS: 'Sub-redes',
    SUCCESS_CORE_NUMBER: 'Número de núcleos actualizado correctamente',
    SUCCESS_FIREWALL_DEPTH:
      'Calidad de motor de firewall actualizado correctamente',
    SUCCESS_PROFILE: 'Perfil actualizado con éxito',
    SYNCHED: 'Sincronizado',
    SYSLOG: 'Syslog',
    SYSTEM_EVENTS: 'Eventos de sistema',
    TOTAL_LICENSES: 'Licencias totales',
    TUNNEL: 'Conexión SASE',
    TYPE: 'Tipo de dispositivo',
    UNAUTHORIZED_ERROR: 'Dispositivo no autorizado',
    UNKNOWN_MEMORY_WARNING:
      'Memoria disponible desconocida, la memoria libre podria no ser suficiente para el pack de reglas seleccionadas',
    UPDATE_SUCCESS: 'Dispositivo actualizado con éxito',
    UPLOAD: 'Cargar',
    WEB_FILTER_PROFILE: 'Perfil Filtro Web',
    DELETE_CNM_DEVICE: 'Eliminar dispositivo del CNM',
    DNS: 'DNS',
    DNS_FORWARDER: 'DNS FORWARDER',
    DNS_RESOLVER: 'DNS RESOLVER',
    DNS1: 'DNS primario',
    DNS2: 'DNS secundario',
    REQUIRED_INTERFACES: 'Se requiere al menos un interfaz',
    DNS_SAVED_SUCCESS: 'La configuración DNS se ha guardado con éxito',
    DNS_SAVED_ERROR: 'Error al guardar la configuración DNS',
    NO_MONITOR_DATA: 'Sin datos de monitorización',
    DISCONNECTED_DEVICE: 'El dispositivo no está conectado',
    GENERAL_CONFIGURATION: 'Config general',
    RULE_PACK: 'Precisión de IPS/WebFilter/Antivirus',
    SUCCESS_RULE_PACK:
      'Precisión de IPS/WebFilter/Antivirus actualizado correctamente',
    ERROR_RULE_PACK:
      'Error al actualizar la precisión de IPS/WebFilter/Antivirus',
    STANDARD_PACKAGE: 'Estándar',
    EXTENDED_PACKAGE: 'Extendido',
    EXTREME_PACKAGE: 'Extremo',
    STANDARD_RS420_PACKAGE: 'Estándar-RS420',
    CLI: 'CLI',
    DIFFERENCES: 'Mostrar/Ocultar diferencias',
    CURRENT_CLI: 'Configuración actual',
    NEW_CLI: 'Nueva configuración',
    HARDWARE_OFFLOADING: 'Descarga de trabajo hardware',
    SUCCESS_HARDWARE_OFFLOADING:
      'Descarga de trabajo hardware actualizada correctamente',
    ERROR_HARDWARE_OFFLOADING:
      'Error al actualizar la Descarga de trabajo hardware',
    CLI_WEB_FILTER: 'Web Filter dinámico',
    SUCCESS_CLI_WEB_FILTER: 'Web Filter dinámico actualizado correctamente',
    ERROR_CLI_WEB_FILTER: 'Error al actualizar el Web Filter dinámico',
    TLS_SYSLOG_ENABLED: 'Cifrar logs a BeSafe Pro (TLS)',
    TLS_SYSLOG_HELP: 'Cifra mediante TLS el flujo de syslog que este dispositivo envía a BeSafe Pro. No afecta a los destinos externos listados debajo.',
    SYSLOG_EXTERNAL_DESTINATIONS: 'Destinos de syslog externos',
    SUCCESS_TLS_SYSLOG: 'Configuración de syslog cifrado actualizada correctamente',
    ERROR_TLS_SYSLOG: 'Error al actualizar la configuración de syslog cifrado',
    CLOUD_STATUS: 'Estado de la nube',
    HOSTNAME: 'Hostname',
    NEVER_CONNECTED: 'Nunca conectado',
    PEER_ID: 'IKE Peer ID',
    PRESHARED_KEY: 'Pre-shared key',
    SASE_TUNNEL_STATUS: 'Estado de túnel ZTNA/SASE',
    TUNNEL_FULL_UP: 'Completamente levantado',
    TUNNEL_UP: 'Levantado',
    TUNNEL_DOWN: 'Caído',
    BAN_SOON: 'El dispositivo será baneado cuando el temporizador termine',
    BAN_SOON_CRITICAL: 'El dispositivo será baneado en breve',
    TIME_UNTIL_TUNNEL_BAN: 'Tiempo hasta el baneo del túnel',
    BANNED: 'Bloqueado',
    VALIDATE_LENGTH_IKE_PEER_ID:
      'El IKE Peer ID debe estar entre 6 y 16 caracteres',
    REMOTE_ACCESS_SSL_VPN: 'Perfil de SSL VPN',
    SSLVPN_APPLIED_FW_RULES_ERROR:
      'Perfil de SSL VPN no puede ser cambiado. Tiene reglas de firewall aplicadas.',
    WEB_FILTER_SERVICES_REQUIRED:
      'No se puede asignar este perfil. Contiene reglas de firewall con perfil de filtro web y servicios "Any".',
    UTM_LICENSE_EXCEPTION:
      'Error al instalar la configuración. Licencia de UTM <{license}> no encontrada o expirada para el dispositivo <{device}> y el perfil <{profile}>',
    CLOUD_LICENSE_EXCEPTION:
      'Error al instalar la configuración. Licencia de Cloud <{license}> no encontrada o expirada para el perfil <{profile}>',
    VPN_TUNNEL_LICENSE_MISSING:
      'Error al instalar la configuración. Licencia VPN Tunnel <{license}> no encontrada o expirada para el dispositivo cloud <{device}>',
    INTERFACE_EXCEPTION:
      'Error al instalar la configuración. La interfaz <{interface}> no se encuentra en el dispositivo <{device}> para el perfil <{profile}>',
    UTM_PROFILE_EXCEPTION:
      'Error al instalar la configuración. No hay perfil configurado en dispositivo <{device}>',
    TASK_EXCEPTION: '{message}',
    NO_ZTNA_LICENSE: 'Licencia ZTNA no disponible',
    CONNECTOR_NAME: 'Nombre del conector',
    ZTNA_TUNNEL_STATUS: 'Estado del túnel ZTNA',
    TUNNELS_CONFIGURED: 'Configurados',
    TUNNELS_UP: 'Levantados',
    TUNNELS_FULL_UP: 'Completamente levantados',
    NO_SASE_TUNNEL: 'No configurado',
    CHILD_MODE: {
      NAME: 'Child mode',
      COMPATIBILITY: 'Compatibilidad',
      STRICT: 'Estricto',
    },
    DEVICE_HARDENING: 'Device hardening',
    SOFTWARE_VERSION: 'Versión de software',
    TEMPLATE: 'Plantilla',
    SASE_INTERFACE_WARNING:
      'Puede que necesite editar su dispositivo para establecer la interfaz adecuada para el túnel SASE',
    CONFIRM_UNBAN: '¿Está seguro de que quiere desbloquear este dispositivo?',
    DEVICE_UNBANNED: 'Dispositivo desbloqueado con éxito',
    UNBAN_DEVICE: 'Desbloquear dispositivo',
    NOT_BANNED: 'El dispositivo no está bloqueado',
    NETWORK_EXACT_MATCH:
      'No se puede usar esta red. Ya está asignada al dispositivo "{device}"',
    NETWORK_OVERLAP_WARNING: '{network} en el dispositivo "{device}"',
    INVALID_MONITOR_PROFILE: 'El perfil monitor no es válido para este dispositivo',
    MONITOR_MODE_NOT_SUPPORTED: 'El modo monitor solo está disponible en dispositivos UTM',
  },
  DEVICE_PROTOCOLS: {
    TITLE: 'Gestión de protocolos',
    PROTOCOL_SSH: 'SSH',
    PROTOCOL_TELNET: 'Telnet',
    SUCCESS_EDIT: 'Protocolo del dispositivo actualizado con éxito',
    ERROR_EDIT: 'Error al actualizar el protocolo del dispositivo',
    ERROR_FETCH: 'Error al obtener los protocolos del dispositivo',
  },
  DEVICE_USERS: {
    TITLE: 'Usuarios permitidos',
    ADD_DEVICE_USER: 'Añadir usuario de dispositivo',
    EDIT_DEVICE_USER: 'Editar usuario de dispositivo',
    SUCCESS_ADD: 'Usuario de dispositivo añadido con éxito',
    SUCCESS_EDIT: 'Usuario de dispositivo editado con éxito',
    ERROR_ADD: 'Error al añadir usuario de dispositivo',
    ERROR_EDIT: 'Error al editar usuario de dispositivo',
    ERROR_FETCH: 'Error al obtener usuarios de dispositivo',
    CONFIRM_DELETE:
      '¿Está seguro de que quiere eliminar este usuario de dispositivo?',
    SUCCESS_DELETE: 'Usuario de dispositivo eliminado con éxito',
    ERROR_DELETE: 'Error al eliminar usuario de dispositivo',
    INVALID_USERNAME:
      'El nombre de usuario tiene que tener entre 4 y 32 caracteres',
    INVALID_PASSWORD: 'La contraseña tiene que tener entre 8 y 64 caracteres',
    LIMIT_EXCEEDED: 'Máximo número de usuarios alcanzado (100)',
    INVALID_USERNAME_CHARACTERS:
      'Sólo se permiten caracteres alfanuméricos en el nombre de usuario',
    USERNAME_ALREADY_EXISTS: 'El nombre de usuario ya existe',
    PASSWORDS_DO_NOT_MATCH: 'Las contraseñas no coinciden',
  },
  INTERFACES: {
    ADD: 'Añadir interfaz',
    ADDRESS_RANGE: 'Rango de direcciones',
    ADDRESSING_MODE: 'Modo de direccionamiento',
    AUTOMATIC: 'Automático (dhcp)',
    CONFIRM_CLEAN_INTERFACE: '¿Quieres limpiar la interfaz?',
    CONFIRM_DELETE_INTERFACE: '¿Quieres eliminar la interfaz?',
    DEFAULT_ROUTER: 'Router por defecto',
    DESCRIPTION: 'Descripción',
    DESCRIPTION_PLACEHOLDER: 'Descripción',
    DESCRIPTION_MAX_VALUE: 'Solo se permite un máximo de {maxValue} carácteres',
    DHCP_SERVER: 'Servidor DHCP',
    DHCP: 'DHCP',
    DUPLICATED_IP: 'Ip ya se encuentra en uso',
    DUPLICATE_VLAN_ID: 'VLAN id ya se encuentra en uso, dentro de la Ethernet',
    EDIT: 'Editar interfaz',
    END_IP: 'IP Fin',
    ERROR_CREATE: 'Error al crear interfaz',
    ERROR_CLEAN: 'Error al limpiar interfaz',
    ERROR_DELETE: 'Error al borrar interfaz',
    ERROR_DELETE_ETHERNET: 'No se puede borrar, interfaz del tipo Ethernet',
    ERROR_FETCH: 'Error al obtener interfaces',
    ERROR_UPDATE: 'Error al actualizar interfaz',
    ETHERNET_BRIDGE_LIST: 'Listado de Interfaces Ethernet sin configuración',
    ETHERNET_JUST_VM:
      'No se puede crear interface ethernet en este dispositivo',
    GENERAL: 'General',
    ID: 'ID',
    INTERFACE: 'Interfaz',
    INTERFACES: 'Interfaces',
    INVALID_RANGE_BRIDGE_ID: 'El rango debe estar entre 0 y 1000',
    INVALID_RANGE_VLAN_ID: 'El rango debe estar entre 1 y 4096',
    INVALID_RANGE_VLAN_ID_BRIDGE: 'El rango debe estar entre 2 y 4096',
    INVALID_RANGE_ETH_ID: 'El rango debe estar entre 0 y 1000',
    IP_MASK: 'Dirección IP / Máscara',
    IP: 'IP',
    MANUAL: 'Manual',
    NAME: 'Nombre',
    PARENT: 'Interfaz padre',
    PRIMARY_DNS_SERVER: 'Servidor DNS primario',
    RANGE: 'IP Inicio / IP Fin',
    REQUIRE_SUBNET: 'La subnet es obligatoria',
    SECONDARY_DNS_SERVER: 'Servidor DNS secundario',
    SECURITY: 'Seguridad',
    START_IP: 'IP Inicio',
    STATUS: 'Estado',
    SUBNETWORK: 'Subred',
    SUCCESS_CREATE: 'Interfaz creada con éxito',
    SUCCESS_CLEAN: 'Interfaz limpiada con éxito',
    SUCCESS_DELETE: 'Interfaz borrada con éxito',
    SUCCESS_UPDATE: 'Interfaz actualizada con éxito',
    TYPE: 'Tipo de interfaz',
    BRIDGE_NAME_DUPLICATED: 'El Bridge ya está en uso',
    VLAN_DUPLICATED: 'La VLAN ya está en uso',
    ETHERNET_NAME_DUPLICATED: 'La Ethernet ya está en uso',
    ETHERNET_NAME_VALID:
      'Asegúrese que el nombre de interfaz, coincide con una interfaz disponible en el equipo',
    BRIDGE_IP_DUPLICATED: 'La IP ya se encuentra en uso en otro Bridge',
    VLAN_IP_DUPLICATED: 'La IP ya se encuentra en uso en otra VLAN',
    ETH_IP_DUPLICATED: 'La IP ya se encuentra en uso en otra Ethernet',
    MONITOR_ONLY_ETHERNET: 'Solo se pueden monitorizar interfaces ethernet',
    MONITOR_MODE_NOT_SUPPORTED: 'El modo monitor solo está disponible en dispositivos UTM',
    MONITOR: 'Monitor (SPAN)',
    MONITOR_MODE: 'Modo monitor (puerto SPAN)',
    MONITOR_IPS_PROFILE: 'Perfil IPS monitor',
    MONITOR_OT_PROFILE: 'Perfil IPS-OT monitor',
    MONITOR_REQUIRES_NO_IP: 'Una interfaz monitorizada no puede tener dirección IP, DHCP, servidor DHCP ni VLANs',
    MONITOR_NO_IP_NOTE: 'Una interfaz monitorizada no tiene configuración IP: al guardar se eliminan su dirección, DHCP y servidor DHCP.',
    MONITOR_BLOCKED_BY_CONFIGURATION: 'Una interfaz configurada no puede estar en modo monitor. Para habilitarlo, elimina primero su configuración.',
  },
  FILTERS: {
    FIREWALL_PROFILES: {
      NAME: 'Perfiles de firewall',
    },
    MORE: 'Más',
    PAST_5MIN: 'Últimos 5 minutos',
    PAST_HOUR: 'Última hora',
    PAST24HOURS: 'Últimas 24 horas',
    PAST30DAYS: 'Últimos 30 días',
    PAST5YEARS: 'Últimos 5 años',
    PAST7DAYS: 'Últimos 7 días',
    PASTYEAR: 'Último año',
    RANGE: 'Rango Personalizado',
    TODAY: 'Hoy',
    YESTERDAY: 'Ayer',
    VERDICT: {
      NAME: 'Veredicto',
    },
    ACTION: {
      ALERT: 'Alert',
      ALLOWED: 'Permitido',
      BLOCKED: 'Bloqueado',
      DROP: 'Drop',
      NAME: 'Acción',
      PASS: 'Pass',
      DETECT: 'Detectar',
      PERMIT: 'Permitir',
      BLOCK: 'Bloquear',
      CUSTOM: 'Custom',
      OFF: 'Apagar',
      DEFAULT: 'Default',
    },
    ADD_MULTI_INPUT: {
      SRC_IP: 'Añade una red o un rango de redes',
    },
    APPLICATION: {
      NAME: 'Aplicación',
    },
    APPLICATIONS: {
      NAME: 'Aplicaciones',
      SAFARI: 'Safari',
    },
    BRIGHTCLOUD_ID: {
      NAME: 'Subcategoría',
    },
    FAMILY: {
      NAME: 'Family',
    },
    CATEGORY: {
      NAME: 'Categoría',
    },
    CREATED_AT: {
      NAME: 'Fecha creación',
    },
    DATE: {
      'LAST DAY': 'Último día',
      'LAST MONTH': 'Últimos 30 días',
      'LAST WEEK': 'Últimos 7 días',
      CUSTOM: 'Personalizado',
      NAME: 'Fecha',
      TODAY: 'Hoy',
      YESTERDAY: 'Ayer',
      INVALID_RANGE: 'Rango de fechas inválido',
      REQUIRED: 'Rango de fechas requerido',
    },
    DESCRIPTION: {
      NAME: 'Descripción',
    },
    DEST_COUNTRY_CODE: {
      NAME: 'País de destino',
    },
    DEST_COUNTRY_NAME: {
      NAME: 'País',
    },
    DEST_IP: {
      NAME: 'IP destino',
    },
    FEATURE: {
      ANOMALY: 'Anomalía',
      AV: 'Antivirus',
      APPLICATIONS: 'Aplicaciones',
      APPS: 'Aplicaciones',
      DLP: 'DLP',
      IPS: 'IPS',
      NAME: 'Funcionalidad',
      VPN: 'VPN',
      WEBFILTER: 'Filtro web',
      ZTNA: 'ZTNA',
    },
    FILE_NAME: {
      NAME: 'Nombre de archivo',
    },
    FILE_SIZE: {
      NAME: 'Tamaño de archivo',
    },
    FILE_MAGIC: {
      NAME: 'Tipo de archivo',
    },
    HTTP_METHOD: {
      DELETE: 'DELETE',
      GET: 'GET',
      NAME: 'Método HTTP',
      POST: 'POST',
      PUT: 'PUT',
    },
    OS: {
      ANDROID: 'Android',
      IOS: 'iOS',
      LINUX: 'Linux',
      MACOS: 'macOS',
      NAME: 'OS',
      WINDOWS: 'Windows',
    },
    VIRUS_NAME: {
      NAME: 'Nombre del virus',
    },
    FILE_MD5: {
      NAME: 'Hash MD5',
    },
    HOSTNAME: {
      NAME: 'Nombre del host',
    },
    PERIOD: {
      DAY: 'Día',
      HOUR: 'Hora',
      MINUTE: 'Minuto',
      MONTH: 'Mes',
      NAME: 'Periodo',
      SECOND: 'Segundo',
      WEEK: 'Semana',
      YEAR: 'Año',
    },
    PROTO: {
      ICMP: 'ICMP',
      IGMP: 'IGMP',
      NAME: 'Protocolo',
      TCP: 'TCP',
      UDP: 'UDP',
    },
    PROTOCOL: {
      ICMP: 'ICMP',
      IGMP: 'IGMP',
      NAME: 'Protocolo',
      TCP: 'TCP',
      UDP: 'UDP',
    },
    RECEIVED: {
      NAME: 'Bytes recibidos',
    },
    REPUTATION: {
      NAME: 'Reputación',
    },
    SEVERITY: {
      1: 'Critical',
      2: 'Major',
      3: 'Minor',
      4: 'Audit',
      5: 'Informational',
      AUDIT: 'Audit',
      CRITICAL: 'Critical',
      INFORMATIONAL: 'Informational',
      MAJOR: 'Major',
      MINOR: 'Minor',
      NAME: 'Gravedad',
    },
    SRC_COUNTRY_CODE: {
      NAME: 'País de origen',
    },
    SRC_IP: {
      INVALID: 'Se ha detectado una red inválida en el filtro de IP origen',
      NAME: 'IP origen',
    },
    SRC_USER: {
      NAME: 'Usuario origen',
    },
    TARGET: {
      BOTH: 'Both',
      NAME: 'Target',
      TO_CLIENT: 'To client',
      TO_SERVER: 'To server',
    },
    TRANSMITTED: {
      NAME: 'Bytes transmitidos',
    },
    TYPE: {
      ANTIVIRUS: 'Antivirus',
      APPLICATIONS: 'Aplicaciones',
      IPS: 'IPS',
      NAME: 'Tipo',
    },
    TYPE_IPS: {
      CUSTOM: 'Custom',
      DEFAULT: 'Default',
      NAME: 'Type',
    },
    UPDATED_AT: {
      NAME: 'Update at',
    },
    URL: {
      NAME: 'URL',
    },
    RESULT: {
      NAME: 'Resultado',
      SUCCESS: 'Éxito',
      FAIL: 'Intento fallido',
    },
    SASE_TUNNEL_STATUS: {
      NAME: 'Estado de túnel ZTNA/SASE',
      DOWN: 'Caído',
      UP: 'Levantado',
      FULL_UP: 'Completamente levantado',
      BANNED: 'Bloqueado',
    },
    PROFILES: {
      NAME: 'Perfiles',
    },
  },
  DASHBOARD: {
    TOP_PROTECTION: 'Top Protecciones',
    FEATURES: 'Funcionalidades',
    BLOCKED: 'Bloqueado',
    TRAFFIC_BLOCKED: 'Tráfico Bloqueado',
    TRAFFIC_ALLOWED: 'Tráfico Permitido',
    MALWARE_REGIONS: 'Malware detectado por regiones',
    SEVERITY_ALERTS: 'Eventos por Gravedad',
    FEATURE_ALERTS: 'Eventos por Funcionalidad',
    NAME: 'Nombre',
    SEVERITY: 'Severidad',
    DETECTIONS: 'Detecciones',
    TRAFFIC_STATS: 'Estadísticas de tráfico',
    ACTION: 'Acción',
    BY: 'Por ',
    ALERTS: 'Eventos',
    TRAFFIC: 'Tráfico',
    SEVERITY_BY_SRC_IP: 'Gravedad por IP Origen',
    SEVERITY_BY_DST_IP: 'Gravedad por IP Destino',
    TRAFFIC_BY_ACTION: 'Tráfico por Acción',
    TOP_TEN_EVENTS_BY_SRC_IP: 'Top 10 Eventos por IP origen',
    TOP_TEN_EVENTS_BY_DEST_IP: 'Top 10 Eventos por IP destino',
    TOP_10_MALWARE_FILES: 'Top 10 Archivos Maliciosos',
    TOP_10_SRC_USERS_MALWARE:
      'Top 10 Usuarios de Origen con Descargas de Malware',
    XDR_EVENTS: 'Eventos XDR',
    TRAFFIC_BY_APPLICATION_AND_IP: 'Tráfico por Aplicación y Origen',
    DLP_EVENTS: 'Eventos DLP',
    TOP_TEN_DLP_EVENTS_BY_FILE_NAME: 'Top 10 Eventos por Nombre de Archivo',
    ZTNA_THROUGHPUT_BY_SOURCE_USER: 'Tráfico ZTNA por usuario origen',
  },
  CONFIGURATION: {
    IpsProtection: 'Protección IPS',
    Ssl: 'SSL',
    Dlp: 'DLP',
    Applications: 'Control de Aplicaciones',
    RULES: 'Lista de reglas',
    Vpn: 'VPN',
    WebFilter: 'Filtro web',
    Antivirus: 'Antivirus',
    OtProtection: 'Protección OT',
    PENDING_CHANGES: 'Cambios para persistir',
    AFFECTED_DEVICES: 'Equipos afectados',
    SUMMARY_CHANGES: 'Resumen de cambios que quieres instalar:',
    CONFIRMATION_QUESTION: '¿Quieres aplicar estos cambios?',
    CASB: 'CASB',
    CASB_MISSING_SSL:
      'Perfil de Inspección SSL necesario para que CASB funcione correctamente',
    CASB_SSL_FULL_REQUIRED:
      'Perfil de Inspección SSL configurado a "COMPLETO" necesario para que CASB funcione correctamente',
    LOG_SECURITY_EVENTS: 'Registrar eventos de seguridad',
    LOG_SECURITY_EVENTS_SUCCESS: 'Registro de eventos de seguridad actualizado correctamente',
    LOG_SECURITY_EVENTS_ERROR: 'Error al actualizar el registro de eventos de seguridad',
  },
  VPN: {
    ACTIVATE_IPSEC: 'Activar VPN IPsec',
    ACTIVATE_SSL: 'Activar VPN SSL',
    GROUPS: 'Grupos VPN',
  },
  DLP: {
    ADD_RULE: 'Añadir nueva regla DLP',
    NAME: 'Nombre',
    REGEX: 'Expresión Regular',
    RULES: 'Reglas',
    TABLE: {
      NAME: 'Nombre',
      REGEX: 'Expresión Regular',
      ACTIONS: 'Acciones',
      DESCRIPTION: 'Descripción',
    },
    DETAILS: 'Detalles',
    FILE_TYPES: 'Tipos de archivos',
    FILE_NAME: 'Nombre de archivo',
    FILE_NAMES: 'Nombres de archivo',
    CONTENT: 'Contenido',
    CONTENT_TOOLTIP:
      'Buscar los siguientes elementos dentro del contenido del archivo y del tráfico',
    FILE_TYPE_GROUPS: 'Grupos de tipos de archivo',
    FILE_NAME_GROUPS: 'Grupos de nombres de archivo',
    CONTENT_GROUPS: 'Grupos de contenidos de protocolo',
    FILE_TYPES_HELP: 'Seleciona los tipos de archivo permitidos',
    BASIC_MODE: 'Modo básico',
    REGEX_MODE: 'Modo regex',
    INSERT_BASIC_MODE: 'Inserta el nombre del archivo',
    INSERT_REGEX_MODE: 'Inserta la expresion regular del nombre del archivo',
    EXCLUDE_NAMES: 'Nombres excluidos',
    FILES: 'Archivos',
    HELP: 'Click para más información',
    PROTOCOL: 'Protocolo',
    RULE_NAME: 'Nombre de regla',
    ACTION: 'Acción',
    OPTIONS: 'Opciones',
    EDIT_RULE_TITLE: 'Editar regla DLP',
    ADD_RULE_TITLE: 'Añadir regla DLP',
    CONFIRM_DELETE: '¿Está seguro que desea borrar esta regla DLP?',
    SUCCESS_DELETE: 'Regla DLP eliminada correctamente',
    FILE_TYPES_PLACEHOLDER: 'Tipos de archivo...',
    FILE_NAMES_PLACEHOLDER: 'Nombres de archivo...',
    CONTENT_PLACEHOLDER: 'Contenido...',
    RULE_NAME_MISSING: 'Añada un nombre a la regla',
    CRITERIA_MISSING: 'Añada como mínimo un elemento a la regla',
    ADD_RULE_SUCCESS: 'Regla DLP creada correctamente',
    EDIT_RULE_SUCCESS: 'Regla DLP actualizada correctamente',
  },
  IPS_PROTECTION: {
    IPS_IDS_PROTECTION: 'Protección IPS/IDS',
    IDS_PROTECTION: 'Protección IDS',
    IPS_PROTECTION: 'Protección IPS',
    ANTIDOS_PROTECTION: 'Protección AntiDoS',
    UPDATE_SUCCESS: 'Protección IPS actualizada correctamente',
    UPDATE_ERROR: 'Error al actualizar la protección IPS',
    TABLE: {
      DESCRIPTION: 'Descripción',
      SEVERITY: 'Gravedad',
      OS: 'SO',
      ACTION: 'Acción',
      AFFECTED_APPS: 'Aplicaciones Afectadas',
      CVE_ID: 'ID CVE',
      UPDATED_AT: 'Fecha actualización',
      CREATED_AT: 'Fecha creación',
      TARGET: 'Destino',
      TYPE: 'Tipo',
      RULE_PACK: 'Pack de reglas',
      ACTIONS: 'Acciones',
    },
    ANTIDOS_TABLE: {
      NAME: 'Nombre',
      STATUS: 'Estado',
      ACTION: 'Acción',
      THRESHOLD: 'Umbral',
      COUNT: 'Cantidad',
      INTERVAL: 'Periodo',
    },
    ANTIDOS_FORM: {
      ADD_RULE: 'Añadir nueva regla AntiDoS',
      ADD_SUCCESS: 'Regla AntiDoS creada con éxito',
      ADD_ERROR: 'Error al crear regla AntiDoS',
      EDIT_RULE: 'Editar regla AntiDoS',
      EDIT_SUCCESS: 'Regla AntiDoS actualizada con éxito',
      EDIT_ERROR: 'Error al actualizar regla AntiDoS',
      CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta regla AntiDoS?',
      DELETE_SUCCESS: 'Regla AntiDoS eliminada con éxito',
      DELETE_ERROR: 'Error al eliminar regla AntiDoS',
      NAME: 'Nombre',
      STATUS: 'Estado',
      ACTION: 'Acción',
      PROTOCOL: 'Protocolo',
      TYPE: 'Tipo',
      TYPE_ICMP_ERROR:
        'El campo Servicios debe estar vacío al seleccionar el tipo ICMP flood en las reglas de AntiDoS',
      SOURCE: 'Origen',
      DESTINATION: 'Destino',
      TRACK_BY: 'Rastrear por',
      TRACK_BY_SOURCE: 'Origen',
      TRACK_BY_DESTINATION: 'Destino',
      THRESHOLD: 'Umbral',
      THRESHOLD_INVALID: 'Umbral solo permite valores entre {min} y {max}',
      INTERVAL_INVALID: 'Periodo solo permite valores entre {min} y {max}',
      ACTIONS: 'Acciones',
      ANY: 'Todos',
      MAX_NETWORKS_ERROR:
        'Se ha excedido el máximo número de redes y puertos permitidos en una regla AntiDoS',
    },
    ACTIVATE_OTSIGNATURES: 'Activar firmas OT',
    EXCEPTIONS: 'Excepciones',
    PROTECTION_TYPE: 'Tipo de protección',
    STRICT_MODE: 'Modo estricto',
    STRICT_MODE_WARNING:
      'Aviso. Al habilitar este modo, se bloqueará todo el tráfico que no coincida con las firmas de detección del IPS.',
    ADD_EXCEPTIONS: 'Añadir excepciones',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta regla?',
    DELETE_SUCCESS: 'Regla eliminada correctamente',
    ADD_SUCCESS: 'Regla añadida correctamente',
    ADD_ERROR: 'Error al crear regla',
    CONFIRM_EXCEPTION_DELETE:
      '¿Está seguro de que quiere eliminar esta excepción?',
    DELETE_EXCEPTION_SUCCESS: 'Excepción eliminada correctamente',
    ADD_EXCEPTION_SUCCESS: 'Excepción añadida correctamente',
    CHECK_SYNTAX: 'Comprueba la sintasis de la regla',
    ADD_RULE: 'Añadir nueva regla',
    ADD_RULE_HELP: 'Añadir las reglas de una en una',
    EDIT_RULE: 'Editar regla',
    CHANGE_ACTION: 'Cambiar Acción',
    EDIT_SUCCESS: 'Regla modificada correctamente',
    EDIT_ERROR: 'Error al modificar la regla',
    DUPLICATED_DESCRIPTION: 'La descripción de la regla ya se encuentra en uso',
  },
  ERRORS: {
    IP_REGISTERED: 'IP ya registrado',
    HOSTNAME_INVALID: 'Nombre de host inválido',
    IP_NOT_RESOLVED: 'Dirección IP no obtenida',
  },
  ANTIVIRUS: {
    TITLE_ANTIVIRUS: 'Antivirus',
    TITLE_ANTI_CNC: 'Anti Command & Control',
    TITLE_SANDBOX: 'Enviar archivos desconocidos a Sandbox',
    TITLE_FILE_BLACKLIST: 'Lista negra de archivos',
    MD5_HASHES_FILE_BLACKLIST: 'Lista de hashes MD5',
    MD5_HASHES_FILE_BLACKLIST_ERROR: 'Hashes MD5 no válidos',
    SUCCESS_UPDATE: 'Configuración actualizada correctamente',
    SUCCESS_ANTIVIRUS:
      'El estado del Antivirus se ha actualizado correctamente',
    SUCCESS_ANTI_CNC: 'El estado del Anti C&C se ha actualizado correctamente',
    SUCCESS_FILE_BLACKLIST:
      'El estado de la lista negra de archivos se ha actualizado correctamente',
    SUCCESS_MD5_HASHES:
      'El estado de la lista de hashes MD5 se ha actualizado correctamente',
    ERROR_INVALID_MD5_HASH: 'Hash MD5 no válido',
    ERROR_FETCH: 'Error al cargar las opciones de Antivirus y Anti C&C',
    ERROR_UPDATE:
      'Error mientras se modificaban las opciones de Antivirus y Anti C&C',
  },
  TIME: {
    FROM: 'Desde',
    TO: 'Hasta',
    AT: 'A',
    JANUARY: 'Enero',
    FEBRUARY: 'Febrero',
    MARCH: 'Marzo',
    APRIL: 'Abril',
    MAY: 'Mayo',
    JUNE: 'Junio',
    JULY: 'Julio',
    AUGUST: 'Agosto',
    SEPTEMBER: 'Septiembre',
    OCTOBER: 'Octubre',
    NOVEMBER: 'Noviembre',
    DECEMBER: 'Diciembre',
    MONDAY: 'Lunes',
    MEDIUM_MONDAY: 'Lun',
    SHORT_MONDAY: 'L',
    TUESDAY: 'Martes',
    MEDIUM_TUESDAY: 'Mar',
    SHORT_TUESDAY: 'M',
    WEDNESDAY: 'Miércoles',
    MEDIUM_WEDNESDAY: 'Mie',
    SHORT_WEDNESDAY: 'X',
    THURSDAY: 'Jueves',
    MEDIUM_THURSDAY: 'Jue',
    SHORT_THURSDAY: 'J',
    FRIDAY: 'Viernes',
    MEDIUM_FRIDAY: 'Vie',
    SHORT_FRIDAY: 'V',
    SATURDAY: 'Sábado',
    MEDIUM_SATURDAY: 'Sáb',
    SHORT_SATURDAY: 'S',
    SUNDAY: 'Domingo',
    MEDIUM_SUNDAY: 'Dom',
    SHORT_SUNDAY: 'D',
    NEXT_MONTH: 'Mes siguiente',
    PREV_MONTH: 'Mes anterior',
    OPEN_MONTH: 'Abrir selector de mes',
    OPEN_YEAR: 'Abrir selector de año',
    CLOSE_MONTH: 'Cerrar selector de mes',
    CLOSE_YEAR: 'Cerrar selector de año',
    DEFAULT_PLACEHOLDER: 'Seleccionar...',
    FIRST_DAY_OF_WEEK: 'Lunes',
    DAYS: 'Días',
    TIMEZONE: 'Zona horaria',
    DAILY: 'Diario',
    WEEKLY: 'Semanal',
    MONTHLY: 'Mensual',
    YEARLY: 'Anual',
    DAYS_OF_WEEK: 'Días de la semana',
    MONTHS: 'Meses',
    WEEKS: 'Semanas',
    DAYS_OF_MONTH: 'Días del mes',
    LAST_DAY_OF_MONTH: 'Último día',
    HOUR: 'Hora',
    YEARS: 'Años',
  },
  LICENSES: {
    TYPE: 'Tipo',
    NUMBER: 'Número',
    VALIDITY: 'Validez',
    VALIDITY_INVALID: 'Validez no válida',
    ALLOCATION: 'Distribución',
    AVAILABLE: 'Available',
    AVAILABLE_USERS: 'Usuarios disponibles',
    AVAILABLE_DEVICES: 'Dispositivos disponibles',
    TOTAL: 'Total',
    CLOSE_TO_EXPIRY: 'Cerca de caducar',
    EXPIRED: 'Caducados',
    USED: 'En uso',
    TIME_CONSUMPTION: 'Tiempo consumido',
    LICENSE_TYPE: 'Tipo de licencia',
    NUMBER_DEVICES: 'Número de dispositivos',
    NUMBER_LICENSES: 'Número de licencias',
    CREATED: 'Licencia creada con éxito',
    ADD_LICENSE: 'Añadir licencia',
    LOAD_FILE: 'Cargar archivo',
    ACTIVATE: 'Activar licencia',
    UPLOAD: 'Subir archivo .txt',
    EXPIRATION_DATE: 'Fecha de expiración',
    ASSIGN_DATE: 'Fecha de asignación',
    NO_LICENSES_AVAILABLE: 'Sin licencias',
    ADD: 'Añadir licencia',
    DEVICE_CLOUD_UUID: 'Dispositivo cloud',
    TRIAL_PERIOD: 'Periodo de prueba',
    EXPIRED_TOOLTIP: 'Esta licencia ha caducado',
    CLOSE_TO_EXPIRY_TOOLTIP: 'Esta licencia caducará en un mes o menos',
    CONFIRM_ERROR: 'Error al eliminar la licencia caducada',
    CONFIRM_DELETE:
      '¿Está seguro de que quiere eliminar esta licencia caducada?',
    SUCCESS_DELETE: 'Licencia caducada eliminada correctamente',
    ADMIN_CONFIRM_ERROR: 'Error al eliminar la licencia',
    ADMIN_CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta licencia?',
    ADMIN_SUCCESS_DELETE: 'Licencia eliminada correctamente',
    SELECT_ALL_UTM: 'Seleccionar todas las licencias UTM',
    SELECT_ALL_CLOUD: 'Seleccionar todas las licencias Cloud',
    DELETE_ALL_EXPIRED_LICENSES: 'Elimina todas las licencias expiradas',
    DELETE_ALL_CONFIRM_ERROR: 'Error al eliminar todas las licencias caducadas',
    DELETE_ALL_CONFIRM_DELETE:
      '¿Está seguro de que quiere eliminar todas las licencias caducadas?',
    DELETE_ALL_SUCCESS_DELETE: 'Licencias caducadas eliminadas correctamente',
    LICENSE_DETECTED: 'Licencia detectada',
    LICENSE_NOT_FOUND: 'Licencia no encontrada',
    FILE_ERROR: 'El fichero tiene errores',
    LICENSE_INVALID: 'Licencia no válida',
    LICENSE_EMPTY: 'El tipo de la licencia no puede estar vacío',
    TENANT_INVALID: 'La licencia no corresponde a este tenant',
    DATA_INVALID: 'La licencia tiene datos no válidos',
    ALREADY_ACTIVATED: 'Licencia ya activada',
    SSE_USERS: 'Usuarios SSE',
    ASSIGN_LICENSES: 'Asignar licencias',
    ERROR_NO_LICENSES: 'No se ha seleccionado ninguna licencia',
    LICENSES_MANAGER: 'Gestor de licencias',
    LICENSES_ASSIGNED: 'Licencias asignadas',
    IPSOT_WITH_IPS: 'Licencias IPS OT requieren licencias IPS',
    NUMBER_INFO:
      'El número de licencias depende de los usuarios en el caso de licencias SSE y de los dispositivos en el resto de licencias',
    N_DEVICES: '{n} Dispositivos',
    N_USERS: '{n} Usuarios',
    SELECT_TENANT: 'Selecciona un tenant',
    SUCCESS_ADD: 'Licencia añadida con éxito',
    ERROR_ADD: 'Error al añadir licencia',
    NUM_FIELD_REQUIRED: 'El campo número de licencias es obligatorio',
    NUM_FIELD_INVALID: 'El campo número de licencias es inválido',
    TI_REGISTRATION_FAILED: 'Error en el registro de Threat Intelligence',
    TI_SYNC_FAILED: 'Error en la sincronización de Threat Intelligence',
    DEVICE_LIMIT_EXCEEDED:
      'Se ha alcanzado el límite de dispositivos de la licencia. Esta licencia no tiene plazas libres para más dispositivos.',
    TI_DELETION_FAILED:
      'Error en la eliminación de licencia de Threat Intelligence',
    LM_SERIAL_NUMBER: 'Número de Serie',
    LM_LICENSE_CODE: 'Código de Licencia',
    LM_SERIAL_PLACEHOLDER: 'ej. XXXX-XXXX-XXXX-XXXX',
    LM_CODE_PLACEHOLDER: 'Introduce tu código de licencia',
    LM_VALIDATE_AND_ACTIVATE: 'Validar y Activar',
    LM_DESCRIPTION: 'Introduce el número de serie y el código de licencia proporcionado por tu gestor de licencias para activar tu producto.',
    SOURCE: 'Procedencia',
    SOURCE_LM: 'License Manager',
    SOURCE_FILE: 'Fichero',
    SOURCE_LM_LICENSE_ID: 'Licencia LM {id}',
    SOURCE_LM_PACKAGE_ID: 'Paquete LM {id}',
    NO_ACTIVE_ARGUS_LICENSE:
      'No se encontró ninguna licencia de Argus activa. Active una licencia de Argus en Administración -> Licencias.',
    SEAT_QUOTA_EXCEEDED:
      'Todos los puestos de licencia de Argus están en uso. Aumente la capacidad de su licencia en Administración -> Licencias.',
  },
  RESELLER_LICENSES: {
    SUCCESS_ASSIGN: 'Licencia asignada con éxito',
    ERROR_ASSIGN: 'Error al asignar licencia',
    INVALID_RESELLER: 'El distribuidor no es válido para la licencia',
    UNSHAREABLE_ERROR: 'Número de licencias excedidas',
    USERS_NUMBER_ERROR: 'El número de usuarios debe ser un múltiplo de 10',
    CONFIRM_ERROR: 'Error al eliminar la licencia del distribuidor',
    CONFIRM_DELETE:
      '¿Está seguro de que quiere eliminar esta licencia del distribuidor?',
    SUCCESS_DELETE: 'Licencia del distribuidor eliminada correctamente',
  },
  REPORTS: {
    FILTER: 'Filtro',
    FROM: 'Desde',
    TO: 'Hasta',
    FEATURES: 'Características',
    GENERAL: 'General',
    IPS: 'IPS',
    DLP: 'DLP',
    THROUGHPUT: 'Rendimiento',
    WEBFILTER: 'Filtro Web',
    APPLICATIONS: 'Aplicaciones',
    INTERFACES: 'Interfaces',
    ANTIVIRUS: 'Antivirus',
    VIEW: 'Ver',
    HIDE: 'Esconder',
    DOWNLOAD: 'Descargar',
    SCHEDULE: 'Programar',
    SCHEDULE_NEW_REPORT: 'Programar nuevo informe',
    SCHEDULED_REPORTS: 'Informes Programados',
    TASK_NAME: 'Nombre de tarea',
    TASK_NAME_PLACEHOLDER: 'Nombre de tarea...',
    PERIOD: 'Periodo',
    TIMEFRAME: 'Periodo de tiempo',
    ALL: 'Todo',
    GENERATE: 'Generar',
    USER: 'Usuarios',
    NETWORK: 'Redes',
    NETWORK_RANGE: 'Rangos de Red',
    GEOLOCATION: 'Geolocalizaciones',
    FQDN: 'FQDN',
    MAC: 'MAC',
    TOP_SUBCATEGORY_ACTION: 'Top 10 Subcategorías por Acción',
    TOP_SUBCATEGORY_SRC_IP: 'Top 10 IPs de origen por Subcategoría',
    REPORTS_TEMPLATES: 'Plantillas de informes',
    TRAFFIC_BY_APPLICATION: 'Tráfico por Aplicación',
    REPORT_PREVIEW: 'Previsualización de informe',
    ZTNA: 'ZTNA',
  },
  REPORTS_TEMPLATES: {
    NAME: 'Nombre',
    FROM: 'Desde',
    TO: 'Hasta',
    SOURCES: 'Origen',
    DESTINATIONS: 'Destino',
    DESTINATION_PORT: 'Puerto de destino',
    APPLICATIONS: 'Aplicaciones',
    HOSTNAME: 'Nombre del host',
    CATEGORIES: 'Categorías',
    FEATURES: 'Características',
    ADD: 'Añadir plantilla de informe',
    EDIT: 'Editar plantilla de informe',
    ADD_SUCCESS: 'Plantilla de informe creada correctamente',
    ADD_ERROR: 'Error al crear una plantilla de informe',
    EDIT_SUCCESS: 'Plantilla de informe actualizada correctamente',
    EDIT_ERROR: 'Error al editar una plantilla de informe',
    DELETE_SUCCESS: 'Plantilla de informe eliminada correctamente',
    DELETE_ERROR: 'Error al eliminar una plantilla de informe',
    REQUIRED_FIELDS_ERROR: 'Por favor complete todos los campos requeridos',
    REQUIRED_NAME_ERROR: 'Nombre obligatorio',
    REQUIRED_FROM_ERROR: 'Fecha de inicio obligatoria',
    REQUIRED_TO_ERROR: 'Fecha de finalización obligatoria',
    REQUIRED_FEATURES_ERROR: 'Seleccione al menos una característica',
    FROM_AFTER_TO_ERROR:
      'La fecha de inicio no puede ser posterior a la fecha de finalización',
    ERROR_DUPLICATED_NAME: 'Este nombre ya existe',
  },
  EMAIL: {
    TO: 'Para',
    CC: 'CC',
    BCC: 'CCO',
    SUBJECT: 'Asunto',
    CONTENT: 'Contenido',
  },
  SCHEDULED_REPORTS: {
    CONFIRM_DELETE:
      '¿Está seguro de que quiere eliminar este informe programado?',
    CRON: 'Programación',
    DISCARD: 'Descartar',
    EDIT_SCHEDULED: 'Editar informe programado',
    EMAILS: 'Correos',
    ERROR_DELETE: 'Error al eliminar informe programado',
    ERROR_FETCH: 'Error al obtener informes programados',
    INVALID_FEATURES: 'Debe seleccionar al menos una característica',
    INVALID_HOUR: 'Hora inválida',
    INVALID_PERIOD: 'Periodo inválido',
    LAST_EXEC: 'Última ejecución',
    NAME: 'Nombre',
    NEW_SCHEDULED: 'Programar nuevo informe',
    NEXT_EXEC: 'Siguiente ejecución',
    SAVE: 'Guardar cambios',
    STATUS: 'Estado',
    SUCCESS_DELETE: 'Informe programado eliminado correctamente',
  },
  STATIC_ROUTES: {
    ADD: 'Añadir nueva Ruta Estática',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta ruta estática?',
    DISTANCE: 'Distancia',
    DISTANCE_RANGE: 'La distancia debe estar entre 1 y 255',
    DUPLICATE_NAME: 'Nombre ya se encuentra en uso',
    EDIT: 'Editar Ruta Estática',
    ERROR_CREATE: 'Error al crear la ruta estática',
    ERROR_DELETE: 'Error al eliminar ruta estática',
    ERROR_UPDATE: 'Error al actualizar la ruta estática',
    ERROR_FETCH: 'Error obteniendo las rutas estáticas',
    ERROR_GATEWAY_INTERFACE: 'Debe haber una puerta de enlace o interface',
    GATEWAY: 'Puerta de Enlace',
    NAME: 'Nombre',
    NETWORK: 'Red',
    INTERFACE: 'Interfaz',
    REQUIRE_SUBNET: 'La subnet es obligatoria',
    SUCCESS_CREATE: 'Ruta estática creada correctamente',
    SUCCESS_DELETE: 'Ruta estática eliminada correctamente',
    SUCCESS_UPDATE: 'Ruta estática actualizada correctamente',
  },
  LICENSE_TYPES: {
    BS: 'Cloud',
    UTM_R: 'UTM para RS y TE-100 series',
    UTM_M: 'UTM para M, Celer, Regesta, TE-200 y TE-220 series',
    UTM_A: 'UTM para Atlas y TE-400 series',
    UTM_M20: 'UTM para M20',
    UTM_H5A: 'UTM para H5 Auto',
    UTM_H5R: 'UTM para H5 Rail',
    UTM_V: 'UTM para VM series',
    UTM_S: 'UTM para SDE series',
    UTM_F: 'UTM para Ares y TE-600 series',
    AS: 'Antispam',
    AV: 'Antivirus',
    AC: 'Control de aplicaciones',
    DLP: 'DLP / Filtro de contenido',
    FW: 'Firewall',
    IPS: 'IDS/IPS',
    IPSOT: 'IDS/IPS OT',
    SSL: 'Inspección SSL',
    ZTNA: 'ZTNA',
    ZTNAAGL: 'ZTNA Agentless',
    ARGUS: 'Argus',
    RA: 'Acceso Remoto',
    UF: 'Filtro Web',
    CB: 'CASB',
    DNS: 'Filtro DNS',
    UID: 'Identificación de usuario',
    VPNTUN: 'Túnel VPN',
    SSE: 'SSE Basado en Usuario',
    USER_BASED: '{license} Basado en Usuario',
    N_USERS: '{n} usuarios',
    SSE_MULTIPLIER_ERROR:
      'El multiplicador de una licencia SSE no puede exceder {maxMultiplier}',
  },
  COUNTRIES: {
    '-': 'Desconocido',
    US: 'Estados Unidos de América',
    CN: 'China',
    AU: 'Australia',
    JP: 'Japón',
    TH: 'Tailandia',
    IN: 'India',
    MY: 'Malasia',
    KR: 'Corea (República de)',
    SG: 'Singapur',
    HK: 'Hong Kong',
    TW: 'Taiwan (Provincia de China)',
    KH: 'Camboya',
    PH: 'Filipinas',
    VN: 'Viet Nam',
    NO: 'Noruega',
    BR: 'Brasil',
    AR: 'Argentina',
    PS: 'Palestina, Estado de',
    ES: 'España',
    FR: 'Francia',
    NL: 'Países Bajos',
    CZ: 'Chequia',
    DE: 'Alemania',
    AT: 'Austria',
    CH: 'Suiza',
    GB: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
    IT: 'Italia',
    GR: 'Grecia',
    RU: 'Federación de Rusia',
    IE: 'Irlanda',
    DK: 'Dinamarca',
    PT: 'Portugal',
    SE: 'Suecia',
    GH: 'Ghana',
    CM: 'Camerún',
    BE: 'Bélgica',
    ZA: 'Sudáfrica',
    FI: 'Finlandia',
    TR: 'Turquía',
    AE: 'Emiratos Árabes Unidos',
    HU: 'Hungría',
    PL: 'Polonia',
    JO: 'Jordania',
    RO: 'Rumania',
    UG: 'Uganda',
    AM: 'Armenia',
    TZ: 'Tanzania, República Unida de',
    BI: 'Burundi',
    UY: 'Uruguay',
    CL: 'Chile',
    LU: 'Luxemburgo',
    PE: 'Perú',
    BG: 'Bulgaria',
    UA: 'Ucrania',
    EG: 'Egipto',
    CA: 'Canadá',
    IL: 'Israel',
    QA: 'Qatar',
    MD: 'Moldavia (República de)',
    SC: 'Seychelles',
    IQ: 'Irak',
    LV: 'Letonia',
    UZ: 'Uzbekistán',
    SK: 'Eslovaquia',
    KZ: 'Kazajistán',
    GE: 'Georgia',
    EE: 'Estonia',
    HR: 'Croacia',
    AL: 'Albania',
    LT: 'Lituania',
    SA: 'Arabia Saudi',
    MT: 'Malta',
    CR: 'Costa Rica',
    CY: 'Chipre',
    IR: 'Irán (República Islámica de)',
    ID: 'Indonesia',
    BH: 'Baréin',
    MX: 'México',
    CO: 'Colombia',
    SY: 'República Árabe Siria',
    LB: 'Líbano',
    ZM: 'Zambia',
    ZW: 'Zimbabue',
    OM: 'Omán',
    RS: 'Serbia',
    IS: 'Islandia',
    SI: 'Eslovenia',
    MK: 'Macedonia del Norte',
    LI: 'Liechtenstein',
    JE: 'Jersey',
    BA: 'Bosnia y Herzegovina',
    AZ: 'Azerbaiyán',
    KG: 'Kirguistán',
    IM: 'Isla de Man',
    GG: 'Guernsey',
    GI: 'Gibraltar',
    LY: 'Libia',
    YE: 'Yemen',
    BY: 'Bielorrusia',
    RE: 'Reunión',
    MQ: 'Martinica',
    KW: 'Kuwait',
    LK: 'Sri Lanka',
    SZ: 'Suazilandia',
    CD: 'Congo (República Democrática del)',
    GP: 'Guadalupe',
    BD: 'Bangladesh',
    BT: 'Bután',
    BN: 'Brunei Darussalam',
    PM: 'San Pedro y Miquelón',
    PA: 'Panamá',
    LA: 'Lao (República Democrática Popular)',
    GU: 'Guam',
    MP: 'Islas Marianas del Norte',
    DO: 'República Dominicana',
    NG: 'Nigeria',
    NZ: 'Nueva Zelanda',
    EC: 'Ecuador',
    VE: 'Venezuela (República Bolivariana de)',
    PR: 'Puerto Rico',
    VI: 'Islas Vírgenes (E.E.U.U.)',
    PK: 'Pakistán',
    MN: 'Mongolia',
    PG: 'Papua Nueva Guinea',
    TL: 'Timor Oriental',
    SB: 'Islas Salomón',
    VU: 'Vanuatu',
    FJ: 'Fiji',
    CK: 'Islas Cook',
    TO: 'Tonga',
    NP: 'Nepal',
    KE: 'Kenia',
    MO: 'Macao',
    NI: 'Nicaragua',
    JM: 'Jamaica',
    TT: 'Trinidad y Tobago',
    LS: 'Lesoto',
    AF: 'Afganistán',
    MA: 'Marruecos',
    GD: 'Granada',
    VG: 'Islas Vírgenes (Británicas)',
    KN: 'San Cristóbal y Nieves',
    AG: 'Antigua y Barbuda',
    VC: 'San Vicente y las Granadinas',
    BS: 'Bahamas',
    DM: 'Dominica',
    KY: 'Islas Caimán',
    LC: 'Santa Lucía',
    MM: 'Birmania',
    BB: 'Barbados',
    PY: 'Paraguay',
    GT: 'Guatemala',
    UM: 'Islas Ultramarinas Menores de los Estados Unidos',
    TM: 'Turkmenistán',
    TK: 'Tokelau',
    MV: 'Maldivas',
    NC: 'Nueva Caledonia',
    WF: 'Wallis y Futuna',
    SM: 'San Marino',
    ME: 'Montenegro',
    SV: 'El Salvador',
    AD: 'Andorra',
    MC: 'Mónaco',
    BO: 'Bolivia (Estado Plurinacional de)',
    GL: 'Groenlandia',
    TJ: 'Tayikistán',
    FO: 'Islas Feroe',
    MF: 'San Martín (Parte Francesa)',
    LR: 'Liberia',
    MU: 'Mauricio',
    BW: 'Botsuana',
    MZ: 'Mozambique',
    TN: 'Túnez',
    MG: 'Madagascar',
    AO: 'Angola',
    NA: 'Namibia',
    CI: 'Costa de Marfil',
    SD: 'Sudán',
    MW: 'Malaui',
    GA: 'Gabón',
    ML: 'Mali',
    BJ: 'Benín',
    CV: 'Cabo Verde',
    RW: 'Ruanda',
    CG: 'Congo',
    GM: 'Gambia',
    GN: 'Guinea',
    BF: 'Burkina Faso',
    SO: 'Somalia',
    SL: 'Sierra Leona',
    NE: 'Niger',
    CF: 'República Centroafricana',
    TG: 'Togo',
    SS: 'Sudán del Sur',
    GQ: 'Guinea Ecuatorial',
    SN: 'Senegal',
    DZ: 'Algeria',
    AS: 'Samoa Americana',
    MR: 'Mauritania',
    DJ: 'Yibuti',
    KM: 'Comoras',
    IO: 'Territorio Británico del Océano Índico',
    TD: 'Chad',
    YT: 'Mayotte',
    NR: 'Nauru',
    WS: 'Samoa',
    FM: 'Micronesia (Estados Federados de)',
    PF: 'Polinesia Francesa',
    HN: 'Honduras',
    BM: 'Bermuda',
    BZ: 'Belice',
    CW: 'Curazao',
    AX: 'Islas Aland',
    GF: 'Guayana Francesa',
    NU: 'Niue',
    TV: 'Tuvalu',
    PW: 'Palaos',
    MH: 'Islas Marshall',
    KI: 'Kiribati',
    KP: 'Corea (República Democrática Popular de)',
    AW: 'Aruba',
    CU: 'Cuba',
    HT: 'Haití',
    SR: 'Surinam',
    GY: 'Guyana',
    VA: 'Santa Sede',
    ST: 'Santo Tomé y Príncipe',
    ET: 'Etiopía',
    ER: 'Eritrea',
    GW: 'Guinea-Bissau',
    FK: 'Islas Malvinas (Falkland)',
    AI: 'Anguila',
    TC: 'Islas Turcas y Caicos',
    SX: 'Sint Maarten (Parte Neerlandesa)',
    BV: 'Isla Bouvet',
    SJ: 'Svalbard y Jan Mayen',
    BL: 'San Bartolomé',
    NF: 'Isla Norfolk',
    MS: 'Montserrat',
    BQ: 'Bonaire, San Eustaquio y Saba',
    GS: 'Islas Georgias del Sur y Sandwich del Sur',
    PN: 'Islas Pitcairn',
    SH: 'Santa Elena, Ascensión y Tristán de Acuña',
  },
  DHCP_CONFIGS: {
    MAXIMUM_REACHED: 'Sólo se permiten 5 rangos DHCP',
    SUCCESS_CREATE: 'Configuración DHCP creada con éxito',
    ERROR_CREATE: 'Error al crear configuración DHCP',
    SUCCESS_UPDATE: 'Configuración DHCP actualizada con éxito',
    ERROR_UPDATE: 'Error al actualizar configuración DHCP',
    SUCCESS_DELETE: 'Configuración DHCP eliminada con éxito',
    ERROR_DELETE: 'Error al eliminar configuración DHCP',
    MISSING_NAME: 'Falta el nombre',
    DUPLICATED_NAME: 'El nombre ya se encuentra en uso',
    MISSING_SUBNET: 'Falta la subred',
    MISSING_START_IP: 'Falta la IP de inicio',
    MISSING_END_IP: 'Falta la IP de fin',
    SUBNET_ERROR: 'La subred es inválida',
    SUBNET_IN_RANGE:
      'La dirección IP no debe estar dentro del rango de direcciones dado',
    START_IP_ERROR: 'La IP de inicio del rango de direcciones es inválida',
    START_IP_NOT_IN_SUBNET_ERROR:
      'La IP de inicio del rango de direcciones no se encuentra dentro de la subred dada',
    START_IP_WRONG_VALUE:
      'La IP de inicio del rango de direcciones no debe ser el inicio de la subred dada',
    END_IP_ERROR: 'La IP de fin del rango de direcciones es inválida',
    END_IP_NOT_IN_SUBNET_ERROR:
      'La IP de fin del rango de direcciones no se encuentra dentro de la subred dada',
    INCORRECT_IP_RANGE: 'El rango de direcciones ha de ser ascendente',
    EQUAL_IP_RANGE:
      'La IP de inicio y la IP de fin del rango de direccion han de ser distintas',
    ROUTER_ERROR: 'El router por defecto es inválido',
    PRIMARY_DNS_ERROR: 'El servidor DNS primario es inválido',
    SECONDARY_DNS_ERROR: 'El servidor DNS secundario es inválido',
    INVALID_RANGES: 'Uno o más rangos inválido/s',
    REQUIRED_START_IP: 'IP Inicio requerida',
    REQUIRED_END_IP: 'IP Fin requerida',
    INVALID_START_IP: 'IP Inicio inválida',
    INVALID_END_IP: 'IP Fin inválida',
    INVALID_INTERFACE: 'Interfaz no valida',
    DEFAULT_ROUTER: {
      BAD_IPV4_BLOCK: 'Default Router is invalid',
      NOT_IN_SUBNET:
        'El Router por defecto no se encuentra dentro de la subred dada',
      IP_ADDRESS_IN_RANGE:
        'El Router por defecto no debe estar dentro del rango de direcciones dado',
      START_IP_WRONG_VALUE:
        'El Router por defecto no debe ser el inicio de la subred dada',
    },
  },
  DHCP_CONFIG_RANGES: {
    MAXIMUM_REACHED: 'Sólo se permiten 5 rangos DHCP',
    START_IP: {
      IP_TAKEN: 'IP inicio ya asignada en otro rango',
      BLANK: 'IP inicio no puede ser vacía',
    },
    END_IP: {
      IP_TAKEN: 'IP fin ya asignada en otro rango',
      BLANK: 'IP fin no puede ser vacía',
    },
  },
  FIREWALL: {
    TITLE: 'Proteccion de Firewall',
    EMPTY_SOURCE_NOT_ALLOWED:
      'Las reglas de firewall deben tener al menos una fuente',
    EMPTY_SOURCE: 'EMPTY_SOURCE',
    EMPTY_SOURCE_MUST_DISMISS:
      'Quita el estado EMPTY_SOURCE antes de activar la regla.',
    ADD_RULE_TITLE: 'Añadir nueva regla firewall',
    ADD_SUCCESS: 'Regla firewall creada con éxito',
    ADD_ERROR: 'Error al crear regla firewall',
    EDIT_RULE_TITLE: 'Editar regla firewall',
    EDIT_SUCCESS: 'Regla firewall actualizada con éxito',
    EDIT_ERROR: 'Error al actualizar regla firewall',
    NAME: 'Nombre',
    NAME_PLACEHOLDER: 'Nombre de la regla...',
    SOURCE: 'Origen',
    SOURCE_PLACEHOLDER: '2.2.2.2/24:24',
    SOURCE_ERROR: 'Al menos uno de los orígenes es inválido',
    DESTINATION: 'Destino',
    DESTINATION_PLACEHOLDER: '2.2.2.2/24:24',
    DESTINATION_ERROR: 'Al menos uno de los destinos es inválido',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta regla firewall?',
    DELETE_SUCCESS: 'Regla firewall eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar regla firewall',
    ACTION: 'Acción',
    PASS: 'Permitir',
    DROP: 'Bloquear',
    STATUS: 'Estado',
    ORDER: 'Orden',
    ID: 'ID',
    SUBRULE_IDS: 'IDs de subregla',
    ASSOCIATED_CONNMARKS: 'Connmarks asociados',
    SUBRULE_ALLOWED_CUSTOM: 'Categorías personalizadas permitidas',
    SUBRULE_ALLOWED_PREDEFINED: 'Categorías predefinidas permitidas',
    SUBRULE_ANY_SERVICES: 'Servicios no HTTP/HTTPS',
    ACTIONS: 'Opciones',
    ADD_RULE_ABOVE: 'Añadir regla arriba',
    ADD_RULE_BELOW: 'Añadir regla debajo',
    ADD_RULE_TOP: 'Añadir regla al principio',
    ADD_RULE_BOTTOM: 'Añadir regla al final',
    CONFIRM_DELETE_NETWORK: '¿Está seguro de que quiere eliminar la red',
    CONFIRM_DELETE_NETWORKS_GROUP:
      '¿Está seguro de que quiere eliminar el grupo de redes?',
    SERVICES: 'Servicios',
    ANY: 'Todos',
    LOCAL: 'LOCAL',
    PROTOCOL: 'Protocolo',
    INTERFACE: 'Interfaces',
    INCOMING_INTERFACES: 'Interfaces de entrada',
    PROFILES: 'Perfiles',
    SHOW_SYSTEM_RULES: 'Mostrar reglas del sistema',
    SYSTEM_RULES_TITLE: 'Reglas implícitas',
    USER_RULES_TITLE: 'Reglas de usuario',
    INVALID_NAME: 'Nombre inválido',
    INVALID_DESCRIPTION:
      'Caracteres inválidos. Caracteres válidos: letras, números y - _ / # @ $ & * ( ) %',
    INVALID_DESCRIPTION_LENGTH: 'Longitud de descripción inválida',
    INVALID_NAME_LENGTH: 'Longitud de nombre debe ser entre 2 y 58 caracteres',
    MASQUERADE_SNAT_NOT_ALLOWED_ON_DROP:
      'Masquerade SNAT no puede activarse cuando la acción es Drop',
    INVALID_ORDER: 'Orden inválido',
    CHANGE_ORDER: 'Cambiar Orden',
    ENABLE_SCHEDULE: 'Regla activada por el programador.',
    DISABLE_SCHEDULE: 'Regla desactivada por el programador.',
    INVALID_SCHEDULE_LENTGH: 'La regla solo puede tener una programación',
    DEVICES_UNSYNCHRONIZED: 'Dispositivos desincronizados: {devices}',
    SSL_PROFILE_INCOMPATIBLE_INTERFACES:
      'Perfil SSL no se puede usar con interfaces bridge',
    SSL_PROFILE_MISSING_INTERFACES:
      'Perfil SSL debe usarse con interfaces de entrada',
    SSL_PROFILE_PROTOCOL_ERROR:
      'Perfil SSL sólo se puede usar con HTTPS, POP3S y SMTPS',
    WEB_FILTER_SERVICES_REQUIRED:
      'Los servicios no pueden ser "Any" cuando se selecciona un perfil de filtro web y el filtro web dinámico está habilitado',
    NOT_EDITABLE: 'No se pueden editar reglas implícitas del sistema',
    LOG_SESSIONS: 'Registrar sesiones',
    LOG_DROPPED_PACKETS: 'Registrar paquetes descartados',
  },
  NAT: {
    TITLE: 'Reglas NAT',
    ADD_RULE_TITLE: 'Añadir regla NAT',
    EDIT_RULE_TITLE: 'Editar regla NAT',
    NAME: 'Nombre',
    NAME_PLACEHOLDER: 'Nombre de la regla NAT...',
    SOURCE: 'Origen NAT (SNAT)',
    DESTINATION: 'Destino NAT (DNAT)',
    TYPE: 'Tipo NAT',
    SERVICES: 'Puerto de redirección DNAT',
    STATIC: 'Estático',
    DYNAMIC: 'Dinámico',
    AUTO: 'Enmascarado',
    AUTO_DESCRIPTION: 'Usar automáticamente la IP de la interfaz de salida',
    SERVICES_TYPE_ERROR: 'Todos los tipos de servicio deben ser el mismo',
    NAT_SERVICES_TYPE_ERROR:
      'El tipo de los servicios debe ser el mismo que el de los servicios NAT',
    SERVICES_PORT_ERROR:
      'Servicios y servicios NAT deben tener un puerto cada uno',
    NAT_FIELD_REQUIRED:
      'Es obligatorio rellenar el campo origen NAT o destino NAT',
    MAX_SOURCE_NAT: 'El número máximo de origenes NAT es 1',
    MAX_DESTINATION_NAT: 'Max nat destination elements is 1',
    MAX_SERVICE_NAT: 'El número máximo de servicios NAT es 1',
    SERVICE_NAT_GROUPS_ERROR: 'Los servicios NAT no pueden tener grupos',
    INTERNAL_INTERFACE: 'Interfaz de salida',
    EXTERNAL_INTERFACE: 'Interfaz de entrada',
    MAX_INTERNAL_INTERFACE: 'El número máximo de interfaces de salida es 1',
    MAX_EXTERNAL_INTERFACE: 'El número máximo de interfaces de entrada es 1',
    UNDELETED_ENTITY: 'La regla no se ha podido eliminar',
    UNPROCESSED_ENTITY: 'La regla no se ha podido procesar',
  },
  OBJECT_EXPLORER: {
    NETWORK_ELEMENTS: 'Elementos de red',
    NETWORKS: 'Redes',
    NETWORK: 'Red',
    NETWORK_IPV4: 'Red IPv4',
    NETWORK_IPV6: 'Red IPv6',
    NETWORK_GROUPS: 'Grupos de Red',
    NETWORK_GROUP: 'Grupo de Red',
    NETWORK_GROUP_ADD: 'Añadir nuevo Grupo de Red',
    NETWORK_GROUP_EDIT: 'Editar Grupo de Red',
    SERVICES: 'Servicios',
    FQDN: 'FQDN',
    FQDN_PLACEHOLDER: 'FQDN...',
    FQDN_ADD: 'Añadir nuevo FQDN',
    FQDN_GROUP: 'Grupo de FQDN',
    FQDN_GROUP_ADD: 'Añadir nuevo Grupo de FQDN',
    FQDN_GROUP_EDIT: 'Editar Grupo de FQDN',
    GEOLOCATION: 'Geolocalización',
    GEOLOCATION_GROUP: 'Grupo de Geolocalización',
    GEOLOCATION_GROUP_ADD: 'Añadir nuevo Grupo de Geolocalización',
    GEOLOCATION_GROUP_EDIT: 'Editar Grupo de Geolocalización',
    IP: 'Dirección IP',
    IPV4: 'Dirección IPV4',
    IPV6: 'Dirección IPV6',
    IPV4_LIST: 'Direcciones IPV4',
    IPV6_LIST: 'Direcciones IPV6',
    IPV4_ERROR: 'La dirección IPV4 no es válida',
    IP_RANGE: 'Rango de Direcciones IP',
    NETWORK_IPV4_RANGE: 'Rango de IPv4',
    NETWORK_IPV6_RANGE: 'Rango de IPv6',
    MAC: 'Direcciones MAC',
    MAC_GROUP_ADD: 'Añadir nuevo Grupo de Direcciones MAC',
    MAC_GROUP_EDIT: 'Editar Grupo de Direcciones MAC',
    USERS: 'Usuarios',
    USERS_GROUP: 'Grupo de Usuarios',
    USER_GROUP_ADD: 'Añadir nuevo Grupo de Usuarios',
    USER_GROUP_EDIT: 'Editar Grupo de Usuarios',
    NETWORK_RANGE: 'Rango de IPs',
    NETWORK_RANGE_GROUP_ADD: 'Añadir nuevo Grupo de Rango de IPs',
    NETWORK_RANGE_GROUP_EDIT: 'Editar  Grupo de Rango de IPs',
    GROUPS: 'Grupos',
    SCHEDULES: 'Programaciones',
    SCHEDULE: 'Programación',
    ALL_DAY: 'Todo el día',
    START_TIME: 'Hora de inicio',
    STOP_TIME: 'Hora de parada',
    WEEKDAYS_ERROR: 'Debes seleccionar al menos un día de la semana',
    TIME_ERROR:
      'Debes seleccionar una hora de parada posterior a la hora de inicio',
    ALREADY_IN_USE:
      "El objeto no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    ALREADY_IN_USE_GROUP:
      "El objeto no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Grupos'.",
    ALREADY_IN_USE_DNS:
      'El objeto no se puede eliminar porque se está usando en una configuración de DNS.',
    OBJECT_LIST: 'Lista de objetos',
    EXCLUDED_OBJECT_LIST: 'Lista de objetos excluídos',
    EDIT_NOT_ALLOWED: 'No tienes permitido modificar objetos precargados',
    DELETE_NOT_ALLOWED: 'No tienes permitido eliminar objetos precargados',
    TCP_SERVICE_GROUP_ADD: 'Añadir nuevo Grupo de servicios TCP',
    TCP_SERVICE_GROUP_EDIT: 'Editar Grupo de servicios TCP',
    UDP_SERVICE_GROUP_ADD: 'Añadir nuevo Grupo de servicios UDP',
    UDP_SERVICE_GROUP_EDIT: 'Editar Grupo de servicios UDP',
    ICMP_SERVICE_GROUP_ADD: 'Añadir nuevo Grupo de servicios ICMP',
    ICMP_SERVICE_GROUP_EDIT: 'Editar Grupo de servicios ICMP',
    OTHER_SERVICE_GROUP_ADD: 'Añadir nuevo Grupo de otros servicios',
    OTHER_SERVICE_GROUP_EDIT: 'Editar Grupo de otros servicios',
    GROUP_DETACH_SUCCESS: 'Objeto desasociado del grupo correctamente',
    GROUP_EMPTY_ERROR: 'El grupo no se puede quedarse vacío',
    DELETE_SUCCESS: 'Objeto eliminado correctamente',
    TCP_SERVICE: 'Servicio TCP',
    UDP_SERVICE: 'Servicio UDP',
    ICMP_SERVICE: 'Servicio ICMP',
    OTHER_SERVICE: 'Otro servicio',
    TCP_SERVICE_GROUP: 'Grupo de Servicio TCP',
    UDP_SERVICE_GROUP: 'Grupo de Servicio UDP',
    ICMP_SERVICE_GROUP: 'Grupo de Servicio ICMP',
    OTHER_SERVICE_GROUP: 'Grupo de otros servicios',
    CASB_TENANTS: 'Tenants CASB',
    DLP: 'DLP',
    FILE_TYPES: 'Tipos de archivos',
    FILE_NAMES: 'Nombres de archivos',
    CONTENTS: 'Contenido de protocolo',
    DLP_FILE_NAME_GROUP_ADD: 'Añadir grupo de nombre de archivos',
    DLP_FILE_TYPE_GROUP_ADD: 'Añadir grupo de tipo de archivos',
    DLP_FILE_NAME_GROUP_EDIT: 'Editar grupo de nombre de archivos',
    DLP_FILE_TYPE_GROUP_EDIT: 'Editar grupo de tipo de archivos',
    DNS_RECORD: 'Registro DNS',
    DNS_RECORDS: 'Registros DNS',
    IP_ADDRESS_MODERATE: 'Dirección IP (modo moderado)',
    IP_ADDRESS_STRICT: 'Dirección IP (modo estricto)',
    SSL_PROFILE: 'SSL TUNNELS',
    IPSEC_PROFILE: 'IPSEC VPN',
    APPLICATION_STATUS: 'Estado de la aplicación',
    BUILD: 'Build de Windows',
    USER_BUILD: 'Instalador del Agente',
    SUCCESS_BUILD:
      'Build iniciado satisfactoriamente. El ejecutable estará disponible en unos minutos. Por favor, espera a que el proceso se complete.',
    RUNNING: 'En proceso',
    INACTIVE: 'Desconectado',
    CONNECTED_TUNNEL: '{type}: {name}',
    OS_UNKNOWN: 'SO: Desconocido',
    DEVICE_NAME_UNKNOWN: 'Nombre de dispositivo: Desconocido',
    NO_SELECTED_DAYS: 'No hay días seleccionados',
    MAC_ADDRESSES: 'Direcciones MAC',
    AZURE_TENANT_NAME: 'Nombre del Tenant de Azure',
  },
  CASB_TENANT_OBJECTS: {
    TARGET: 'Dominio CASB',
    ADD: 'Añadir Tenant CASB',
    EDIT: 'Editar Tenant CASB',
    EDIT_SUCCESS: 'Tenant CASB actualizado correctamente',
    ADD_SUCCESS: 'Tenant CASB añadido correctamente',
  },
  NETWORK_OBJECTS: {
    CASB_ID: 'CASB ID',
    AUTO_MODE: 'Modo Automático',
    AUTO_MODE_UPDATE_SUCCESS: 'Modo Automático actualizado con éxito',
    CASB_ID_PLACEHOLDER: 'CASB ID...',
    IP: 'IP',
    IPV4: 'IPv4',
    IPV4_RANGE: 'Rango IPv4',
    IPV6: 'IPv6',
    IPV6_RANGE: 'Rango IPv6',
    NET_MASK: 'Máscara de Red',
    NET_MASK_IPV4: 'Máscara de Red IPv4',
    NET_MASK_IPV6: 'Máscara de Red IPv6',
    GROUPS: 'Grupos',
    PROTOCOL: 'Protocolo',
    PORT: 'Puerto',
    DETACH: 'Desasociar',
    REMOVE_NETWORK_FROM_GROUP: 'Eliminar red de este grupo',
    GROUP_ADD_SUCCESS: 'Grupo de red creado con éxito',
    GROUP_ADD_ERROR: 'Error al crear el grupo de red',
    GROUP_EDIT_SUCCESS: 'Grupo de red actualizado con éxito',
    GROUP_EDIT_ERROR: 'Error al actualizar el grupo de red',
    GROUP_DELETE_SUCCESS: 'Grupo de red eliminado correctamente',
    GROUP_UPDATE_SUCCESS: 'Grupo de red actualizado correctamente',
    GROUP_ALREADY_IN_USE:
      "El grupo de red no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    GROUP_IPV4_ERROR: 'Al menos una de las direcciones IPv4 no es válida',
    GROUP_IPV6_ERROR: 'Al menos una de las direcciones IPv6 no es válida',
    INVALID_IP_MASK: 'Máscara IP inválida',
    TYPE: 'Tipo',
    MAC_ADDRESS: 'Dirección MAC',
    MAC_ADDRESS_ADD: 'Añadir nueva Dirección MAC',
    MAC_ADDRESS_GROUP: 'Grupo de Dirección MAC',
    DOMAIN: 'Dominio',
    DOMAIN_PLACEHOLDER: 'Dominio...',
    HOSTNAME: 'Nombre de Host',
    HOSTNAME_PLACEHOLDER: 'Nombre de Host...',
    GROUP: 'Grupo',
    GROUP_PLACEHOLDER: 'Grupo...',
    LOAD_ERROR: 'Error al cargar objetos de red',
    DETAIL_ERROR: 'Error al cargar detalles del objeto de red',
    ALREADY_IN_USE:
      "El objeto de red no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    DELETE_SUCCESS: 'Objeto de red eliminado correctamente',
    ADD: 'Añadir nueva Red',
    ADD_SUCCESS: 'Objeto de red creado con éxito',
    ADD_ERROR: 'Error al crear el objeto de red',
    EDIT: 'Editar Red',
    EDIT_SUCCESS: 'Objeto de Red actualizada con éxito',
    EDIT_ERROR: 'Error al actualizar el objeto de red',
    ZTNA_RULE_IN_USE:
      'El objeto no se puede modificar porque está siendo usado en una regla ZTNA',
    RANGE: 'Rango de Red',
    RANGE_GROUP: 'Grupo de Rango de Red',
    SOURCE_SELECT: 'Seleccionar Origen',
    SOURCES_SELECT: 'Seleccionar Origen',
    LOCAL_SELECT: 'Seleccione Selector local',
    REMOTE_SELECT: 'Seleccione Selector remoto',
    DESTINATION_SELECT: 'Seleccionar Destino',
    SERVICE_SELECT: 'Seleccionar Servicio',
    RECORD_SELECT: 'Seleccionar Registros',
    FQDN_SELECT: 'Seleccionar FQDN',
    NETWORK_SELECT: 'Seleccionar Red',
    NETWORK_RANGE_SELECT: 'Seleccionar Rango de red',
    GEOLOCATION_SELECT: 'Seleccionar Geolocalización',
    TCP_SERVICE_SELECT: 'Seleccionar Servicio TCP',
    UDP_SERVICE_SELECT: 'Seleccionar Servicio UDP',
    ICMP_SERVICE_SELECT: 'Seleccionar Servicio ICMP',
    OTHER_SERVICE_SELECT: 'Seleccionar Servicio other',
    MAC_SELECT: 'Seleccionar MAC',
    USER_SELECT: 'Seleccionar Usuario',
    DLP_FILE_TYPE_SELECT: 'Seleccionar Tipo de Archivo DLP',
    DLP_FILE_NAME_SELECT: 'Seleccionar Nombre de Archivo DLP',
    DLP_CONTENT_GROUP_ADD: 'Añadir Contenido DLP',
    DLP_CONTENT_SELECT: 'Seleccionar Contenido DLP',
    FIELD_REQUIRED:
      'Se requiere rellenar al menos uno de los campos IPv4 o IPv6',
    IPV4_ERROR:
      'El campo IPv4 no es válido. Por favor, revise la dirección IP y la máscara de red.',
    IPV6_ERROR:
      'El campo IPv6 no es válido. Por favor, revise la dirección IP y la máscara de red.',
    FIREWALL_IPV4_ERROR:
      "El campo IPv4 no puede estar vacío porque está siendo usado en una regla firewall con protocolo IPv4. Por favor, revise la lista 'Donde se usa'.",
    FIREWALL_IPV6_ERROR:
      "El campo IPv6 no puede estar vacío porque está siendo usado en una regla firewall con protocolo IPv6. Por favor, revise la lista 'Donde se usa'.",
    MAC_ERROR:
      'El campo Dirección MAC no es válido. Por favor, revise la dirección MAC.',
    IPS: 'Listado de IPs',
    CASB_TENANT_PLACEHOLDER: 'Dominio CASB...',
    SOURCE: 'Origen',
    AD_SERVERS: 'Configuraciones Azure',
    EMAIL: 'Email',
    EMAIL_OF_IMPORTED_USER:
      'Este email pertenece a un usuario importado de un directorio (Entra ID o beActive). Use ese usuario.',
    DUPLICATE_EMAIL: 'Duplicate Email',

    SYNC_AZURE_AD_USERS: 'Lista de usuarios Azure AD',
    SYNCED_USERS: 'Usuarios sincronizados',
    SYNCED_SUCCESS: 'Syncronizado con éxito',
    SYNC_FAILED: 'Syncronización fallida',
    SSL_VPN: 'SSL VPN',
    AGENTLESS_USERS: 'Usuarios sin agente',
    CONNECTOR_SELECT: 'Seleccionar Conector',
    APPLICATION_SELECT: 'Seleccionar Aplicación',
    SASE_DEVICE: 'Oficinas',
    OBSERVATION_ID: 'ID de Observación',
    OBSERVATION_ID_ERROR: 'El ID debe tener exactamente 6 dígitos',
    OBSERVATION_ID_FORMAT_ERROR:
      'El ID de observación debe tener exactamente 6 dígitos',
    OBSERVATION_ID_ALREADY_TAKEN: 'El ID de observación ya ha sido tomado',

    CREATE_BUILD: 'Ejecutable del Build de windows',
  },
  NETWORK_RANGE_OBJECTS: {
    ALREADY_IN_USE:
      "El objeto de Rango de IP no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    DELETE_SUCCESS: 'Objeto de Rango de IP eliminado correctamente',
    ADD: 'Añadir nuevo Rango de IP',
    ADD_SUCCESS: 'Objeto de Rango de IP creado con éxito',
    ADD_ERROR: 'Error al crear el objeto Rango de IP',
    EDIT: 'Editar Rango de IP',
    EDIT_SUCCESS: 'Objeto de Rango de IP actualizado con éxito',
    EDIT_ERROR: 'Error al actualizar el objeto Rango de IP',
    FIELD_REQUIRED:
      'Se requiere rellenar al menos uno de los campos de rango IPv4 o IPv6',
    IPV4_FORMAT_ERROR:
      'El campo IPv4 debe tener un formato de rango como X.X.X.X - X.X.X.X',
    IPV6_FORMAT_ERROR:
      'El campo IPv6 debe tener un formato de rango como ::X - ::X',
    IPV4_ERROR:
      'Al menos una de las direcciones IPv4 no es válida. Por favor, revise las direcciones IP. Formato: X.X.X.X - X.X.X.X.',
    IPV6_ERROR:
      'Al menos una de las direcciones IPv6 no es válida. Por favor, revise las direcciones IP. Formato: ::X - ::X.',
  },
  FQDN_OBJECTS: {
    ADD_SUCCESS: 'Objeto FQDN creado con éxito',
    ADD_ERROR: 'Error al crear el objeto FQDN',
  },
  MAC_OBJECTS: {
    ADD_SUCCESS: 'Objeto de Dirección MAC creado con éxito',
    ADD_ERROR: 'Error al crear el objeto de Dirección MAC',
  },
  USER_OBJECTS: {
    ADD: 'Añadir nuevo Usuario',
    BESAFE_VPN_AGENT: 'Agente VPN BeSafe',
    ADD_SUCCESS:
      'El objeto de usuario se ha creado o actualizado correctamente',
    ADD_ERROR: 'Error al crear el objeto Usuario',
    EDIT: 'Editar Usuario',
    EDIT_SUCCESS: 'Objeto de Usuario actualizado con éxito',
    EDIT_ERROR: 'Error al actualizar objeto de Usuario',
    NO_DATA: 'No data available',
    NO_AZURE_CONFIG: 'No configuration selected',
    VPN_CLIENT_CONFIG_NOT_FOUND: 'Configuración de cliente VPN no encontrada',
    TWO_FACTOR_AUTH_RESET_SUCCESS:
      'La autenticación de dos factores se ha restablecido correctamente',
    CONFIG_UPDATE_SUCCESS: 'Configuración actualizada correctamente',
    CONFIG_UPDATE_FAILURE: 'Error al actualizar la configuración',
    AUTO_MODE_UPDATE_FAILURE: 'Error al actualizar el Modo Automático',

    TWO_FACTOR_AUTH_ENABLED_SUCCESS:
      'Autenticación de dos factores habilitada correctamente',
    INVALID_TWO_FACTOR_AUTH_CODE:
      'Código de autenticación de dos factores inválido',
    TWO_FACTOR_AUTH_NOT_ENABLED: 'Autenticación de dos factores no habilitada',
    TWO_FACTOR_AUTH_VERIFIED_SUCCESS:
      'Autenticación de dos factores verificada correctamente',
    TWO_FACTOR_AUTH_NOT_ALLOWED: 'Autenticación de dos factores no permitida',
    INVALID_API_KEY: 'Clave API inválida',
    AUTO_MODE_2FA_CONFLICT:
      'La autenticación de dos factores debe estar deshabilitada cuando el Modo Automático está habilitado',
    DOWNLOAD_BUILD: 'Descargar el Cliente Windows',
    SEND_EMAIL: 'Enviado vía email',

    API_KEY: 'API Key',
    REGENERATE_API_KEY: 'Regenerar la API Key',
    CONFIRM_API_REGENERATE: '¿Está seguro de que quiere regenerar la API Key?',
    API_KEY_REGENERATE_SUCCESS: 'API Key regenerada con éxito',
    TWO_FACTOR_AUTH_SETUP_COMPLETED: 'Configuración 2FA Completada',
    TWO_FACTOR_AUTH_ENABLED: '2FA Habilitado',
    RESET_TWO_FACTOR_AUTH: 'Restablecer 2FA',
    CONFIRM_RESET_TWO_FACTOR_AUTH:
      '¿Estás seguro de que deseas restablecer el 2FA para este usuario?',
    RESET_TWO_FACTOR_AUTH_SUCCESS: '2FA restablecido con éxito',
    AUTO_CONNECT_MODE: 'Modo de Conexión Automática',
    AUTO_MODE_UPDATE_SUCCESS: 'Modo Automático actualizado correctamente',
    BESAFE_ARGUS: 'BeSafe Argus',
    ARGUS_REAL_TIME_PROTECTION_ENABLED: 'Protección en tiempo real',
    ARGUS_REAL_TIME_PROTECTION_UPDATE_SUCCESS: 'Protección en tiempo real de Argus actualizada correctamente',
    ARGUS_MODE: 'Modo',
    ARGUS_MODE_ANTIVIRUS: 'Antivirus',
    ARGUS_MODE_PROXY: 'Proxy',
    ARGUS_MODE_UPDATE_SUCCESS: 'Modo de Argus actualizado correctamente',
    ARGUS_STATUS: 'Estado de BeSafe Argus',
    ARGUS_SECTION_SERVICE_STATUS: 'Estado del Servicio',
    ARGUS_SECTION_VERSION_INFO: 'Información de Versión',
    ARGUS_SECTION_SCAN_STATS: 'Estadísticas de Escaneo',
    ARGUS_REACHABLE_LABEL: 'Accesible',
    ARGUS_REACHABLE_YES: 'Accesible',
    ARGUS_REACHABLE_NO: 'No Accesible',
    ARGUS_ENABLED_LABEL: 'Habilitado',
    ARGUS_ENABLED_YES: 'Habilitado',
    ARGUS_ENABLED_NO: 'Deshabilitado',
    ARGUS_ACTUAL_MODE: 'Modo',
    ARGUS_VERSION: 'Versión de Argus',
    ARGUS_MODEL_VERSION: 'Versión de Definiciones',
    ARGUS_LAST_UPDATE: 'Última Actualización',
    ARGUS_SCANNED: 'Escaneados',
    ARGUS_BLOCKED: 'Bloqueados',
    ARGUS_SCAN_ERRORS: 'Errores de Escaneo',
    ARGUS_OVERSIZE: 'Omitidos por Tamaño',
    ARGUS_NO_DATA: 'Aún no se ha reportado datos de Argus',
    ARGUS_SERVICE_ENABLED: 'Servicio Argus',
    ARGUS_SERVICE_UPDATE_SUCCESS: 'Servicio de Argus actualizado correctamente',
    ARGUS_SERVICE_INVALID_VALUE: 'El valor del servicio Argus debe ser true o false',
    NETFLOW_SECTION: 'NetFlow',
    NETFLOW_ENABLE: 'Habilitar NetFlow',
    NETFLOW_HOST: 'Host',
    NETFLOW_PROTOCOL: 'Protocolo',
    NETFLOW_PORT: 'Puerto',
    NETFLOW_ENCRYPTED: 'Habilitar cifrado',
    NETFLOW_TRUST_UNKNOWN_CA: 'Confiar en CAs desconocidas',
    NETFLOW_SAMPLING_RATE: 'Frecuencia de muestreo (%)',
    NETFLOW_EXPORT_FREQUENCY: 'Frecuencia de exportación (segundos)',
    NETFLOW_INVALID_SAMPLING_RATE:
      'La frecuencia de muestreo debe estar entre 0.01 y 100',
    NETFLOW_INVALID_EXPORT_FREQUENCY:
      'La frecuencia de exportación debe estar entre 1 y 86400',
    NETFLOW_INVALID_CERTIFICATE: 'El certificado seleccionado no es válido',
    NETFLOW_CERTIFICATE_REQUIRED_WHEN_TRUST_DISABLED: 'Se requiere un certificado',
    ARGUS_LICENSE_STATUS: 'Estado de Licencia',
    ARGUS_LICENSE_ACTIVE: 'Activa',
    ARGUS_LICENSE_NO_LICENSE: 'Sin licencia de Argus activa',
    ARGUS_LICENSE_ACTIVE_UNTIL: 'Válida hasta el {date}',
    ARGUS_SEATS_RATIO: '{used} de {total} puestos usados',
  },
  GROUP_OBJECTS: {
    LOAD_ERROR: 'Error al cargar los grupos',
    DETAIL_ERROR: 'Error al cargar detalles del grupo',
  },
  AGENTPROFILE: {
    ADD: 'Agregar nuevo perfil de agente',
    EDIT: 'Editar perfil de agente',
    ADD_SUCCESS: 'El perfil de agente se creó correctamente',
    ADD_ERROR: 'Error al crear el perfil de agente',
    EDIT_SUCCESS: 'El perfil de agente se actualizó correctamente',
    EDIT_ERROR: 'Error al actualizar el perfil de agente',
    DELETE_SUCCESS: 'El objeto de perfil de agente se eliminó correctamente',
    DELETE_ERROR: 'Error al eliminar el objeto de perfil de agente',
    NO_DATA: 'No hay datos disponibles',
    ANTIVIRUS: 'Host Checker de Antivirus',
    COPORATE_NETWORK: 'Red corporativa',
    IP_CONFIG: 'Lista de redes corporativas seguras',
    HOST_CHECKER_SECTION: 'Verificador de Host',
    LOCATION_AWARENESS_SECTION: 'Conciencia de Ubicación',
    NO_CERTIFICATE_AVAILABLE: 'No hay certificado disponible',
  },
  AGENT_MAILER: {
    DOWNLOAD_SUCCESS:
      'El instalador de BeSafe Agent se ha descargado correctamente.',
    NO_INSTALLER:
      'No hay instalador disponible en este momento. Por favor, inténtelo de nuevo más tarde.',
    INVALID_EMAIL:
      'Por favor, introduzca una dirección de correo electrónico válida para recibir el instalador.',
  },
  SERVICES: {
    ALREADY_IN_USE:
      "El objeto de Servicio no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    ADD_SUCCESS: 'Objeto de Servicio creado con éxito',
    ADD_ERROR: 'Error al crear el objeto Servicio',
    EDIT_SUCCESS: 'Objecto de Servicio actualizado con éxito',
    EDIT_ERROR: 'Error al actualizar el objeto de Servicio',
    DELETE_SUCCESS: 'Objeto de Servicio eliminado correctamente',
    TCP_SERVICE: 'Servicio TCP',
    UDP_SERVICE: 'Servicio UDP',
    ICMP_SERVICE: 'Servicio ICMP',
    OTHER_SERVICE: 'Otros servicios',
    ADD: 'Añadir nuevo Servicio',
    EDIT: 'Editar Servicio',
    SELECT: 'Seleccionar Servicios',
    PORTS: 'Puertos',
    PORTS_PLACEHOLDER: '80,443,7000-7009,514:512-1023',
    ICMP_TYPE: 'Tipo ICMP',
    ICMP_TYPE_PLACEHOLDER: 'Tipo ICMP...',
    ICMP_CODE: 'Código ICMP',
    ICMP_CODE_PLACEHOLDER: 'Código ICMP...',
    PROTOCOL_NUMBER: 'Número de protocolo',
    PROTOCOL_NUMBER_PLACEHOLDER: 'Número de protocolo...',
    LOAD_ERROR: 'Error al cargar objetos de servicio',
    DETAIL_ERROR: 'Error al cargar detalles del objeto de servicio',
    PORTS_ERROR: 'Al menos uno de los puertos es inválido',
    ICMP_TYPE_ERROR: 'Tipo ICMP es inválido',
    ICMP_CODE_ERROR: 'Código ICMP es inválido',
    PROTOCOL_NUMBER_ERROR:
      'Número de protocolo es inválido. Debe estar comprendido entre 0 y 255',
    ICMP_GROUP_ALL_ERROR:
      'No puedes seleccionar otros servicios ICMP cuando ALL_ICMP o ALL_ICMP6 ya esté seleccionado',
    ICMP_VERSIONS_ERROR: 'No puedes mezclar servicios ICMP e ICMP6',
  },
  SCHEDULE_OBJECTS: {
    LOAD_ERROR: 'Error al cargar objetos de programación',
    DETAIL_ERROR: 'Error al cargar detalles del objeto de programación',
    ALREADY_IN_USE:
      "El objeto no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    SCHEDULE_OBJECT_DELETED_SUCCESS:
      'Objeto de Programación eliminado correctamente',
    ADD: 'Añadir nueva Programación',
    EDIT: 'Editar Programación',
    SELECT: 'Seleccionar Programación',
  },
  DNS_RECORD_OBJECTS: {
    LOAD_ERROR: 'Error al cargar objetos de registro DNS',
    DETAIL_ERROR: 'Error al cargar detalles del objeto de registro DNS',
    ALREADY_IN_USE:
      "El objeto no se puede eliminar porque se está usando en otros lugares. Por favor, revise la lista 'Donde se usa'.",
    DNS_RECORD_OBJECT_DELETED_SUCCESS:
      'Objeto de registro DNS eliminado correctamente',
    ADD: 'Añadir nuevo registro DNS',
    EDIT: 'Editar registro DNS',
    SELECT: 'Seleccionar registro DNS',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar este registro DNS?',
    DESELECT_NOT_ALLOWED:
      'Los registros DNS iniciales no pueden ser desmarcados',
    ERROR_DUPLICATED:
      'El objeto de registro DNS no puede tener el mismo nombre y dirección IP que otro registro DNS existente',
  },
  OBJECT_MODAL: {
    ADD: 'Añadir',
    CANCEL: 'Cancelar',
    EDIT: 'Edit',
  },
  CASB: {
    MICROSOFT365: 'Microsoft 365',
    SALESFORCE: 'Salesforce',
    GOOGLE_DOCUMENTS: 'Google Cloud',
    BOX: 'BOX',
    ACTION: 'Estado',
    RULE_NAME: 'Nombre de la regla',
    SOURCE: 'Usuarios',
    APPLICATION: 'Aplicación',
    TRUST: 'Confianza',
    CONTENT: 'Perfil DLP',
    ACTIVITY: 'Actividad',
    CASB_TENANT: 'Tenant CASB',
    EDIT_RULE_TITLE: 'Editar regla de CASB',
    ADD_RULE_TITLE: 'Añadir regla de CASB',
  },
  XDR: {
    TITLE: 'Politicas XDR',
    ADD: 'Añadir politica XDR',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta regla?',
    DELETE_SUCCESS: 'Regla eliminada correctamente',
    ADD_SUCCESS: 'Regla añadida correctamente',
    COMPROMISED: 'Dispositivo comprometido',
    CPU: 'Alto uso de CPU',
    MEMORY: 'Alto uso de memoria',
    ISOLATE: 'Aislar dispositivo',
    EMAIL: 'Enviar email',
    SDWAN: 'Aislar dispositivo en SDWAN',
    REDIRECT: 'Redirigir tráfico',
    NAME: 'Nombre',
    EVENT: 'Evento',
    ACTION: 'Acción',
    NAME_PLACEHOLDER: 'Nueva política XDR',
    TRIGGER: 'Eventos XDR',
    POLICY_NAME: 'Nombre de política',
    USER_NAME: 'Nombre de usuario',
    ACKNOWLEDGE: 'Reparar',
  },
  INACTIVITY_CONTROL: {
    INACTIVE_SESSION: 'Sesión inactiva',
    INACTIVITY_WARNING:
      'La sesión expirará en {s} segundos debido a la inactividad.',
    STAY_LOGGED_IN: 'Permanecer conectado',
  },
  WEB_FILTER: {
    BASIC: 'Básico',
    MEDIUM: 'Medio',
    HIGH: 'Alto',
    CUSTOM: 'Personalizado',
    ADS: 'Anuncios',
    PARKED_DOMAINS: 'Dominios parqueados',
    WEB_ADVERTISEMENTS: 'Anuncios web',
    DANGEROUS: 'Peligroso',
    GAMBLING: 'Apuestas',
    HACKING: 'Hacking',
    OPEN_HTTP_PROXIES: 'HTTP Proxies libres',
    PAY_TO_SURF: 'Pagar para navegar',
    PEER_TO_PEER: 'Peer to Peer',
    FREE_TIME: 'Tiempo libre',
    COMPUTER_AND_INTERNET_INFO: 'Noticias sobre Ordenadores e Internet',
    ENTERTAINMENT_AND_ARTS: 'Entretenimiento y Arte',
    FASHION_AND_BEAUTY: 'Moda y Belleza',
    FOOD_AND_DINING: 'Comida y Bebida',
    HOME_AND_GARDEN: 'Casa y Jardin',
    HUNTING_AND_FISHING: 'Caza y Pesca',
    INTERNET_PORTALS: 'Portales de Internet',
    KIDS: 'Contenido Infantil',
    LOCAL_INFORMATION: 'Información local',
    MOTOR_VEHICLES: 'Automoción',
    ONLINE_GREETING_CARDS: 'Tarjetas de felicitación',
    PERSONAL_SITES_AND_BLOGS: 'Sitios personales y Blogs',
    PHILOSOPHY_AND_POLITICAL_ADVOCACY: 'Filosofía y Política',
    QUESTIONABLE: 'Contenido cuestionable',
    REAL_ESTATE: 'Inmuebles',
    RECREATION_AND_HOBBIES: 'Hobbies',
    RELIGION: 'Religión',
    SHOPPING: 'Compras',
    SOCIETY: 'Sociedad',
    SPORTS: 'Deportes',
    TRAVEL: 'Viajes',
    MALWARE_THREATS: 'Eventos de Malware',
    BOT_NETS: 'Bot Nets',
    CONFIRMED_SPAM_SOURCES: 'Fuentes de spam confirmadas',
    KEYLOGGERS_AND_MONITORING: 'Keyloggers y Monitorización',
    MALWARE_SITES: 'Sitios de Malware',
    PHISHING_AND_OTHER_FRAUDS: 'Phising y otros fraudes',
    PROXY_AVOIDANCE_AND_ANONYMIZERS: 'Elusión de proxies y anonimizadores',
    SPAM_URLS: 'Spam URLs',
    SPYWARE_AND_ADWARE: 'Spyware y Adware',
    UNCONFIRMED_SPAM_SOURCES: 'Fuentes de spam no confirmadas',
    MEDIA: 'Multimedia',
    MUSIC: 'Música',
    NEWS_AND_MEDIA: 'Noticias y medios de información',
    SOCIAL_NETWORKING: 'Redes sociales',
    STREAMING_MEDIA: 'Contenido en streaming',
    OTHERS: 'Otros',
    UNCATEGORIZED: 'Sin categorizar',
    UNRANKED: 'Sin clasificar',
    UNRANKED_TRAFFIC: 'Tráfico sin clasificar',
    SEARCH_ENGINES: 'Motores de búsqueda',
    IMAGE_AND_VIDEO_SEARCH: 'Buscadores de imágen y vídeo',
    JOB_SEARCH: 'Buscadores de empleo',
    TECHNOLOGY: 'Tecnología',
    COMPUTER_AND_INTERNET_SECURITY: 'Seguridad de Ordenadores e Internet',
    CONTENT_DELIVERY_NETWORKS: 'Redes de distribución de contenidos',
    DYNAMICALLY_GENERATED_CONTENT: 'Contenido generado dinámicamente',
    INDIVIDUAL_STOCK_ADVICE_AND_TOOLS: 'Herramientas para la gestión de Stock',
    INTERNET_COMMUNICATIONS: 'Comunicaciones en Internet',
    PERSONAL_STORAGE: 'Almacenamiento personal',
    SHAREWARE_AND_FREEWARE: 'Shareware y Freeware',
    TRANSLATION: 'Traducción',
    WEB_HOSTING: 'Web hosting',
    WEB_BASED_EMAIL: 'Web Email',
    UNWANTED_WEBSITES: 'Sitios web no deseados',
    ABORTION: 'Aborto',
    ABUSED_DRUGS: 'Drogas',
    ADULT_AND_PORNOGRAPHY: 'Contenido Adulto y Pornografía',
    ALCOHOL_AND_TOBACCO: 'Alcohol y Tacabo',
    AUCTIONS: 'Subastas',
    CHEATING: 'Trampas',
    CULT_AND_OCCULT: 'Sectas y sobrenatural',
    DATING: 'Citas',
    DEAD_SITES: 'Sitios perdidos',
    GAMES: 'Juegos',
    GROSS: 'Contenido grosero',
    HATE_AND_RACISM: 'Odio y Racismo',
    ILLEGAL: 'Contenido ilegal',
    MARIJUANA: 'Marihuana',
    MILITARY: 'Militar',
    NUDITY: 'Desnudos',
    PRIVATE_IP_ADDRESSES: 'Direcciones IP privadas',
    SEX_EDUCATION: 'Educación sexual',
    SWIMSUITS_AND_INTIMATE_APPAREL: 'Bañadores y ropa íntima',
    VIOLENCE: 'Violencia',
    WEAPONS: 'Armas',
    WORK: 'Trabajo',
    BUSINESS_AND_ECONOMY: 'Negocios y Economía',
    EDUCATIONAL_INSTITUTIONS: 'Instituciones educativas',
    FINANCIAL_SERVICES: 'Servicios Financieros',
    GOVERNMENT: 'Gobierno',
    HEALTH_AND_MEDICINE: 'Salud y Medicina',
    LEGAL: 'Jurídico',
    REFERENCE_AND_RESEARCH: 'Investigación y Bibliografía',
    TRAINING_AND_TOOLS: 'Herramientas educativas',
    SELF_HARM: 'Autolesiones',
    DNS_OVER_HTTPS: 'DNS sobre HTTPS',
    LOW_THC_CANNABIS_PRODUCTS:
      'Productos de cannabis con bajo contenido de THC',
    GENERATIVE_AI: 'IA Generativa',
    CATEGORIES: 'Categorías',
    CUSTOM_CATEGORIES: 'Categorías personalizadas',
    CATEGORY_NAME: 'Nombre',
    CATEGORY_COUNT: 'Cuenta',
    CATEGORY_STATE: 'Estado',
    ERROR_INDEX: 'Error al obtener categorías',
    SUCCESS_LEVEL_SET: 'Nivel de protección actualizado correctamente',
    ERROR_LEVEL_SET: 'Error al actualizar el nivel de protección',
    ERROR_UPDATING_CATEGORY: 'Error al actualizar categoría',
    ERROR_UPDATING_SUBCATEGORY: 'Error al actualizar subcategoría',
    SUCCESS_UPDATING_CATEGORY: 'Categoría actualizada correctamente',
    SUCCESS_UPDATING_SUBCATEGORY: 'Subcategoría actualizada correctamente',
    BASIC_BLOCKED:
      'CATEGORÍAS BLOQUEADAS: Sitios Malware, Phising y otros Fraudes, Spyware y Adware, Elusión de proxies y anonimizadores, Fuentes de spam confirmadas, Apuestas, Contenido grosero, Keyloggers y Monitorización, Engaños, Contenido Ilegal, Violencia, Bot Nets, Hacking, Armas',
    MEDIUM_BLOCKED:
      'CATEGORÍAS BLOQUEADAS: Sitios Malware, Phising y otros Fraudes, Spyware y Adware, Elusión de proxies y anonimizadores, Fuentes de spam confirmadas, Apuestas, Contenido grosero, Keyloggers y Monitorización, Engaños, Contenido Ilegal, Violencia, Bot Nets, Hacking, Viajes, Drogas, Juegos, Marihuana, Spam URLs, Dominios Parqueados, Armas',
    HIGH_BLOCKED:
      'CATEGORÍAS BLOQUEADAS: Sitios Malware, Phising y otros Fraudes, Spyware y Adware, Elusión de proxies y anonimizadores, Fuentes de spam confirmadas, Apuestas, Contenido grosero, Keyloggers y Monitorización, Engaños, Contenido Ilegal, Violencia, Bot Nets, Hacking, Viajes, Drogas, Juegos, Marihuana, Spam URLs, Dominios Parqueados, Subastas, Compras, Sectas y sobrenatural, Streaming, Armas, Tarjetas Regalo, Odio y Racismo, Alcohol y Tabaco, Redes Sociales',
    WILDCARD: 'Wildcard',
    REGEX: 'Expresión regular',
    EXPRESSION_TYPE: 'Tipo de expresión',
    URLS: 'Urls',
    ADD_CUSTOM_CATEGORY: 'Crear categoría personalizada',
    EDIT_CUSTOM_CATEGORY: 'Editar categoría personalizada',
    VIEW_CUSTOM_CATEGORY: 'Categoría personalizada',
    PREDEFINED_CATEGORIES: 'Categorías predefinidas',
    PREDEFINED_CATEGORY_BADGE: 'BeSafe Pro',
    PREDEFINED_CATEGORY_INFO: 'Categoría gestionada por BeSafe Pro. No se puede eliminar ni modificar su lista de dominios, pero sí cambiar su acción.',
    SUCCESS_DELETE: 'Categoría personalizada eliminada con éxito',
    ERROR_DELETE: 'Error al eliminar categoría personalizada',
    SUCCESS_CREATE: 'Categoría personalizada creada con éxito',
    ERROR_CREATE: 'Error al crear categoría personalizada',
    SUCCESS_UPDATE: 'Categoría personalizada actualizada con éxito',
    ERROR_UPDATE: 'Error al actualizar categoría personalizada',
    CONTENT_FILTER: 'Filtro de contenido',
    WEB_CONTENT_FILTERS: 'Filtros de contenido web',
    SUCCESS_CONTENT_FILTER_SET: 'Filtro de contenido actualizado correctamente',
    ERROR_CONTENT_FILTER_SET: 'Error al actualizar filtro de contenido',
    ERROR_INDEX_CONTENT_FILTER: 'Error al obtener filtros de contenido web',
    ERROR_UPDATE_CONTENT_FILTER: 'Error al actualizar filtro de contenido web',
    SUCCESS_UPDATE_CONTENT_FILTER:
      'Filtro de contenido web actualizado correctamente',
    SUCCESS_DELETE_CONTENT_FILTER:
      'Filtro de contenido web eliminado correctamente',
    ERROR_DELETE_CONTENT_FILTER: 'Error al eliminar filtro de contenido web',
    SUCCESS_CREATE_CONTENT_FILTERS:
      'Filtro de contenido web creado correctamente',
    ERROR_CREATE_CONTENT_FILTERS: 'Error al crear filtro de contenido web',
    EDIT_CONTENT_FILTER: 'Editar filtro de contenido web',
    ADD_CONTENT_FILTER: 'Crear filtro de contenido web',
    REPUTATION: 'Reputación mínima permitida',
    SUCCESS_REPUTATION_SET: 'Reputación actualizada correctamente',
    ERROR_REPUTATION_SET: 'Error al actualizar reputación',
    ALLOW_ALL: 'Permitir todo',
    URLS_DESCRIPTION:
      'Wildcard *: URL con el caracter wildcard de forma opcional al comienzo o final de la URL. El caracter wildcard representa 0 o más caracteres variables o desconocidos\nRegex (.*): Expresión regular de una URL siguiendo el estandar PCRE',
    BAD_WILDCARD_EXPRESSION:
      'Expresión wildcard incorrecta: debe contener como máximo un carácter wildcard (*) al comienzo o final de la expresión',
    SEARCH_PROTECTION:
      'Protección de búsquedas de Google®, Bing®, Yahoo® y Youtube®',
    SEARCH_PROTECTION_HELP:
      'Active la protección de búsquedas de Google® y Bing® para limitar los resultados de búsqueda (páginas web, imágenes y contenido), sólo se mostrarán los resultados seguros y apropiados. Pornografía y otros contenidos indeseados serán excluidos de los resultados de búsqueda.',
    SUCCESS_SEARCH_PROTECTION_SET:
      'Protección de búsquedas actualizado correctamente',
    ERROR_SEARCH_PROTECTION_SET: 'Error al actualizar protección de búsquedas',
    MODERATE: 'Moderado',
    STRICT: 'Estricto',
    YOUTUBE_MODE: 'Restricción de Youtube',
    SUCCESS_YOUTUBE_MODE_SET:
      'Nivel de restricción de Youtube actualizado con éxito',
    ERROR_YOUTUBE_MODE_SET:
      'Error al actualizar el nivel de restricción de Youtube',
  },
  IPS_EXCEPTION: {
    ORIGIN_IP: 'IP Origen',
    PORT: 'Puerto',
    DESTINATION_IP: 'IP Destino',
    ORIGIN: 'Origen',
    DESTINATION: 'Destino',
    ACTIONS: 'Acciones',
  },
  TEMPLATES: {
    TITLE: 'Extensión de CLI',
    SUCCESS_CREATE: 'Plantilla created con éxito',
    ERROR_CREATE: 'Error al crear plantilla',
    SUCCESS_UPDATE: 'Plantilla actualizada con éxito',
    ERROR_UPDATE: 'Error al actualizar plantilla',
    TEMPLATE: 'Plantilla',
    EDIT: 'Editar plantilla',
    ADD: 'Crear plantilla',
    SUCCESS_CLI: 'Extension de CLI actualizada con éxito',
    ERROR_CLI: 'Error al actualizar extensión de CLI',
    SUCCESS_DELETE: 'Plantilla borrada con éxito',
    ERROR_DELETE: 'Error al borrar plantilla',
  },
  PROTOCOL: {
    WRONG_PORT: 'El puerto debe ser un número entre 1 y 65535',
    WRONG_PROTOCOL: 'El protocolo debe ser TCP o UDP',
    WRONG_HOST: 'Host incorrecto',
  },
  SYSLOGS: {
    TLS_CA_NOT_PROVISIONED: 'El certificado de syslog cifrado no está disponible. Contacte con su administrador.',
    TLS_CA_DELIVERY_FAILED: 'No se pudo entregar el certificado de syslog cifrado al dispositivo.',
    DUPLICATED_NAME: 'El nombre no puede estar duplicado',
    WRONG_PORT: 'El puerto debe ser un número entre 1 y 65535',
    WRONG_PROTOCOL: 'El protocolo debe ser TCP o UDP',
    WRONG_HOST: 'Host incorrecto',
    MAXIMUM_REACHED: 'Sólo se permiten 4 entradas de syslog',
    NAME: 'Nombre',
    HOST: 'Host',
    PROTOCOL: 'Protocolo',
    PORT: 'Puerto',
    ACTIONS: 'Acciones',
    SUCCESS_DELETE: 'Syslog borrado con éxito',
    ERROR_DELETE: 'Error al borrar syslog',
    EDIT: 'Editar syslog',
    ADD: 'Crear syslog',
    ERROR_UPDATE: 'Error al actualizar syslog',
    SUCCESS_UPDATE: 'Syslog actualizado con éxito',
    ERROR_CREATE: 'Error al crear syslog',
    SUCCESS_CREATE: 'Syslog creado con éxito',
    CA_FILE: 'Archivo CA',
    CA_FILE_HELP:
      'Este campo puede estar vacío si tienes un certificado firmado por una Autoridad Certificadora (CA)',
    UPLOAD_CA_FILE: 'Subir un certificado CA',
    REQUIRE_CA_FILE: 'Se requiere un archivo CA para esta configuración',
    ENCRYPTED: 'Activar cifrado',
    ENCRYPTED_COLUMN: 'Cifrado',
    TRUST_UNKNOWN_CA: 'Confiar en CAs desconocidas',
    MUTUAL_TLS: 'Activar TLS mutuo',
    MUTUAL_TLS_COLUMN: 'TLS Mutuo',
    MUTUAL_TLS_HELP:
      'Se requiere un certificado de cliente para usar el TLS mutuo',
    CLIENT_CERT: 'Certificado de cliente',
    CLIENT_KEY: 'Clave de cliente',
    UPLOAD_CLIENT_CERT: 'Subir un certificado de cliente',
    REQUIRE_CLIENT_CERT:
      'Se requiere un certificado de cliente para esta configuración',
    UPLOAD_CLIENT_KEY: 'Subir una clave de cliente',
    REQUIRE_CLIENT_KEY:
      'Se requiere una clave de cliente para esta configuración',
  },
  FORWARD_SYSLOGS: {
    MAXIMUM_REACHED: 'Sólo se permiten 3 entradas de syslog',
    ENCRYPTED: 'Cifrado',
    ENCRYPTED_HELP:
      'Se requiere un certificado para usar el cifrado. Puedes añadir uno en la sección de Administración.',
  },
  REMOTE_ACCESS: {
    ONLINE_USERS: 'Usuarios online',
    CONCURRENT_USERS_WARNING:
      'Se ha sobrepasado el número máximo de usuarios concurrentes que permiten las licencias',
  },
  VPNTUNNEL: {
    INVALID_CERTIFICATE: 'El certificado seleccionado no es válido',
    CONFIRM_DELETE: '¿Desea eliminar el túnel?',
    DELETE_SUCCESS: 'Túnel borrado con éxito',
    DELETE_ERROR: 'Error al borrar túnel',
    NAME: 'Nombre',
    SOURCE: 'IP Pool',
    INTERFACE: 'Interfaz',
    PORT: 'Puerto',
    PROTOCOL: 'Protocolo',
    ENABLE_SPLIT_TUNNELING: 'Activar división de túnel',
    SPLIT_TUNNELING: 'Túnel dividido',
    SUCCESS_CREATE: 'Túnel creado con éxito',
    ERROR_CREATE: 'Error al crear túnel',
    WARNING_CREATE:
      'Comprueba que cada dispositivo con perfil SSL "{profileName}" estén con sus interfaces configuradas correctamente en cada túnel!',
    SUCCESS_UPDATE: 'Túnel actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar túnel',
    EDIT_TUNNEL: 'Editar túnel',
    ADD_TUNNEL: 'Crear túnel',
    ROUTING_ADDRESS: 'Dirección de enrutamiento',
    DNS1: 'DNS primario',
    DNS2: 'DNS secundario',
    AUTHENTICATION: 'Autenticación',
    CONNECTION_SETTINGS: 'Configuración de conexión',
    TUNNEL_AUTHENTICATION: 'Modo túnel y autenticación',
    DNS: 'DNS',
    UPLOAD_CLIENT_CERT: 'Cargar certificado de cliente',
    USERS: 'Usuarios',
    SERVER_DEFINITION: 'Definición de servidor',
    DESTINATION_SERVER_IPSEC: 'Destino del Agente',
    DESTINATION_SERVER_SSL: 'Servidor de Destino SSL',
    IP: 'IP',
    HOSTNAME: 'Hostname',
    INTERFACES: 'Interfaz',
    INVALID_PORT: 'Puerto no válido',
    INVALID_PROTOCOL: 'Protocolo no válido',
    INVALID_DNS: 'DNS no válido',
    INVALID_IP: 'IP no válida',
    INVALID_HOSTNAME: 'Hostname no válido',
    NO_USERS_ERROR: 'No hay usuarios asignados al túnel',
    ANY_NETWORK_PRESENT_ERROR: 'La red Any no puede estar presente en el túnel',
    DISABLED_APPLICATIONS: 'Aplicaciones deshabilitadas',
    IP_POOL_ROUTING_ADDRESS_ERROR:
      'Los segmentos de la dirección de enrutamiento deben ser diferentes de los segmentos de la IP Pool',
    MISSING_USER_EMAIL_ERROR: 'Los usuarios deben tener un email asignado',
    IP_POOL_EXHAUSTED: 'No hay suficientes direcciones IP en el pool',
    PORT_PROTOCOL_DUPLICATED:
      'La combinación de puerto y protocolo ya está en uso en otro túnel',
    IP_POOL_DUPLICATED: 'El IP pool ya está en uso en otro túnel',
    IPSEC_DESTINATION_SERVER_DUPLICATED:
      'El servidor de destino IPSec ya está en uso en otro túnel',
    SSL_DESTINATION_SERVER_DUPLICATED:
      'El servidor de destino SSL ya está en uso en otro túnel',
    DUPLICATED_NAME: 'El nombre del túnel ya está en uso',
    INVALID_HOSTNAME_SERVER:
      'El nombre de host no es válido para túneles VPN de tipo cloud',
    DNS_SUFFIX: 'Sufijo DNS',
    EQUAL_NETWORK: 'La IP pool es igual a otra del mismo perfil',
    INSUFFICIENT_MASK:
      'La máscara de red de la IP pool tiene que ser menor que 31 y mayor a 8',
    INTERFACE_IN_USE: 'La interfaz estática está siendo usada por un túnel VPN',
    USER_IN_RULE: 'El usuario eliminado está siendo usado en una regla de ZTNA',
    GROUP_IN_RULE: 'El grupo eliminado está siendo usado en una regla de ZTNA',
    CONFIRM_REMOVE_FROM_RULES:
      'Eliminar estos usuarios/grupos también los eliminará de {count} regla(s) de firewall/ZTNA. Las reglas que queden sin fuentes serán deshabilitadas. ¿Desea continuar?',
    USERS_IN_RULES:
      'Los usuarios/grupos eliminados están siendo usados en reglas de firewall o ZTNA',
    AGENT_PROFILE: 'Perfil de agente',
  },
  SSLVPN: {
    CONFIRM_DELETE: '¿Desea eliminar el túnel?',
    DELETE_SUCCESS: 'Túnel borrado con éxito',
    DELETE_ERROR: 'Error al borrar túnel',
    NAME: 'Nombre',
    SOURCE: 'IP Pool',
    INTERFACES: 'Interfaces',
    PORT: 'Puerto',
    ENABLE_SPLIT_TUNNELING: 'Activar división de túnel',
    SPLIT_TUNNELING: 'Túnel dividido',
    TITLE: 'SSL VPN',
    SUCCESS_CREATE: 'Túnel creado con éxito',
    ERROR_CREATE: 'Error al crear túnel',
    SUCCESS_UPDATE: 'Túnel actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar túnel',
    EDIT_TUNNEL: 'Editar túnel',
    ADD_TUNNEL: 'Crear túnel',
    ROUTING_ADDRESS: 'Dirección de enrutamiento',
    DNS1: 'DNS primario',
    DNS2: 'DNS secundario',
    AUTHENTICATION: 'Método de autenticación',
    CONNECTION_SETTINGS: 'Configuración de conexión',
    TUNNEL_AUTHENTICATION: 'Modo túnel y autenticación',
    DNS: 'DNS',
    UPLOAD_CLIENT_CERT: 'Cargar autoridad de certificación',
    BUILD_EXE: 'Build de Windows',
    SUCCESS_BUILD:
      'Build iniciado satisfactoriamente. El ejecutable estará disponible en unos minutos. Por favor, espera a que el proceso se complete.',
    BUILD_STATUS:
      'Un build está actualmente en progreso. Por favor, intenta la creación en masa después de 5 minutos.',
    NO_USERS: 'No hay usuarios asignados al tunel',
    CLIENT_CERT: 'Certificado de Usuario',
    USERS: 'Credenciales de Usuario',
    AGENT_PROFILE: 'Perfil de agente',
    USER_LIST: 'Lista de Usuarios',
    ALREADY_IN_USE: 'El túnel SSL VPN está siendo usado en otro lugar',
    APPLIED_FW_RULES_ERROR:
      'Tunel SSL VPN no puede ser eliminado. Tiene reglas de firewall aplicadas.',
    INVALID_IP_POOL_UPDATE:
      'La red de la IP pool no puede ser modificada excepto para incrementar la máscara de red',
    IP_POOL_OVERLAPS_TENANT:
      'La IP pool se solapa con una red reservada del sistema',
    INVALID_INTERFACE:
      'Interfaz no válida para el túnel "{tunnel}". Prueba una interfaz estática con IP asignada',
  },
  PORTAL: {
    TITLE: 'Portal sin agente',
    POOL: 'Pool del portal',
    POOL_CIDR: 'CIDR del pool',
    SET_POOL: 'Configurar pool',
    NO_POOL_CONFIGURED:
      'No hay ningún pool configurado. Selecciona una red para habilitar el portal sin agente.',
    USERS: 'Usuarios del portal',
    ADD_USER: 'Añadir usuario',
    USER: 'Usuario',
    ASSIGNED_IP: 'IP asignada',
    REMOVE: 'Eliminar',
    CONFIRM_REMOVE_TITLE: 'Eliminar usuario del portal',
    CONFIRM_REMOVE_DESC:
      '¿Seguro que deseas eliminar a {name} del portal sin agente?',
    FETCH_ERROR: 'Error al cargar la configuración del portal sin agente',
    POOL_UPDATED: 'Pool actualizado correctamente',
    POOL_UPDATE_ERROR: 'Error al actualizar el pool',
    USERS_ADDED: 'Usuario(s) añadido(s) correctamente',
    ADD_USERS_ERROR: 'Error al añadir usuario(s)',
    USER_REMOVED: 'Usuario eliminado correctamente',
    REMOVE_USER_ERROR: 'Error al eliminar el usuario',
    INVALID_POOL: 'La red seleccionada no es un pool válido',
    POOL_MUST_BE_NETWORK: 'El pool debe ser un objeto de tipo red',
    INSUFFICIENT_MASK:
      'La red seleccionada es demasiado pequeña. Elige una red con un rango de direcciones mayor',
    POOL_NOT_CONFIGURED: 'El pool del portal aún no ha sido configurado',
    POOL_TOO_LARGE:
      'La red seleccionada es demasiado grande. Elige una red /16 o más pequeña',
    POOL_IN_USE:
      'No se puede cambiar el pool mientras haya usuarios del portal asignados. Elimina primero los usuarios del portal',
    SELECT_POOL: 'Seleccionar pool de IPs',
    LOCKED_TITLE: 'ZTNA Agentless no está incluido en tu licencia',
    LOCKED_MESSAGE:
      'Ofrece a tus usuarios acceso seguro desde el navegador a las aplicaciones internas, sin instalar nada en sus dispositivos. Contacta con tu representante de Teldat para activar ZTNA Agentless.',
    LICENSE_LIMIT_REACHED:
      'Se ha alcanzado el límite de usuarios de la licencia ZTNA Agentless',
    INVALID_USER: 'El objeto seleccionado no es un usuario válido',
    NO_USERS: 'Selecciona al menos un usuario para añadir',
    USER_NOT_FOUND: 'No se ha encontrado el usuario del portal',
    GATEWAY_WITHOUT_DEVICE: 'El portal aún no tiene un dispositivo peer en el broker',
    BROKER_HOSTNAME_MISSING: 'La cuenta no tiene un hostname SASE para el broker',
    PRE_SHARED_KEY_MISSING: 'El portal no tiene clave precompartida para el túnel',
    POOL_EXCEEDS_GATEWAY_SUBNET:
      'El pool del portal debe caber en una red /24 para el gateway',
    INVALID_DNS_SERVERS: 'Los servidores DNS deben ser una lista de direcciones IP separadas por espacios',
    INVALID_BROWSER_HOMEPAGE: 'La página de inicio del navegador debe ser una URL http o https',
    INVALID_BROWSER_ADD_HOSTS:
      'Los hosts adicionales deben ser una lista de entradas nombre:ip separadas por espacios',
    INVALID_CA_BUNDLE: 'El paquete de CA solo puede contener certificados PEM',
    CA_BUNDLE_TOO_LARGE: 'El paquete de CA supera los 64 KB',
    INVALID_HOSTING: 'El alojamiento debe ser cloud u on_prem',
    INVALID_SIZE_TIER: 'El tamaño debe ser s, m, l o xl',
    INVALID_PORTAL_DOMAIN: 'El dominio del portal no es un nombre de host válido',
    GATEWAY_EXISTS: 'Esta cuenta ya tiene un portal',
    DOMAIN_TAKEN: 'Otro portal ya usa este dominio',
    DOMAIN_REQUIRED: 'Se necesita un dominio para el portal porque no hay un sufijo DNS por defecto configurado',
    PROVIDER_CONFIG_MISSING: 'La configuración del proveedor cloud del servicio de portales está incompleta',
    PROVIDER_CONFIG_INVALID: 'Un ajuste del proveedor cloud del servicio de portales tiene un valor no soportado',
    CLOUD_INIT_UNSAFE_VALUE: 'Un ajuste de instalación del portal contiene caracteres que la VM no admite',
    GATEWAY_WITHOUT_INSTANCE: 'Este portal no tiene una VM cloud sobre la que actuar',
    GATEWAY_DECOMMISSIONED: 'Este portal ha sido dado de baja',
    NOT_RETRYABLE: 'Solo se puede reintentar un portal en error o uno que no terminó de arrancar',
    RETRY_CLOUD_ONLY: 'Solo se puede reintentar un portal en la nube. Para un appliance on-premises, vuelve a registrarlo.',
    GATEWAY_HAS_DEVICE: 'Este portal ya tiene un dispositivo peer en el broker',
    DEVICE_NOT_ADOPTABLE: 'Solo un peer SASE visible no Teldat con peer id puede ser el dispositivo del portal',
    IP_POOL_EXHAUSTED: 'El pool no tiene direcciones IP disponibles',
    NO_CONNECTOR_NETWORKS:
      'El tenant no tiene ningún conector ZTNA que exponga una red LAN, así que el portal no alcanzaría nada. Añade antes interfaces LAN o rutas estáticas a un conector.',
    EMAIL: 'Correo electrónico',
    LOGIN_PASSWORD: 'Acceso',
    PASSWORD: 'Contraseña',
    CONFIRM_PASSWORD: 'Confirmar contraseña',
    PASSWORD_SET: 'Contraseña establecida',
    NO_PASSWORD: 'Sin contraseña',
    NO_LICENSE_SEAT: 'Sin plaza de licencia',
    SET_PASSWORD: 'Establecer contraseña',
    SET_PASSWORD_DESC:
      'Establezca la contraseña de acceso al portal para {name} ({email}). Iniciará sesión con su correo electrónico y esta contraseña.',
    PASSWORD_MIN_HINT: 'Al menos {min} caracteres.',
    PASSWORD_MISMATCH: 'Las contraseñas no coinciden',
    PASSWORD_SET_SUCCESS: 'Contraseña establecida correctamente',
    SET_PASSWORD_ERROR: 'Error al establecer la contraseña',
    PASSWORD_TOO_SHORT: 'La contraseña es demasiado corta (mínimo 8 caracteres)',
    EMAIL_REQUIRED_FOR_LOGIN:
      'Este usuario no tiene correo electrónico, que es necesario como nombre de acceso al portal',
    STATUS_TITLE: 'Estado del portal',
    STATUS_PENDING: 'Pendiente',
    STATUS_PROVISIONING: 'Aprovisionando',
    STATUS_ENROLLING: 'Registrando',
    STATUS_ACTIVE: 'Activo',
    STATUS_DEGRADED: 'Degradado',
    STATUS_OFFLINE: 'Sin conexión',
    STATUS_ERROR: 'Error',
    STATUS_DECOMMISSIONED: 'Retirado',
    STATUS_FETCH_ERROR: 'No se pudo cargar el estado del portal',
    NO_GATEWAY_TITLE: 'Todavía no hay ningún portal desplegado',
    NO_GATEWAY_MESSAGE:
      'Tu portal sin agente aún no se ha desplegado. Contacta con Teldat para ponerlo en marcha.',
    DOMAIN: 'Dominio del portal',
    HOSTING: 'Alojamiento',
    HOSTING_CLOUD: 'Nube',
    HOSTING_ON_PREM: 'En las instalaciones',
    TIER: 'Tamaño',
    TIER_LABEL: '{tier} (hasta {capacity} usuarios)',
    SEATS: 'Licencias',
    SEATS_USED: '{used} de {licensed} licenciadas',
    SEATS_UNLIMITED: '{used} en uso (sin límite de licencias)',
    PROVISIONED_USERS: 'Usuarios aprovisionados',
    ACTIVE_SESSIONS: 'Sesiones activas',
    RUNNING_BROWSERS: 'Navegadores en ejecución',
    DISK_FREE: 'Disco libre',
    MEMORY_FREE: 'Memoria libre',
    HEALTH: 'Salud',
    HEALTH_TUNNEL_DOWN: 'túnel caído',
    HEALTH_DISK_LOW: 'poco disco',
    HEALTH_MEMORY_LOW: 'poca memoria',
    CONNECTOR_NETWORKS: 'Redes de los conectores',
    NO_CONNECTOR_NETWORKS_SHORT: 'Sin redes de conectores',
    NO_CONNECTOR_NETWORKS_WARNING:
      'Tus conectores ZTNA no exponen ninguna red LAN, así que el portal no puede alcanzar ninguna aplicación. Añade interfaces LAN o rutas estáticas a un conector.',
    DECOMMISSIONED_TITLE: 'Sin portal',
    DECOMMISSIONED_MESSAGE:
      'Tu portal fue retirado el {date}. Contacta con Teldat para desplegar uno nuevo.',
    VERSION: 'Versión',
    LAST_HEARTBEAT: 'Último latido',
    NEVER: 'Nunca',
    TUNNEL: 'Túnel',
    TUNNEL_UP: 'Arriba',
    TUNNEL_DOWN: 'Caído',
    PUBLIC_IP: 'IP pública',
    PORTAL_SETTINGS: 'Ajustes del portal',
    PORTAL_SETTINGS_SAVED: 'Ajustes del portal guardados',
    PORTAL_SETTINGS_ERROR: 'Error al guardar los ajustes del portal',
    DNS_SERVERS: 'Servidores DNS',
    DNS_SERVERS_HELP:
      'Resolutores que usan los navegadores del portal para los nombres internos, separados por espacios. Vacío mantiene los valores por defecto del portal.',
    BROWSER_HOMEPAGE: 'Página de inicio',
    BROWSER_HOMEPAGE_HELP:
      'URL que abre cada navegador del portal al iniciarse, normalmente la página de entrada de tu intranet.',
    BROWSER_ADD_HOSTS: 'Hosts adicionales',
    BROWSER_ADD_HOSTS_HELP:
      'Entradas estáticas nombre a IP añadidas a los navegadores, una nombre:ip por línea, para hosts que tu DNS no resuelve.',
    CA_BUNDLE: 'Paquete de CA',
    CA_BUNDLE_HELP:
      'Certificados PEM en los que confían los navegadores, para que las aplicaciones HTTPS internas firmadas por tu propia CA abran sin avisos.',
    RECORDING_RETENTION: 'Retención de grabaciones (días)',
    RECORDING_RETENTION_HELP:
      'Cuántos días se conservan las grabaciones de sesión, de 1 a 3650. Las grabaciones más antiguas se eliminan del almacenamiento y ya no se pueden reproducir.',
    INVALID_RECORDING_RETENTION:
      'La retención de grabaciones debe ser un número entero de días entre 1 y 3650',
    RECORDINGS: 'Grabaciones',
    RECORDINGS_SUMMARY: '{pending} pendientes de subir, {local} en el portal',
    RECORDING_RETENTION_DAYS: 'Se conservan {days} días',
    RECORDING_STORAGE: 'Almacenamiento de grabaciones',
    RECORDING_STORAGE_NONE: 'Solo en el portal',
    RECORDING_STORAGE_PENDING: 'En preparación',
    GATEWAYS_TITLE: 'Portales ZTNA',
    GATEWAYS_FETCH_ERROR: 'No se pudieron cargar los portales',
    ACCOUNT: 'Tenant',
    USERS_SEATS: 'Usuarios / licencias',
    FILTER_STATUS: 'Estado',
    FILTER_ACCOUNT: 'Tenant',
    ALL_STATUSES: 'Todos los estados',
    ALL_ACCOUNTS: 'Todos los tenants',
    DEPLOY: 'Desplegar portal',
    DEPLOY_DESC:
      'Crea el portal y su peer en el broker para el tenant seleccionado. El tenant debe tener configurado antes su pool del portal.',
    SELECT_ACCOUNT: 'Selecciona un tenant',
    PORTAL_DOMAIN: 'Dominio del portal',
    PORTAL_DOMAIN_NO_SUFFIX: 'portal.ejemplo.com',
    PORTAL_DOMAIN_HELP:
      'Opcional. Déjalo vacío para nombrar el portal según el tenant bajo {suffix}, el sufijo DNS por defecto de este servidor.',
    PORTAL_DOMAIN_HELP_NO_SUFFIX:
      'Obligatorio: este servidor no tiene configurado un sufijo DNS por defecto.',
    PROVISIONING_STARTED:
      'Aprovisionamiento iniciado. El portal estará disponible en unos minutos.',
    GATEWAY_CREATED: 'Portal creado',
    REENROLL: 'Volver a registrar',
    REENROLL_TITLE: 'Emitir un nuevo token de registro',
    REENROLL_DESC:
      'Un nuevo token de un solo uso permite que el appliance de {account} se registre de nuevo (reinstalación, instalación en las instalaciones). El token anterior deja de funcionar.',
    RESIZE: 'Redimensionar',
    RESIZE_TITLE: 'Redimensionar portal',
    RESIZE_DESC:
      'Cambia el tamaño del portal de {account}. Un portal en la nube se redimensiona en el sitio y no está disponible durante unos minutos.',
    RESIZE_STARTED: 'Redimensionado aplicado',
    DECOMMISSION: 'Retirar',
    DECOMMISSION_TITLE: 'Retirar portal',
    DECOMMISSION_DESC:
      'El portal de {account} se desmantelará: se eliminan su VM, su registro DNS y su peer en el broker. El historial de sesiones se conserva. Esta acción no se puede deshacer.',
    DECOMMISSION_TYPE_NAME: 'Escribe el nombre del tenant ({account}) para confirmar',
    DECOMMISSIONED_SUCCESS: 'Portal retirado',
    RETRY: 'Reintentar',
    RETRY_TITLE: 'Reintentar despliegue del portal',
    RETRY_DESC:
      'El portal de {account} se despliega de nuevo en una VM nueva. Se elimina la VM del intento fallido. Se conservan el tenant, el tamaño y el dominio.',
    RETRY_STARTED: 'Aprovisionamiento reiniciado. El portal estará disponible en unos minutos.',
    TOKEN_TITLE: 'Token de registro',
    TOKEN_ONCE:
      'Este token se muestra una sola vez y caduca {expires}. Cópialo ahora; no se puede recuperar, solo sustituir con Volver a registrar.',
    TOKEN_COMMAND: 'En el appliance, ejecuta:',
    TOKEN_COPY: 'Copiar',
    TOKEN_COPIED: 'Copiado',
    TOKEN_CLOSE: 'Ya lo he copiado',
    ENROLLMENT_PENDING: 'Esperando el registro',
    TENANT_POOL_NOT_CONFIGURED:
      'El tenant aún no ha configurado su pool del portal. Pídele que lo configure en Configuración > ZTNA > Portal primero.',
    TENANT_NOT_LICENSED:
      'El tenant seleccionado no tiene una licencia activa de ZTNA Agentless',
    REFRESH: 'Actualizar',
    SIGN_IN: 'Inicio de sesión del portal',
    SIGN_IN_HELP: 'Cómo inician sesión los usuarios del portal. Los usuarios locales (creados aquí) usan siempre su contraseña del portal. Con el inicio de sesión con Microsoft activo, los usuarios importados por la conexión de Azure AD de abajo entran con Microsoft, con el MFA que exija su tenant de Entra. Ambos tipos pueden estar a la vez en el portal.',
    ENTRA_ENABLED: 'Iniciar sesión con Microsoft Entra ID',
    ENTRA_ENABLED_HELP: 'Añade "Sign in with Microsoft" a la página de inicio de sesión del portal, junto al formulario de contraseña de los usuarios locales.',
    REQUIRE_MFA_CLAIM: 'Exigir MFA',
    REQUIRE_MFA_CLAIM_HELP: 'Rechaza los inicios de sesión de Entra cuyo token no indique que se usó autenticación multifactor.',
    AZURE_AD_CONNECTION: 'Conexión de Azure AD',
    AZURE_AD_CONNECTION_HELP: 'Administración > Conexiones de servidor > Azure AD. Su registro de aplicación necesita el URI de redirección que se muestra allí.',
    SELECT_CONNECTION: 'Seleccione una conexión',
    NO_AZURE_AD_CONNECTIONS: 'Esta cuenta no tiene conexión de Azure AD. Añada una antes en Administración > Conexiones de servidor > Azure AD.',
    REDIRECT_URI: 'URI de redirección',
    REDIRECT_URI_MISSING: 'No disponible: este beSafe Pro no tiene URL pública configurada. Contacte con soporte.',
    SIGN_IN_SAVED: 'Inicio de sesión del portal guardado',
    SIGN_IN_ERROR: 'No se pudo guardar el inicio de sesión del portal',
    SIGN_IN_FETCH_ERROR: 'No se pudo cargar el inicio de sesión del portal',
    SIGN_IN_STATUS_NEEDS_CONNECTION: 'El inicio de sesión con Microsoft está desactivado hasta que elija una conexión de Azure AD.',
    SIGN_IN_STATUS_CONNECTION_INCOMPLETE: 'La conexión de Azure AD está incompleta: su ID de tenant debe ser un GUID y necesita un ID de cliente y un secreto.',
    MICROSOFT_SIGN_IN: 'Inicio de sesión con Microsoft',
    SSO_CONNECTION_REQUIRED: 'Elija una conexión Azure AD antes de activar el inicio de sesión con Microsoft',
    ENTRA_USER_NO_PASSWORD: 'Los usuarios de Entra ID inician sesión con Microsoft y no tienen contraseña del portal',
    INVALID_GROUP: 'El objeto seleccionado no es un grupo de usuarios de esta cuenta',
    LOCAL_GROUP_NOT_ALLOWED: 'Solo se pueden añadir al portal grupos importados de Entra ID',
    GROUP_NOT_FOUND: 'No se ha encontrado el grupo del portal',
    GROUP_MEMBERS: '{count, plural, one {# miembro} other {# miembros}}',
    GROUP_REMOVED: 'Grupo eliminado del portal',
    REMOVE_GROUP_ERROR: 'No se ha podido eliminar el grupo del portal',
    CONFIRM_REMOVE_GROUP_DESC: '¿Eliminar el grupo {name} del portal? Sus miembros pierden el acceso salvo que también se hayan añadido a mano o mediante otro grupo.',
    GROUP_MEMBERS_WITHOUT_ACCESS_WARNING: '{count, plural, one {# miembro} other {# miembros}} de los grupos del portal no {count, plural, one {tiene} other {tienen}} acceso: las plazas de licencia o las IPs del pool están agotadas.',
    SSO_INVALID_TENANT_ID: 'El ID de directorio (tenant) debe ser un GUID',
    SSO_INVALID_AZURE_AD_CONNECTION: 'Seleccione una conexión de Azure AD de esta cuenta',
    SSO_INCOMPLETE: 'El inicio de sesión con Entra ID necesita un ID de tenant, un ID de cliente y un secreto de cliente',
  },
  IPSECVPN_REMOTE: {
    CONFIRM_DELETE: '¿Desea eliminar el túnel?',
    DELETE_SUCCESS: 'Túnel borrado con éxito',
    DELETE_ERROR: 'Error al borrar túnel',
    NAME: 'Nombre',
    SOURCE: 'IP Pool',
    INTERFACES: 'Interfaces',
    PORT: 'Puerto',
    ENABLE_SPLIT_TUNNELING: 'Activar división de túnel',
    SPLIT_TUNNELING: 'Túnel dividido',
    TITLE: 'IPSEC Vpn',
    SUCCESS_CREATE: 'Túnel creado con éxito',
    ERROR_CREATE: 'Error al crear túnel',
    SUCCESS_UPDATE: 'Túnel actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar túnel',
    EDIT_TUNNEL: 'Editar túnel',
    ADD_TUNNEL: 'Crear túnel',
    BUILD_EXE: 'Build de Windows',
    SUCCESS_BUILD:
      'Build iniciado satisfactoriamente. El ejecutable estará disponible en unos minutos. Por favor, espera a que el proceso se complete.',
    BUILD_STATUS:
      'Un build está actualmente en progreso. Por favor, intenta la creación en masa después de 5 minutos.',
    NO_USERS: 'No hay usuarios asignados al tunel',
  },
  VPN_USERS: {
    TITLE: 'Usuarios',
    SUCCESS_CREATE: 'Usuario creado con éxito',
    ERROR_CREATE: 'Error al crear usuario',
    SUCCESS_UPDATE: 'Usuario actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar usuario',
    EDIT_USER: 'Editar Usuario',
    ADD_USER: 'Crear Usuario',
    CONFIRM_DELETE: '¿Desea eliminar el usuario?',
    DELETE_SUCCESS: 'Usuario borrado con éxito',
    DELETE_ERROR: 'Error al borrar usuario',
    EMAIL: 'Email',
    GROUPS: 'Grupos',
    GLOBAL_SETTINGS: 'Configuración de usuarios',
    LOCAL: 'Usuarios locales',
  },
  TENANT: {
    ID: 'ID',
    CIF: 'CIF',
    CIF_ALREADY_EXISTS: 'CIF ya está en uso',
    DUPLICATED_EMAIL: 'Correo electrónico ya esta en uso',
    DUPLICATED_NAME: 'Nombre de cliente ya esta en uso',
    IPS_TYPE_ADVANCED: 'Avanzado',
    IPS_TYPE_BASIC: 'Básico',
    IPS_TYPE: 'Tipo de IPS',
    SUCCESS: 'El cliente ha sido creado con éxito',
    TYPE: 'Tipo',
    TYPE_CARRIER: 'Carrier',
    TYPE_RESELLER: 'Distribuidor',
    TYPE_UTM: 'UTM',
    DETAILS: 'Detalles del cliente',
    ADMINISTRATOR: 'Administrador',
    CLOUD_DEVICES: 'Dispositivos Cloud',
    UUID: 'UUID',
    ADD_CLOUD_DEVICE: 'Agregar dispositivo Cloud',
    CLOUD_IP: 'IP',
    UPDATE_SUCCESS: 'El cliente ha sido actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el cliente',
    NAME: 'Nombre',
    SHARED_SASE: 'Cliente SASE compartido',
    SHARED_SASE_HINT:
      'Los clientes SASE compartidos pueden asociarse a un grupo de dispositivos cloud multi-tenant en lugar de usar dispositivos cloud dedicados.',
    SHARED_SASE_LOCKED:
      'El cliente está asociado a dispositivos compartidos, por lo que no se puede desactivar SASE compartido',
    SHARED_SASE_LOCKED_HINT:
      'Primero desasocia el cliente de sus dispositivos compartidos',
    PORTAL_STILL_DEPLOYED:
      'Retira primero el portal ZTNA del cliente y espera a que aparezca como Retirado.',
  },
  SHARED_DEVICE_GROUPS: {
    TENANTS: 'Clientes',
    SITES: 'Sedes',
    SSL_USERS: 'Usuarios SSL',
    TENANT: 'Cliente',
    SLOT: 'Slot',
    OPENVPN_PORT: 'Puerto SSL VPN',
    OPENVPN_PORT_PLACEHOLDER: 'Automático',
    ATTACH: 'Asociar cliente',
    DETACH: 'Desasociar cliente',
    PANEL_HEADER: '{name} · {count} dispositivos',
    SELECT_TENANT: 'Cliente SASE compartido',
    SELECT_TENANT_PLACEHOLDER: 'Selecciona un cliente',
    ATTACH_SUCCESS: 'Cliente asociado con éxito',
    DETACH_SUCCESS: 'Cliente desasociado con éxito',
    SELECT_GROUP: 'Grupo de dispositivos compartidos',
    SELECT_GROUP_PLACEHOLDER: 'Selecciona un grupo',
    GROUP_USAGE: 'clientes {used}/{total}',
    CONFIRM_DETACH:
      '¿Seguro que deseas desasociar {tenant} de este grupo de dispositivos compartidos?',
  },
  CAPACITY: {
    SITES_LIMIT_EXCEEDED:
      'No hay capacidad de sedes suficiente en el grupo de dispositivos (solicitado {requested}, disponible {available})',
    SSL_USERS_LIMIT_EXCEEDED:
      'No hay capacidad de usuarios SSL suficiente en el grupo de dispositivos (solicitado {requested}, disponible {available})',
    TENANTS_LIMIT_EXCEEDED:
      'El grupo de dispositivos ha alcanzado su número máximo de clientes',
    TENANT_NOT_SHARED: 'El cliente seleccionado no es un cliente SASE compartido',
  },
  VPN_USER_GROUPS: {
    TITLE: 'Grupos de usuarios',
    SUCCESS_CREATE: 'Grupo creado con éxito',
    ERROR_CREATE: 'Error al crear grupo',
    SUCCESS_UPDATE: 'Grupo actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar grupo',
    EDIT_GROUP: 'Editar Grupo',
    ADD_GROUP: 'Crear Grupo',
    CONFIRM_DELETE: '¿Desea eliminar el grupo?',
    DELETE_SUCCESS: 'Grupo borrado con éxito',
    DELETE_ERROR: 'Error al borrar grupo',
    LOCAL_GROUPS: 'Grupos de usuario',
    USERS: 'Usuarios',
  },
  ZTNA_BRANCHES: {
    USERS_TITLE: 'Usuarios de oficina',
    GROUPS_TITLE: 'Grupos de oficina',
  },
  HELP_MODAL: {
    DEVICE_EXPECTED_HEADERS: 'Cabeceras esperadas (separadas por coma)',
    DEVICE_EXPECTED_ROWS: 'Filas (separadas por coma)',
    DEVICE_ROWS:
      'Número de serie o UUID,Nombre,IP,Conexión SASE*,Pre-Shared Key*,Extensión CLI,Peer ID,DVC,Número de Cores,Descripción,Modelo*,Tipo*,Objetos Red,Grupos Red,Direcciones IPv4*,Direcciones IPv6*,Licencias*',
    DEVICE_POSSIBLE_SASE_CONNECTION: '* Conexión SASE debe ser true o false',
    DEVICE_POSSIBLE_PRE_SHARED_KEY:
      '* Pre-Shared Key es obligatorio para dispositivos tipo "Others". Para dispositivos Teldat y ZTNA_Connector, puede estar vacío ya que el PSK se generará automáticamente al activar la conexión SASE o ZTNA. Formato: texto plano (mín 8 caracteres) o pre-encriptado (Base64 de 44 caracteres)',
    DEVICE_POSSIBLE_MODELS:
      '* Posibles valores de Modelo: RS420, Celer, M2, M10, Regesta, Atlas 840, M20, H5-Rail, H5-Auto, VM, SDE-10K, SDE-20K, SDE-22K, SDE-24K, ARES C640, TE-100, TE-200, TE-220, TE-400, TE-600',
    DEVICE_POSSIBLE_TYPES:
      '* Posibles valores de Tipo: Teldat, Others, ZTNA_Connector',
    DEVICE_POSSIBLE_NETWORKS:
      "* Objetos Red y Grupos Red deben ser nombres (separados por ';')",
    DEVICE_POSSIBLE_ADDRESSES:
      "* Direcciones IPv4/IPv6 son direcciones de red opcionales (separadas por ';'). Si se proporcionan, las redes se crearán automáticamente si no existen. El orden debe coincidir con la columna Objetos Red.",
    DEVICE_LICENSES_LEGEND: '* Leyenda de licencias:',
    DEVICE_POSSIBLE_LICENSES:
      "Valores posibles (separados por ';'): UTM_R_AS, UTM_M_AS, UTM_A_AS, UTM_M20_AS, UTM_V_AS, UTM_R_AV, UTM_M_AV, UTM_A_AV, UTM_M20_AV, UTM_V_AV, UTM_R_AC, UTM_M_AC, UTM_A_AC, UTM_M20_AC, UTM_V_AC, UTM_R_DLP, UTM_M_DLP, UTM_A_DLP, UTM_M20_DLP, UTM_V_DLP, UTM_R_FW, UTM_M_FW, UTM_A_FW, UTM_M20_FW, UTM_V_FW, UTM_R_IPS, UTM_M_IPS, UTM_A_IPS, UTM_M20_IPS, UTM_V_IPS, UTM_R_IPSOT, UTM_M_IPSOT, UTM_A_IPSOT, UTM_M20_IPSOT, UTM_V_IPSOT, UTM_R_SSL, UTM_M_SSL, UTM_A_SSL, UTM_M20_SSL, UTM_V_SSL, UTM_R_RA, UTM_M_RA, UTM_A_RA, UTM_M20_RA, UTM_V_RA, UTM_R_UF, UTM_M_UF, UTM_A_UF, UTM_M20_UF, UTM_V_UF, UTM_R_CB, UTM_M_CB, UTM_A_CB, UTM_M20_CB, UTM_V_CB, UTM_R_DNS, UTM_M_DNS, UTM_A_DNS, UTM_M20_DNS, UTM_V_DNS, UTM_R_UID, UTM_M_UID, UTM_A_UID, UTM_M20_UID, UTM_V_UID, UTM_R_VPNTUN, UTM_M_VPNTUN, UTM_A_VPNTUN, UTM_M20_VPNTUN, UTM_V_VPNTUN, BS_AS, BS_AV, BS_AC, BS_DLP, BS_FW, BS_IPS, BS_IPSOT, BS_SSL, BS_ZTNA, BS_RA, BS_UF, BS_CB, BS_DNS, BS_UID, BS_VPNTUN",
  },
  DNS_FORWARDER: {
    INVALID_DNS_1: 'El DNS Forwarder primario no es válido',
    INVALID_DNS_2: 'El DNS Forwarder secundario no es válido',
    BLOCK_DISABLE_SAFE_SEARCH:
      'El DNS Forwarder no puede deshabilitarse mientras el dispositivo tenga asociado un perfil Firewall con la protección de búsquedas activada',
    UNKNOWN_INTERFACE:
      'El DNS Forwarder no puede escuchar en un interfaz que el dispositivo no tiene',
  },
  DNS_RESOLVER: {
    INVALID_DNS_1: 'El DNS Resolver primario no es válido',
    INVALID_DNS_2: 'El DNS Resolver secundario no es válido',
    BLOCK_DISABLE: 'El DNS Resolver no puede deshabilitarse',
  },
  TRUST: {
    VERY_LOW: 'Muy Bajo',
    LOW: 'Bajo',
    MEDIUM: 'Medio',
    HIGH: 'Alto',
    VERY_HIGH: 'Muy Alto',
  },
  ACTIONS: {
    ALLOW: 'Permitir',
    DETECT: 'Detectar',
    BLOCK: 'Bloquear',
  },
  CASB_RULES: {
    ADD: 'Creada',
    CONFIRM_DELETE: '¿Está seguro de borrar esta regla CASB?',
    DUPLICATED_NAME: 'Nombre ya registrado',
    EDIT: 'Actualizada',
    ERROR_ADD: 'Error al crear la regla CASB',
    ERROR_EDIT: 'Error al actualizar la regla CASB',
    SUCCESS_ADD: 'Regla CASB creada correctamente',
    SUCCESS_DELETE: 'Regla CASB eliminada correctamente',
    SUCCESS_EDIT: 'Regla CASB actualizada correctamente',
  },
  DLP_OBJECTS: {
    NAME: 'Nombre',
    DESCRIPTION: 'Descripción',
    EXPRESSION: 'Expresión',
    EDIT: 'Editar objeto DLP',
    ADD: 'Añadir objeto DLP',
    EDIT_SUCCESS: 'Objeto DLP actualizado correctamente',
    EDIT_ERROR: 'Error al actualizar objeto DLP',
    ADD_SUCCESS: 'Objeto DLP añadido correctamente',
    ADD_ERROR: 'Error al añadir objeto DLP',
    LOAD_ERROR: 'Error al cargar los objetos DLP',
    DETAIL_ERROR: 'Error al cargar detalles del objeto DLP',
    ALREADY_IN_USE: 'Ya en uso',
    DELETE_SUCCESS: 'Objeto DLP borrado correctamente',
  },
  DLP_RULES: {
    EDIT_SUCCESS: 'Regla DLP actualizada correctamente',
    EDIT_ERROR: 'Error al actualizar regla DLP',
    ADD_SUCCESS: 'Regla DLP añadida correctamente',
    ADD_ERROR: 'Error al añadir regla DLP',
    LOAD_ERROR: 'Error al cargar las reglas DLP',
    DELETE_SUCCESS: 'Regla DLP borrada correctamente',
    NAME: 'Reglas DLP',
  },
  PROTOCOL_PORTS: {
    UNWANTED_CHARACTERS:
      'Caracteres no deseados. Asegure emplear sólo números, comas y espacios.',
    NOT_IN_RANGE: 'Uno o más puertos de los especificados no es válido',
  },
  SSL_EXCEPTION: {
    DUPLICATE_NAME: 'Nombre ya registrado',
    EMPTY_NAME: 'Nombre no puede ser vacío',
  },
  SASE: {
    MAX_SASE_DEVICES_REACHED:
      'Se ha alcanzado el número máximo de 1000 dispositivos conectados por SASE.',
    ACTIVE_PROFILE:
      'No se puede modificar el perfil VPN de un dispositivo con conexión SASE activa',
    PROFILE_FULL:
      'No se puede asignar a este dispositivo el perfil VPN de un dispositivo con conexión SASE activa',
    MISSING_ACTIVE_CLOUD_LICENSES:
      'La conexión SASE requiere que el dispositivo tenga licencias cloud activas',
    MISSING_ASSOCIATED_NETWORKS:
      'La conexión SASE requiere que el dispositivo tenga redes asociadas',
    CANNOT_UPDATE_BRANCH_PROFILE:
      'No se puede cambiar el perfil de Firewall de un dispositivo con reglas de ZTNA asociadas',
    CANNOT_DISABLE_BRANCH_SASE_CONNECTION:
      'No se puede deshabilitar la conexión SASE de un dispositivo con reglas de ZTNA asociadas',
  },
  IPSEC_VPN: {
    TITLE: 'Tuneles VPN IPSec L2L',
    PHASE1: 'Fase 1',
    ENCRYPTION: 'Cifrado',
    HASH: 'Hash',
    MAXIMUM_PROPOSALS_REACHED: 'Sólo se permiten 20 Proposiciones',
    MAX_SECOND_PHASES: 'Sólo se permiten 10 Segundas fases',
    CONFIRM_DELETE: '¿Desea eliminar el túnel?',
    DELETE_SUCCESS: 'Túnel borrado con éxito',
    DELETE_ERROR: 'Error al borrar túnel',
    SUCCESS_CREATE: 'Túnel creado con éxito',
    ERROR_CREATE: 'Error al crear túnel',
    SUCCESS_UPDATE: 'Túnel actualizado con éxito',
    ERROR_UPDATE: 'Error al actualizar túnel',
    EDIT_TUNNEL: 'Editar túnel',
    ADD_TUNNEL: 'Crear túnel',
    REMOTE_PEER: 'Peer Remoto',
    LOCAL_INTERFACE: 'Interfaz Local',
    HOSTNAME: 'Nombre del host',
    IP: 'IP',
    IKE: 'Versión IKE',
    DEAD_PEER_DETECTION: 'Dead peer detection',
    ACTION: 'Acción',
    INTERVAL: 'Intervalo (1-86400 segs)',
    TIMEOUT: 'Timeout (1-86400 segs)',
    AUTHENTICATION: 'Autenticación',
    PRESHARED_KEY: 'Clave pre-compartida',
    LOCAL_ID: 'ID local',
    REMOTE_ID: 'ID remoto',
    PROPOSALS: 'Proposal',
    DIFFIE_HELLMAN_GROUPS: 'Grupos Diffie Hellman',
    IKE_LIFETIME: 'Tiempo de vida del IKE (30-86400)',
    IKE_MODE: 'Modo IKE',
    PHASE2: 'Fase 2',
    LOCAL_SELECTOR: 'Selector Local',
    REMOTE_SELECTOR: 'Selector Remoto',
    PERFECT_FORWARD_SECRECY: 'Perfect Forward Secrecy',
    MODE: 'Modo',
    LIFETIME_TYPE: 'Tipo de tiempo de vida',
    LIFETIME: 'Tiempo de vida',
    COMPRESSION: 'Compresión',
    TUNNEL: 'Tunel',
    TRANSPORT: 'Transporte',
    SECONDS: 'Segundos',
    MB: 'MB',
    PACKETS: 'Paquetes',
    AES128: 'Cifrado AES-128 con CBC *',
    AES192: 'Cifrado AES-192 con CBC *',
    AES256: 'Cifrado AES-256 con CBC *',
    AES128GCM128: 'Cifrado AES-128 con Galois Counter Mode 128-bit',
    AES192GCM128: 'Cifrado AES-192 con Galois Counter Mode 128-bit',
    AES256GCM128: 'Cifrado AES-256 con Galois Counter Mode 128-bit',
    AES128GMAC: 'Cifrado Null con AES-128 Galois Message Authentication Code',
    AES192GMAC: 'Cifrado Null con AES-192 Galois Message Authentication Code',
    AES256GMAC: 'Cifrado Null con AES-256 Galois Message Authentication Code',
    AES192GCM64: 'Cifrado AES-192 con GCM and 64 bit ICV',
    AES128CCM64: 'Cifrado AES-128 con CCM and 64 bit ICV',
    AES192CCM64: 'Cifrado AES-192 con CCM and 64 bit ICV',
    AES256CCM64: 'Cifrado AES-256 con CCM and 64 bit ICV',
    '3DES': 'Cifrado 3DES',
    CHACHA20POLY1305: 'Cifrado ChaCha20-Poly1305',
    NULL: 'Cifrado Null',
    MD5: 'Hash MD5',
    SHA1: 'Hash SHA1',
    SHA256: 'Hash SHA2-256',
    SHA384: 'Hash SHA2-384',
    SHA512: 'Hash SHA2-512',
    ENCRYPTION_NOTE: 'Algoritmo de cifrado acelerado por hardware',
    ADD_TUNNEL_ABOVE: 'Añadir tunel arriba',
    ADD_TUNNEL_BELOW: 'Añadir tunel debajo',
    ADD_TUNNEL_TOP: 'Añadir tunel al principio',
    ADD_TUNNEL_BOTTOM: 'Añadir tunel al final',
    PHASE_2_REMOTE_PREFIX: 'Prefijo remoto de la fase 2',
    WRONG_INTERVAL: 'El intervalo debe ser un valor entre 1 y 86400',
    WRONG_TIMEOUT: 'El timeout debe ser un valor entre 1 y 86400',
    WRONG_IKE_LIFETIME:
      'El tiempo de vida de IKE debe ser un valor entre 30 y 86400',
    WRONG_LIFETIME: 'El tiempo de vida debe ser un valor entre 0 y 4294967295',
    WRONG_XFRM_INDEX: 'El número de interfaz XFRM debe estar entre 0 y 1999',
    WRONG_IPSEC_MODE: 'Modo IPSec no válido',
    MAX_TENANT_TUNNELS_REACHED:
      'Ha alcanzado el número máximo de túneles VPN (10)',
    MAX_TUNNEL_NETWORKS_REACHED:
      'Un túnel puede tener como máximo 10 redes',
    DUPLICATED_REMOTE_ID_IN_GROUP:
      'Este ID remoto ya está en uso. Elija uno diferente',
    IPSEC_MODE: 'Modo IPSec',
    ROUTE_BASED: 'Basado en rutas',
    POLICY_BASED: 'Basado en políticas',
    VIRTUAL_TUNNEL_INTERFACE_NAME: 'Nombre de interfaz XFRM',
    ADD_ROUTE_AUTO: 'Configuración de enrutamiento automático',
    CONNECTION_TYPE: 'Tipo de conexión',
    ON_DEMAND: 'Bajo demanda',
    INITIATE: 'Iniciador',
    RESPOND: 'Respondedor',
    ANY: '%any',
    ANY_TOOLTIP: "Sólo activo cuando el tipo de conexión es 'Responder'",
    PROTECTED_TUNNEL: 'El túnel no puede ser editado porque está protegido',
    SASE_TUNNEL_UPDATE:
      'No se puede editar un túnel con una conexión SASE activa',
    SASE_TUNNEL_DELETE:
      'No se puede eliminar un túnel con una conexión SASE activa',
    LOCAL_AND_REMOTE_NETWORKS_NUMBER_EXCEEDED:
      'El número de redes para los selectores locales y remotos es demasiado alto',
    LOCAL_NETWORKS_NUMBER_EXCEEDED:
      'El número de redes para los selectores locales es demasiado alto',
    REMOTE_NETWORKS_NUMBER_EXCEEDED:
      'El número de redes para los selectores remotos es demasiado alto',
  },
  USER_LOGINS: {
    EMAIL: 'Email de usuario',
    DATE: 'Fecha',
    RESULT: 'Resultado',
    REMOTE_ADDRESS: 'Dirección remota',
    LOGIN_ERROR: 'El inicio de sesión ha fallado',
  },
  LIST_MODAL: {
    SOURCE_SELECT: 'Seleccionar Origen',
    CERTIFICATE_SELECT: 'Seleccionar Certificado',
  },
  USER_MANUAL: {
    CARRIER_FILENAME: 'v1.1.0_carrier_es.pdf',
    UTM_FILENAME: 'v1.1.2_utm_es.pdf',
  },
  THREAT_INTEL: {
    VERSION: 'Versión',
    LAST_UPDATE: 'Última actualización',
    LAST_CHECK: 'Última comprobación',
    CLOUD: 'Cloud',
    MANAGED_DEVICES: 'Dispositivos gestionados',
  },
  BESAFE_GROUPS: {
    INVALID_ASSOCIATED_OBJECTS: 'Objetos asociados no válidos para el grupo',
    INVALID_EDITABLE: 'Editable no válido para el grupo',
    INVALID_IP_PROTOCOL: 'Protocolo IP no válido para el grupo',
    INVALID_TYPE: 'Tipo no válido para el grupo',
    MISSING_ASSOCIATED_OBJECTS: 'Faltan objetos asociados para el grupo',
    DUPLICATED_ASSOCIATED_OBJECTS:
      'Hay objetos presentes en el grupo de inclusión y exlusión simultáneamente',
    MISSING_IP_PROTOCOL: 'Falta protocolo IP para el grupo',
    MISSING_NAME: 'Falta nombre para el grupo',
    MISSING_TYPE: 'Falta tipo para el grupo',
    ZTNA_RULE_IN_USE:
      'El grupo no se puede modificar porque está siendo usado en una regla ZTNA',
    PORTAL_IN_USE: 'El grupo no se puede eliminar porque lo usa el portal ZTNA sin agente',
  },
  ZTNA: {
    RULES: 'Reglas',
    CONNECTOR: 'Conector',
    CONNECTORS: 'Conectores',
    APPLICATION: 'Aplicación',
    APPLICATIONS: 'Aplicaciones',
    ADD_RULE_TITLE: 'Añadir nueva regla ZTNA',
    ADD_SUCCESS: 'Regla ZTNA creada con éxito',
    ADD_ERROR: 'Error al crear regla ZTNA',
    EDIT_RULE_TITLE: 'Editar regla ZTNA',
    EDIT_SUCCESS: 'Regla ZTNA actualizada con éxito',
    EDIT_ERROR: 'Error al actualizar regla ZTNA',
    DELETE_SUCCESS: 'Regla ZTNA eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar regla ZTNA',
    ADD_RULE_ABOVE: 'Añadir regla ZTNA arriba',
    ADD_RULE_BELOW: 'Añadir regla ZTNA debajo',
    ADD_RULE_TOP: 'Añadir regla ZTNA al principio',
    ADD_RULE_BOTTOM: 'Añadir regla ZTNA al final',
    SSL_PROFILE_PROTOCOL_ERROR: 'Perfil SSL sólo se puede usar con HTTPS',
    CONFIRM_DELETE: '¿Está seguro de que quiere eliminar esta regla ZTNA?',
    MISSING_ZTNA_APPLICATIONS: 'Falta la aplicación ZTNA',
    ERROR_ZTNA_APPLICATIONS_NUMBER: 'La regla ZTNA tiene demasiadas aplicaciones',
    MIXED_APPLICATION_TYPES:
      'Una regla ZTNA no puede mezclar aplicaciones web (HTTP/HTTPS) con otras aplicaciones',
    INVALID_ZTNA_APPLICATIONS:
      'Una o más aplicaciones seleccionadas no están disponibles',
    MISSING_ZTNA_CONNECTORS: 'Falta el conector ZTNA',
    ERROR_ZTNA_CONNECTORS_NUMBER:
      'Solo se puede asociar un conector a la regla ZTNA',
    CONNECTOR_IN_RULE: 'El conector está asociado a una regla ZTNA',
    TUNNEL_IN_RULE: 'El túnel está asociado a una regla ZTNA',
    REQUIRED_SOURCES_ERROR:
      'La regla ZTNA debe tener un elemento seleccionado como Origen',
    REQUIRED_APPLICATION_ERROR: 'Se requiere al menos una aplicación ZTNA',
    DESTINATION: 'Destino',
    MIXING_TUNNEL_AND_USERS_ERROR:
      'La regla ZTNA no debe combinar túneles SSL VPN con usuarios como Origen',
    CONNECTOR_SELECT: 'Seleccionar Conector',
    APPLICATION_SELECT: 'Seleccionar Aplicaciones',
    APPLICATION_IP_NOT_IN_NETWORK:
      'La IP de la aplicación no está ncluida en las lans o rutas estáticas del conector',
    MASQUERADE_SNAT: 'Masquerade SNAT',
    MASQUERADE_SNAT_REQUIRED_FOR_PORTAL:
      'Siempre activo para usuarios del portal agentless: las aplicaciones no tienen ruta de vuelta al portal',
    MASQUERADE_SNAT_NOT_ALLOWED_ON_REVERSE:
      'Masquerade SNAT no está permitido en reglas ZTNA inversas',
    WILDCARD_NOT_ALLOWED_ON_REVERSE:
      'Las reglas ZTNA inversas no pueden referenciar aplicaciones con URLs con comodín',
    PORTAL_TAB: 'Portal',
  },
  ZTNA_SOURCES: {
    CONFIRM_EMPTY_MAC:
      '¿Está seguro de que desea agregar usuarios sin direcciones MAC?',
  },
  ZTNA_APPLICATIONS: {
    REQUIRED_NAME: 'Nombre requerido',
    REQUIRED_SERVICE: 'Servicio requerido',
    REQUIRED_IP: 'IP requerida',
    REQUIRED_URL: 'URL requerida',
    DELETE_TITLE: 'Eliminar Aplicación ZTNA',
    DELETE_DESCRIPTION:
      '¿Está seguro de que desea eliminar la aplicación ZTNA {name}?',
    SUCCESS_DELETE: 'Aplicación ZTNA eliminada con éxito',
    TABLE_TITLE: 'Aplicaciones ZTNA',
    NAME: 'Nombre',
    DESCRIPTION: 'Descripción',
    URL: 'URL',
    IP: 'IP',
    SERVICE: 'Servicio',
    ADD: 'Añadir Aplicación ZTNA',
    EDIT: 'Editar Aplicación ZTNA',
    SUCCESS_ADD: 'Aplicación ZTNA añadida con éxito',
    SUCCESS_EDIT: 'Aplicación ZTNA actualizada con éxito',
    ERROR_ADD: 'Error al añadir Aplicación ZTNA',
    ERROR_EDIT: 'Error al actualizar Aplicación ZTNA',
    DUPLICATED_NAME: 'Nombre duplicado',
    INVALID_IP: 'IP no válida',
    INVALID_URL: 'URL no válida',
    CANNOT_DELETE_WITH_RULES:
      'No se puede eliminar la aplicación con reglas asociadas',
    IN_USE: 'La aplicación ZTNA está en uso y no se puede modificar',
  },
  TABLE_HEADERS: {
    NAME: 'Nombre',
    MAC_ADDRESSES: 'Direcciones MAC',
  },
  CLI: {
    DEVICE_NAT_EXTERNAL_INTERFACE_ERROR:
      'El dispositivo debe tener una interfaz externa válida para usar la extensión CLI',
    DEVICE_NAT_INTERNAL_INTERFACE_ERROR:
      'El dispositivo debe tener una interfaz interna válida para usar la extensión CLI',
    SYSTEM_OBJECT_UNRESOLVED:
      'No se ha enviado la configuración: no se ha podido resolver la dirección de {object} (hosts: {hosts}). Compruebe que se resuelven desde el servidor de BeSafe Pro.',
  },
  PROFILES: {
    FILTER: 'Perfiles',
  },
  EVENTS: {
    NO_CORRELATION_ID: 'Este evento no tiene un log de tráfico correlacionado',
    RELATED_SESSION_EVENT_NOT_FOUND: 'Log de tráfico relacionado no encontrado',
    EVENT_NOT_FOUND: 'Evento no encontrado',
  },
  SESSION_EVENTS: {
    NO_CORRELATION_ID:
      'Este log de tráfico no tiene un evento de seguridad correlacionado',
    RELATED_EVENT_NOT_FOUND: 'Evento de seguridad relacionado no encontrado',
    SESSION_EVENT_NOT_FOUND: 'Log de tráfico no encontrado',
    TIMESTAMP_REQUIRED: 'El parámetro timestamp es requerido',
    INVALID_NETWORK_TUPLE:
      'Faltan parámetros requeridos para la búsqueda de tráfico',
    INVALID_DATE_FORMAT: 'Formato de fecha inválido',
    INVALID_PORT: 'Número de puerto inválido',
    NO_RELATED_TRAFFIC_FOUND: 'No se encontró tráfico relacionado',
  },
  VPNCLIENTCONFIG: {
    NETWORK_SLA: 'SLA de Red',
    NETWORK_SLA_HELPER:
      'Solo se permiten direcciones IP individuales (p. ej. 8.8.8.8) y dominios FQDN para la monitorización SLA.',
    NETWORK_SLA_TARGET: 'Destino',
    NETWORK_SLA_PROTOCOL: 'Protocolo',
    NETWORK_SLA_PORT: 'Puerto',
    EDIT_NETFLOW_CONFIG: 'Editar la configuración de NetFlow',
    ADD_COLLECTOR: 'Añadir collector',
    COLLECTOR_LIMIT_REACHED: 'Máximo {max} collectors',
    NETWORK_SLA_COLLECTORS_LABEL: 'Network SLA syslog collectors',
    NETWORK_SLA_COLLECTORS_HINT:
      'La información de Network SLA solo se envía a los collectors de esta lista. Sin ningún collector, no se envía.',
    ARGUS_COLLECTORS_LABEL: 'Argus syslog collectors',
    ARGUS_COLLECTORS_HINT:
      'Los eventos de Argus siempre se envían a esta instancia de BeSafe Pro. Los collectors de esta lista también los reciben.',
    NETWORK_SLA_COLLECTOR_CONFIG_LIMIT: 'Se permite un máximo de 3 network SLA collectors',
    ARGUS_COLLECTOR_CONFIG_LIMIT: 'Se permite un máximo de 3 Argus collectors',
    NETWORK_SLA_COLLECTOR_CONFIG: 'Network SLA Collector Config',
    COLLECTOR_HOST: 'Host',
    COLLECTOR_PROTOCOL: 'Protocolo',
    COLLECTOR_PORT: 'Puerto',
    NETWORK_SLA_COLLECTOR_CONFIG_INVALID_PAYLOAD: 'Datos de network SLA collector no válidos',
    NETFLOW_CONFIG_INVALID_PAYLOAD: 'Datos de NetFlow no válidos',
    ARGUS_COLLECTOR_CONFIG: 'Argus Collector Config',
    ARGUS_COLLECTOR_CONFIG_WRONG_HOST: 'Host de Argus collector no válido',
    ARGUS_COLLECTOR_CONFIG_WRONG_PORT: 'Puerto de Argus collector no válido',
    ARGUS_COLLECTOR_CONFIG_WRONG_PROTOCOL: 'Protocolo de Argus collector no válido',
    ARGUS_COLLECTOR_CONFIG_DUPLICATE: 'Argus collector duplicado',
    ARGUS_COLLECTOR_CONFIG_INVALID_PAYLOAD: 'Datos de Argus collector no válidos',
    NETWORK_SLA_COLLECTOR_CONFIG_DUPLICATE: 'Network SLA collector duplicado',
    NETWORK_SLA_COLLECTOR_CONFIG_WRONG_HOST: 'Host de network SLA collector no válido',
    NETWORK_SLA_COLLECTOR_CONFIG_WRONG_PORT: 'Puerto de network SLA collector no válido',
    NETWORK_SLA_COLLECTOR_CONFIG_WRONG_PROTOCOL: 'Protocolo de network SLA collector no válido',
    NETWORK_SLA_INDIVIDUAL_ONLY:
      'Solo se pueden usar objetos individuales de red o dominio como destinos SLA',
    NETWORK_SLA_SINGLE_IP_ONLY:
      'Solo se pueden usar direcciones IP individuales (/32 o /128) como destinos SLA',
    NETWORK_SLA_INVALID_PROTOCOL: 'Protocolo SLA inválido',
    NETWORK_SLA_PORT_REQUIRED: 'Se requiere un puerto para este protocolo SLA',
    NETWORK_SLA_INVALID_PORT: 'Puerto SLA inválido',
    NETWORK_SLA_INVALID_PORT_PROTOCOL: 'Puerto o protocolo SLA inválido',
    NETWORK_SLA_INVALID_PAYLOAD: 'Datos de SLA de Red no válidos',
  },
};

export default flattenObject(messages);
